(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3416,4057],{

/***/ 48033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pdp",
      function () {
        return __webpack_require__(57207);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11534:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-front.10386668.svg","height":30,"width":21});

/***/ }),

/***/ 10108:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-plan.e3ef5f8e.svg","height":30,"width":21});

/***/ }),

/***/ 3089:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-side.8db96089.svg","height":30,"width":21});

/***/ }),

/***/ 59363:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/3D-BIM.97bd8cd9.svg","height":30,"width":21});

/***/ }),

/***/ 65317:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/3D.ed0a4d74.svg","height":30,"width":20});

/***/ }),

/***/ 32873:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-down.aa284948.svg","height":11,"width":20});

/***/ }),

/***/ 97274:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-up.f1d1d9a0.svg","height":10,"width":16});

/***/ }),

/***/ 24425:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/cutout.a8f7a575.svg","height":30,"width":21});

/***/ }),

/***/ 93056:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/parts-diagram.68741125.svg","height":17,"width":14});

/***/ }),

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/warning.42d8cafb.svg","height":20,"width":20});

/***/ }),

/***/ 94057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30525);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_core_Input_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3372);
/* harmony import */ var _components_ProductDetail_v3_AddToCart_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29885);
/* harmony import */ var _components_Shared_QuickView_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30971);








const OutOfStockSection = (props)=>{
    const { outOfStockMsg , localStoreOrShowroomRef , findStoreUrl ="" , sku ="" , staticTexts ={} , productData , productInfoQV , id ="" , upshellmodal , recommendationSource  } = props;
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [emailError, setEmailError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        show: false,
        message: ""
    });
    const [showWelcome, setShowWelcome] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [enableNotify, setEnableNotify] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { outOfStock ="" , notifyEmailTxt ="" , findLocalStore ="" , toCheckAvailability ="" , emailAddress ="" , notifyMailCTA ="" , successTxt ="" , successMsg ="" , outOfStockError ="" , productAnalyticsData ={}  } = staticTexts;
    const productInfo = productData ? JSON.parse(productData.stringProductInfo).productInfo : productAnalyticsData;
    const handleEmailChange = async (val)=>{
        const inputValue = val.trim();
        setEmailError({
            show: false,
            message: ""
        });
        setEmail(inputValue);
        if (!await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .validateField */ .OP$)("email", inputValue)) {
            setEnableNotify(false);
        } else {
            setEnableNotify(true);
        }
    };
    const callBackNotify = (isSuccess)=>{
        if (isSuccess) {
            setShowWelcome(true);
            setEmail("");
            setEnableNotify(false);
            if (id === "quick-view") {
                (0,_components_Shared_QuickView_analytics__WEBPACK_IMPORTED_MODULE_7__/* .quickViewNotifyMeClickAnalytics */ ._H)({
                    productInfo: productInfoQV,
                    upshellmodal,
                    recommendationSource,
                    isSuccess
                });
            }
        } else {
            setEmailError({
                show: true,
                message: outOfStockError
            });
            if (id === "quick-view") {
                (0,_components_Shared_QuickView_analytics__WEBPACK_IMPORTED_MODULE_7__/* .quickViewNotifyMeClickAnalytics */ ._H)({
                    productInfo: productInfoQV,
                    upshellmodal,
                    recommendationSource,
                    isSuccess,
                    errorMsgQV: outOfStockError
                });
            }
        }
    };
    const handleNotification = ()=>{
        (0,_components_ProductDetail_v3_AddToCart_utils__WEBPACK_IMPORTED_MODULE_6__/* .callNotification */ .jL)({
            email,
            sku,
            callBackNotify
        });
        const eventInfo = JSON.parse((0,_components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .getAnalyticsData */ .Eb)(notifyMailCTA));
        const productInfoData = (0,_components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .getProductInfoAnalytics */ .Pt)(productData);
        (0,_components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .pushAnalyticsToDataLayer */ .Qq)(eventInfo, productInfoData);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const localStoreOrShowroomHrefElement = document.querySelector(".out-of-stock-description") && document.querySelector(".out-of-stock-description") !== null ? document.querySelector(".out-of-stock-description").querySelector("a") : "";
        if (localStoreOrShowroomHrefElement) {
            localStoreOrShowroomHrefElement.addEventListener("click", ()=>(0,_components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .addDatalayerLocalStoreHrefClick */ .t8)(null, null, productInfo));
        }
        return ()=>{
            localStoreOrShowroomHrefElement && localStoreOrShowroomHrefElement.removeEventListener("click", _components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .addDatalayerLocalStoreHrefClick */ .t8);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "out-of-stock-container",
        children: !showWelcome ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "out-of-stock",
                    children: outOfStock
                }),
                outOfStockMsg ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "out-of-stock-description",
                    ref: localStoreOrShowroomRef,
                    children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeAndDecodeHtml */ .EzU)(outOfStockMsg)
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "out-of-stock-description",
                    children: [
                        "".concat(notifyEmailTxt, " "),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: findStoreUrl,
                            children: findLocalStore
                        }),
                        " ".concat(toCheckAvailability)
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "notify-email",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "notify-email__input",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Input_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                id: id || "email",
                                ariaRequried: true,
                                type: "text",
                                maxLength: 60,
                                value: email,
                                label: emailAddress,
                                onChange: (e)=>handleEmailChange(e.target.value),
                                showError: emailError.show,
                                errorMessage: emailError.message
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "notify-btn",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                role: "button",
                                className: "gbh-data-layer",
                                "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                                label: notifyMailCTA,
                                onClick: handleNotification,
                                size: "large",
                                type: "primary",
                                flexible: true,
                                disabled: !enableNotify
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "out-of-stock__success-message",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "out-of-stock__thank-title",
                    children: successTxt
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "out-of-stock__thank-description",
                    children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeAndDecodeHtml */ .EzU)(successMsg)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (OutOfStockSection);


/***/ }),

/***/ 30534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/ProductAccordion.view.js









const Accordion = (props)=>{
    const { isOpen =false , contentOverflow =false , trigger =false , handleOpen , handleClose , containerElementProps , isArrow =false , items , itemsOrder , id , titleKey , componentPosition , componentLinkType , accordionProperties: { expandedItems =[]  } = {}  } = props;
    const [isExpanded, setisExpanded] = (0,react.useState)(true);
    const [general, setGeneral] = (0,react.useState)(null);
    const accordiumObject = (0,react.useRef)(null);
    const pageType = window.eventPageType;
    const handleAccordion = ()=>{
        setisExpanded(true);
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(function() {
            let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const CollapsibleHeader = (param)=>{
        let { title , open =false  } = param;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("h2", {
            className: "cmp-accordion__header",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "cmp-accordion__button ".concat(open ? "cmp-accordion__button--expanded" : ""),
                onClick: handleAccordion,
                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(componentPosition ? componentPosition : "accordion", '",\n        "internalLinkZoneName":"n/a","internalLinkURL":"n/a","internalLinkName":"').concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentLinkType ? componentLinkType : "navigation", '",\n        "eventType":"accordion",\n        "eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '"}'),
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "heading",
                        "aria-level": "5",
                        className: "cmp-accordion__title",
                        children: title
                    }),
                    !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-2"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "down-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default.src */.Z.src,
                                    alt: "Arrow Down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "up-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: "Arrow Up"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    const CollapsibleInnerText = (param)=>{
        let { gridColumnClassName , faqText , title  } = param;
        const finalText = (0,helper/* sanitizeInnerHtml */.KD0)((0,helper/* getShortenedUrlwithGeneral */.vu1)(faqText, general));
        const addFaqSeoScript = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: itemsOrder.map((item, i)=>({
                    "@type": "Question",
                    name: items[item]["cq:panelTitle"],
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: items[item]["text"]
                    }
                }))
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "faq-script",
                    type: "application/ld+json",
                    children: JSON.stringify(addFaqSeoScript)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-accordian-title": title,
                    className: "cmp-accordion__panel".concat(isExpanded ? " cmp-accordion__panel--expanded" : " cmp-accordion__panel--hidden"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text ".concat(gridColumnClassName),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-text",
                            children: finalText
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: accordiumObject,
        className: "cmp-accordion",
        "data-placeholder-text": "false",
        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((item, i)=>{
            const title = items[item][titleKey];
            let gridColumnClassName = items[item]["appliedCssClassNames"];
            let faqText = items[item]["text"];
            if (!faqText) {
                faqText = "";
                const itemsOrderArr = items[item][":itemsOrder"];
                if (itemsOrderArr) {
                    itemsOrderArr.forEach((itemTx)=>{
                        faqText = "".concat(faqText).concat(items[item][":items"][itemTx]["text"]);
                        gridColumnClassName = "".concat(items[item][":items"][itemTx]["appliedCssClassNames"]);
                    });
                }
            }
            var ref;
            const isItemExpanded = (ref = expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems.includes(item)) !== null && ref !== void 0 ? ref : isOpen;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cmp-hook-accordion": "item",
                    className: "cmp-accordion__item",
                    id: "accordion-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()),
                    "data-cmp-data-layer": '{"accordion-'.concat(i, "-").concat((0,helper/* getRandom */.sZz)(), '":{"@type":"kohler-us/components/accordion/item","dc:title":"').concat(title, '"}}'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        open: isItemExpanded,
                        onTriggerOpening: handleOpen,
                        onTriggerClosing: handleClose,
                        containerElementProps: containerElementProps,
                        overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                        openedClassName: "collapsible--open",
                        tabIndex: "0",
                        triggerOpenedClassName: "collapsible__trigger--open",
                        trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title
                        }),
                        triggerWhenOpen: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title,
                            open: true
                        }),
                        transitionTime: 400,
                        easing: "ease-in-out",
                        triggerElementProps: {
                            id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                        },
                        contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleInnerText, {
                            gridColumnClassName: gridColumnClassName,
                            faqText: faqText,
                            title: title
                        })
                    })
                })
            }, "accordion-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
        })
    });
};
/* harmony default export */ var ProductAccordion_view = (Accordion);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx


const ProductAccordion = (props)=>{
    const { data: { accordionProperties ={} , componentLinkType =""  }  } = props;
    const { [":itemsOrder"]: itemsOrder , [":items"]: items , id  } = accordionProperties;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "accordion  ".concat(accordionProperties === null || accordionProperties === void 0 ? void 0 : accordionProperties.appliedCssClassNames, " productAccordionView"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion_view, {
            accordionProperties: accordionProperties,
            componentLinkType: componentLinkType,
            items: items,
            itemsOrder: itemsOrder,
            id: id,
            textKey: "text",
            titleKey: "cq:panelTitle"
        })
    });
};
/* harmony default export */ var v3_ProductAccordion = (ProductAccordion);


/***/ }),

/***/ 4464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getDimensionData; }
/* harmony export */ });
const getDimensionData = (dimensionData)=>{
    if (Object.keys(dimensionData).length) {
        const { ProductDimensionAttributes =[] , ProductDimensionAttributesValues =[]  } = dimensionData;
        var ref;
        const { Specification ="[]" , Dimension ="[]" , enable: enabled = false  } = (ref = ProductDimensionAttributes[0]) !== null && ref !== void 0 ? ref : {};
        const specification = JSON.parse(Specification);
        const dimension = JSON.parse(Dimension);
        const processedData = {
            enabled,
            dimensions: dimension.map((d, idx)=>{
                return {
                    key: idx + 1,
                    label: d.label,
                    value: ProductDimensionAttributesValues[0][[
                        d.pimAttribute
                    ]],
                    tooltip: d.tooltip,
                    unit: d.unit
                };
            }),
            specifications: specification.length && specification[0].label.length ? specification.map((s, idx)=>{
                var ref;
                return {
                    key: idx + 1,
                    label: s.label,
                    value: ProductDimensionAttributesValues[0][[
                        s.pimAttribute
                    ]],
                    tooltip: s.tooltip,
                    unit: (ref = s === null || s === void 0 ? void 0 : s.unit) !== null && ref !== void 0 ? ref : ""
                };
            }) : []
        };
        return processedData;
    }
    return {};
};


/***/ }),

/***/ 65670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53683);




const ListPrice = (props)=>{
    const { listPrice =0 , staticTexts: { listPriceInfo ="" , refPrice ="" , listPrice: listPriceText = ""  } = {} , currencySign ="" , priceTooltip =false , setPriceTooltip =()=>{} , handleSetPriceTooltip =()=>{}  } = props;
    const handleKeyDown = (e)=>{
        if (e.keyCode === 27) {
            setPriceTooltip(false);
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "product-detail-page__list-view",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-detail-page__list-value",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
                    value: listPrice,
                    displayType: "text",
                    thousandSeparator: true,
                    prefix: currencySign,
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    tabIndex: "0",
                    "aria-label": "".concat(listPriceText, " ").concat(currencySign).concat(listPrice)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "product-detail-page__list-text",
                onMouseOver: ()=>handleSetPriceTooltip("list info mouseover", true),
                onMouseLeave: ()=>setPriceTooltip(false),
                tabIndex: "0",
                "aria-describedby": "price-list-info-tooltip",
                onFocus: ()=>handleSetPriceTooltip("list info focus", true),
                onBlur: ()=>setPriceTooltip(false),
                onKeyDown: handleKeyDown,
                children: [
                    " ",
                    refPrice,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-detail-page__list-tooltip".concat(priceTooltip ? "--show" : "--hide"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-detail-page__list-tooltip-wrapper",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                id: "price-list-info-tooltip",
                                message: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeAndDecodeHtml */ .EzU)(listPriceInfo)
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ListPrice);


/***/ }),

/***/ 25762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46201);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(52102);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11873);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73962);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11859);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20558);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85518);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55760);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19514);
/* harmony import */ var _components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9670);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44561);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9473);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71025);
/* harmony import */ var _utils_addTocart__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27522);
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20338);
/* harmony import */ var _components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4364);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(51666);






















const PDPCuratedProducts = (props)=>{
    const { authData ={} , quickViewAuthData ={} , openQuickViewModal =()=>{}  } = props || {};
    const { presetConfigs ={} , recommendationTitle ="" , selectedTitle ="" , swatchUrl: baseUrl = "" , mainTitle ="" , productTitle =""  } = authData;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_15__/* .useDispatch */ .I0)();
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const { pdp: { sku: updatedSku = "" , slug: updatedSlug  } = {} , pdp: PdpInfo = {}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_15__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectPdpState */ .BY);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getUserPersona */ .shu)();
    const rowCols = (0,_utils_index__WEBPACK_IMPORTED_MODULE_8__/* .getRowCols */ .n)(width, react_device_detect__WEBPACK_IMPORTED_MODULE_9__/* .isMobile */ .tq, react_device_detect__WEBPACK_IMPORTED_MODULE_9__/* .isTablet */ .Em);
    const [parentProductData, setParentProductData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [requiredItemsProductData, setRequiredItemsProductData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [includedItems, setIncludedItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [addToCartLoader, setAddToCartLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [recommendationSource, setRecommendationSource] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("n/a");
    const [criteriaTitle, setCriteriaTitle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const parsedPresetConfigs = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(presetConfigs) ? JSON.parse(presetConfigs) : {};
    const handleScroll = ()=>{
        var ref;
        const scrollpostion = (ref = document.querySelector(".pdp-curated-recommendation")) === null || ref === void 0 ? void 0 : ref.offsetTop;
        const yscrollposition = window.scrollY;
        if (yscrollposition >= scrollpostion - 300) {
            if (!window.isUpsellAnalaticsLoaded) {
                const productDataForAnalytics = anylticsPdpData();
                if (recommendationSource !== "n/a") {
                    (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addAnalyticsPDPWhenUpSellVisible */ .AD)({
                        recommendation: recommendationTitle,
                        productDataForAnalytics,
                        persona,
                        recommendationSource
                    });
                    window.isUpsellAnalaticsLoaded = true;
                }
            }
        }
    };
    const onScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        handleScroll();
    }, [
        parentProductData,
        requiredItemsProductData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.addEventListener("scroll", onScroll);
        return ()=>{
            document.removeEventListener("scroll", onScroll);
        };
    }, [
        onScroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.isUpsellAnalaticsLoaded = false;
        if (updatedSku && updatedSlug) {
            executeInitialCalls();
        }
    }, [
        updatedSku,
        updatedSlug
    ]);
    const anylticsPdpData = ()=>{
        var ref, ref1, ref2;
        var _data;
        const parentProductDataInfo = (_data = PdpInfo.data) !== null && _data !== void 0 ? _data : [];
        const { ["Color.SKU.Details_ss"]: colors = []  } = parentProductDataInfo;
        let matchedColor = [];
        if (colors.length) {
            matchedColor = colors.filter((colorItem)=>{
                const colorSplit = colorItem.split("|");
                const itemLen = colorSplit.length;
                return colorSplit[itemLen - 1].substring(2, colorSplit[itemLen - 1].length) === PdpInfo.sku;
            });
        }
        const parentProductDataAll = {
            desc: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductDescriptionProductShort_s,
            category: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductLocalCategory_s,
            image: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.productImageUrl,
            unitPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
            productPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
            customerFacingSKU: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.customerFacingSKU,
            productTileName: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
            quantity: 1,
            name: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
            color: matchedColor ? (ref = matchedColor[0]) === null || ref === void 0 ? void 0 : ref.split("|")[0] : "",
            parentglobalPromotionPrice: (ref1 = PdpInfo.data) === null || ref1 === void 0 ? void 0 : ref1["priceList.".concat(persona, ".finalPrice_d")],
            ["priceList.".concat(persona, ".discountedPrice_d")]: (ref2 = PdpInfo.data) === null || ref2 === void 0 ? void 0 : ref2["priceList.".concat(persona, ".finalPrice_d")],
            itemType: "product",
            productRoomType: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.category1_s
        };
        const productDataForAnlytics = {
            parentProductDataAll,
            requiredItemsProductData
        };
        return productDataForAnlytics !== null && productDataForAnlytics !== void 0 ? productDataForAnlytics : {};
    };
    const executeInitialCalls = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_11__/* .getConfig */ .i)();
        const { general: { siteName ="" , lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
        var ref1;
        const { data: { response: { docs: requiredItemsSku = []  } = {}  } = {}  } = (ref1 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getListOfRequiredSkus */ .Q3)(persona, updatedSlug, updatedSku, lwAppName)) !== null && ref1 !== void 0 ? ref1 : {};
        dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__/* .setRequiredItemsSkuData */ .vM)({
            data: requiredItemsSku
        }));
        if (!requiredItemsSku.length) {
            setRequiredItemsProductData([]);
            setLoading(false);
            return;
        }
        var ref2;
        const { data: { results: parentProductInventory = []  } = {}  } = (ref2 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getProductInventory */ .o)(updatedSku)) !== null && ref2 !== void 0 ? ref2 : {};
        const parentProductQuantity = parentProductInventory.length ? (ref = parentProductInventory[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
        var ref3;
        const { CrossSellRecommendationSKUList_ss: requiredSkuList = [] , sku_s: sku = "" , ProductBrandName_s: productBrandName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["productImages.labelWithUrl_ss"]: labledImages  } = (ref3 = requiredItemsSku[0]) !== null && ref3 !== void 0 ? ref3 : {};
        if (!requiredSkuList.length) {
            var ref4;
            const { apiEndPointData: { map: { targetEnvironmentId: environmentId = "" , targetPropertyId: propertyToken = "" , targetMbox: mboxName = ""  }  } = {}  } = config !== null && config !== void 0 ? config : {};
            var ref5;
            const payload = {
                id: {
                    tntId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_20__/* .getTntId */ .xE)()
                },
                environmentId: environmentId,
                context: {
                    channel: "web",
                    address: {
                        url: (ref5 = window === null || window === void 0 ? void 0 : (ref4 = window.location) === null || ref4 === void 0 ? void 0 : ref4.href) !== null && ref5 !== void 0 ? ref5 : ""
                    }
                },
                property: {
                    token: propertyToken
                },
                execute: {
                    mboxes: [
                        {
                            index: 1,
                            name: mboxName,
                            product: {
                                id: "K-" + updatedSku
                            }
                        }
                    ]
                }
            };
            try {
                var ref6;
                const { options: [content] = []  } = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getListOfRequiredAdobeTargetSkus */ .U1)(payload);
                const { content: data = {}  } = content;
                const { adobeRecommendations: { recommendedItems ="" , activityDetails ={}  } = {}  } = JSON.parse(data);
                setCriteriaTitle(activityDetails["criteria.title"]);
                (ref6 = recommendedItems === null || recommendedItems === void 0 ? void 0 : recommendedItems.split(",")) === null || ref6 === void 0 ? void 0 : ref6.map((item)=>{
                    if (item !== "") {
                        requiredSkuList.push(item.replace("K-", ""));
                    }
                });
                if (!requiredSkuList.length) {
                    setRequiredItemsProductData([]);
                    setLoading(false);
                    return;
                } else {
                    setRecommendationSource("target");
                }
            } catch (e) {
                setRequiredItemsProductData([]);
                setLoading(false);
                return;
            }
        } else {
            setRecommendationSource("pim");
        }
        let imgId = "";
        if (labledImages.length) {
            var ref7, ref8;
            const index = labledImages.map((item)=>{
                var ref;
                return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
            }).indexOf(updatedSku);
            const assetId = ((ref8 = (ref7 = labledImages[index]) === null || ref7 === void 0 ? void 0 : ref7.split("|")) === null || ref8 === void 0 ? void 0 : ref8.length) ? labledImages[index].split("|")[1] : "";
            imgId = assetId;
        }
        const productImageUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_8__/* .getPresetUrl */ .v$)(width, rowCols, baseUrl, imgId, parsedPresetConfigs);
        setParentProductData({
            customerFacingSKU: sku,
            name: productBrandName,
            unitPrice: productPrice,
            availableQuantity: parentProductQuantity,
            productImageUrl
        });
        setBrandName(siteName);
        if (requiredSkuList.length) {
            var ref9;
            const { data: { results: productInventory = []  } = {}  } = (ref9 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getProductInventory */ .o)(requiredSkuList.join(","))) !== null && ref9 !== void 0 ? ref9 : {};
            var ref10;
            const { data: data1 = {}  } = (ref10 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getProductDataFromSkuIds */ .fh)(persona, requiredSkuList, lwAppName)) !== null && ref10 !== void 0 ? ref10 : {};
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(data1)) {
                const { response: { docs: requiredSkusProductData = []  } = {}  } = data1;
                const requiredItemsProductData = [];
                if (requiredSkusProductData.length) {
                    requiredSkusProductData.forEach((item)=>{
                        var ref;
                        var ref1;
                        const inventoryObj = (ref1 = productInventory.find((inventoryItem)=>item.sku_s === inventoryItem.sku)) !== null && ref1 !== void 0 ? ref1 : {};
                        var ref2;
                        const colors = (ref2 = item["Color.SKU.Details_ss"]) !== null && ref2 !== void 0 ? ref2 : [];
                        let matchedColor = [];
                        if (colors.length) {
                            matchedColor = colors.filter((colorItem)=>{
                                const colorSplit = colorItem.split("|");
                                const itemLen = colorSplit.length;
                                return colorSplit[itemLen - 1].substring(2, colorSplit[itemLen - 1].length) === item.sku_s;
                            });
                        }
                        var ref3;
                        requiredItemsProductData.push({
                            availableQuantity: (ref3 = inventoryObj === null || inventoryObj === void 0 ? void 0 : inventoryObj.availableQuantity) !== null && ref3 !== void 0 ? ref3 : 0,
                            productColor: matchedColor ? (ref = matchedColor[0]) === null || ref === void 0 ? void 0 : ref.split("|")[0] : "",
                            ...item
                        });
                    });
                    setLoading(false);
                    makeDefaultSelection(requiredItemsProductData, requiredItemsSku[0], parentProductQuantity);
                    setRequiredItemsProductData(requiredItemsProductData);
                }
            }
        }
    };
    const getSubTotal = function() {
        let requiredItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", qty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        return requiredItems.reduce((n, param)=>{
            let { ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , sku_s: sku = "" , availableQuantity =0  } = param;
            var ref;
            let quantity = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(availableParentSku) ? (ref = availableParentSku.includedItems[sku]) === null || ref === void 0 ? void 0 : ref.quantity : 1;
            skuId && sku === skuId ? quantity = qty : quantity;
            const price = availableQuantity ? discountedPrice || productPrice : 0;
            return n + price * quantity;
        }, 0);
    };
    const makeDefaultSelection = function() {
        let productData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], masterSkuData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, parentProductQuantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        const includedRequiredItems = {};
        const { ["priceList.".concat(persona, ".finalPrice_d")]: productFinalPrice = 0  } = masterSkuData;
        const productPrice = parentProductQuantity > 0 ? productFinalPrice : 0;
        includedRequiredItems[updatedSku] = {
            subTotal: getSubTotal(productData, updatedSku) + productPrice,
            includedItems: {
                ...productData.reduce((obj, cur)=>({
                        ...obj,
                        [cur.sku_s]: {
                            check: cur.availableQuantity > 0,
                            quantity: 1,
                            availableQuantity: cur.availableQuantity
                        }
                    }), {})
            },
            check: parentProductQuantity > 0
        };
        setIncludedItems(includedRequiredItems);
    };
    const curatedRecommendationTitle = criteriaTitle || mainTitle;
    const checkChangeHandlerForParentProduct = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        var ref, ref, ref;
        const { unitPrice =0  } = parentProductData;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        availableParentSku.check = checked;
        const operand = checked ? "+" : "-";
        const { subTotal =0  } = availableParentSku;
        availableParentSku.subTotal = eval(subTotal + operand + unitPrice);
        setIncludedItems(addedItems);
        const parentProductDataInfo = PdpInfo.data;
        const parentProductDataAll = {
            ProductDescriptionProductShort_s: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductDescriptionProductShort_s,
            Product_Category: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductLocalCategory_s,
            image: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.productImageUrl,
            unitPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
            customerFacingSKU: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.customerFacingSKU,
            productTileName: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
            ["priceList.".concat(persona, ".finalPrice_d")]: (ref = PdpInfo.data) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".finalPrice_d")],
            ["priceList.".concat(persona, ".discountedPrice_d")]: (ref = PdpInfo.data) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".discountedPrice_d")],
            parentglobalPromotionPrice: (ref = PdpInfo.data) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".finalPrice_d")],
            CustomerFacingBrand_s: parentProductDataInfo.CustomerFacingBrand_s,
            RegionBrandName_s: parentProductDataInfo.RegionBrandName_s,
            availableQuantity: 1,
            qty: 1,
            sku_s: parentProductData.customerFacingSKU,
            productParentImage: parentProductData.productImageUrl,
            itemType: "product",
            productRoomType: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.category1_s
        };
        const includeTitle = (authData === null || authData === void 0 ? void 0 : authData.includeTitle) || curatedRecommendationTitle;
        const itemLength = requiredItemsProductData.length > 0 ? requiredItemsProductData.length - 1 : "-1";
        const isParent = true;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addAnalyticsForIncludeforRequiredItem */ .bP)({
            checked,
            included: includeTitle,
            recommendationTitle,
            installServiceData: parentProductDataAll,
            index: 1,
            childindex: itemLength,
            persona,
            isParent,
            recommendationSource
        });
    };
    const checkChangeHandlerForReqItems = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(availableParentSku)) {
            availableParentSku.includedItems[skuId].check = checked;
            const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                var ref;
                return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
            });
            const requiredFilteredItems = requiredItemsProductData.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
            const { unitPrice =0  } = parentProductData;
            const productPrice = availableParentSku.check ? unitPrice : 0;
            const subTotal = getSubTotal(requiredFilteredItems, parentSku);
            availableParentSku.subTotal = subTotal + productPrice;
            setIncludedItems(addedItems);
        }
    };
    const addSelectedItems = async (subTotal)=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(includedItems)) {
            setAddToCartLoader(true);
            const addedItems = {
                ...includedItems
            };
            const availableParentSku = addedItems[updatedSku];
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(availableParentSku)) {
                const requiredItems = availableParentSku.includedItems;
                const selectedItems = Object.keys(requiredItems).filter((key)=>requiredItems[key].check).map((item)=>{
                    var ref;
                    return {
                        sku: item,
                        quantity: (ref = requiredItems[item]) === null || ref === void 0 ? void 0 : ref.quantity
                    };
                });
                if (availableParentSku.check) {
                    var ref, ref1;
                    const itemsProjectionApiResponse = await (0,_components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_19__/* .getProductsBySku */ .uX)([
                        updatedSku
                    ]);
                    var ref2;
                    const variants = (ref2 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref = itemsProjectionApiResponse[0]) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref2 !== void 0 ? ref2 : [];
                    var ref3;
                    variants.push((ref3 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref1 = itemsProjectionApiResponse[0]) === null || ref1 === void 0 ? void 0 : ref1.masterVariant) !== null && ref3 !== void 0 ? ref3 : {});
                    let isComboSku = false;
                    for(let i = 0; i < variants.length; i++){
                        if (updatedSku === variants[i].sku) {
                            var ref4;
                            isComboSku = ((ref4 = variants[i]) === null || ref4 === void 0 ? void 0 : ref4.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
                        }
                    }
                    selectedItems.push({
                        sku: updatedSku,
                        quantity: 1,
                        isBundle: isComboSku
                    });
                }
                if (selectedItems.length) {
                    const allSelectedItems = selectedItems.map((item)=>({
                            ...item,
                            brand: brandName
                        }));
                    addItemsToCart(allSelectedItems);
                    if (allSelectedItems.length) {
                        let selectedIncludePdpData = [];
                        let parentProductDataAll = [];
                        const parentProduct = allSelectedItems.filter((item)=>{
                            return item.sku === PdpInfo.sku;
                        });
                        if (parentProduct.length) {
                            var ref5;
                            var _data;
                            const parentProductDataInfo = (_data = PdpInfo.data) !== null && _data !== void 0 ? _data : [];
                            const { ["Color.SKU.Details_ss"]: colors = []  } = parentProductDataInfo;
                            let matchedColor = [];
                            if (colors.length) {
                                matchedColor = colors.filter((colorItem)=>{
                                    const colorSplit = colorItem.split("|");
                                    const itemLen = colorSplit.length;
                                    return colorSplit[itemLen - 1].substring(2, colorSplit[itemLen - 1].length) === PdpInfo.sku;
                                });
                            }
                            parentProductDataAll = {
                                desc: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductDescriptionProductShort_s,
                                category: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductLocalCategory_s,
                                image: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.productImageUrl,
                                unitPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
                                customerFacingSKU: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.customerFacingSKU,
                                productTileName: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
                                quantity: 1,
                                name: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
                                color: matchedColor ? (ref5 = matchedColor[0]) === null || ref5 === void 0 ? void 0 : ref5.split("|")[0] : ""
                            };
                        }
                        const childRecommendationProduct = allSelectedItems === null || allSelectedItems === void 0 ? void 0 : allSelectedItems.filter((item)=>item.sku !== PdpInfo.sku);
                        selectedIncludePdpData = childRecommendationProduct === null || childRecommendationProduct === void 0 ? void 0 : childRecommendationProduct.map((childItem)=>{
                            let foundIndex = -1;
                            var ref;
                            const item = (ref = requiredItemsProductData.find((requiredItem, index)=>{
                                foundIndex = index;
                                return requiredItem.sku_s === childItem.sku;
                            })) !== null && ref !== void 0 ? ref : {};
                            return {
                                ...item,
                                foundIndex
                            };
                        });
                        selectedIncludePdpData.sort((a, b)=>Number(a.foundIndex) - Number(b.foundIndex));
                        const productDataForAnlytics = {
                            parentProductDataAll,
                            selectedIncludePdpData
                        };
                        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addAnalyticsForPdpAddToCart */ .P7)(subTotal, productDataForAnlytics, persona, recommendationSource);
                    }
                }
            }
        }
    };
    const addItemsToCart = async (items)=>{
        const payload = await (0,_utils_addTocart__WEBPACK_IMPORTED_MODULE_17__/* .addToCartItem */ .q)([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showPreviewCart */ .z0)());
            setAddToCartLoader(false);
            handleAddtoCartResponse(res);
        });
    };
    const handleAddtoCartResponse = (param)=>{
        let { payload  } = param;
        if (payload) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(payload));
        }
    };
    const getSelectedItemNum = function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { includedItems ={} , check =false  } = item;
        let num = 0;
        for(const key in includedItems){
            if (Object.prototype.hasOwnProperty.call(includedItems, key)) {
                var ref;
                if ((ref = includedItems[key]) === null || ref === void 0 ? void 0 : ref.check) num += 1;
            }
        }
        if (check) num = num + 1;
        return num;
    };
    if (!loading && requiredItemsProductData.length) {
        var ref;
        const subTotal = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(includedItems) ? (ref = includedItems[updatedSku]) === null || ref === void 0 ? void 0 : ref.subTotal : 0;
        const selectedIncludesNum = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(includedItems) ? getSelectedItemNum(includedItems[updatedSku]) : 0;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_21___default().pdpcuratedproductmodule),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pdp-curated-recommendation",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pdp-curated-recommendation__title",
                        children: curatedRecommendationTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pdp-curated-recommendation__conatiner",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                containerClassName: "-pdp-required-item",
                                checkChangeHandlerForParentProduct: checkChangeHandlerForParentProduct,
                                includedItems: includedItems,
                                productTitleUpSell: productTitle,
                                ...parentProductData,
                                ...authData
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "right-side-conatiner",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "header",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "title",
                                                children: recommendationTitle
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "button-total",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "total",
                                                        children: subTotal > 0 && subTotal !== "0.00" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                            price: subTotal
                                                        }) : null
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "add-to-cart-button",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            role: "button",
                                                            label: "Add to Cart (".concat(selectedIncludesNum, ")"),
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true,
                                                            disabled: !subTotal || subTotal === "0.00",
                                                            loading: addToCartLoader,
                                                            onClick: ()=>addSelectedItems(subTotal)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pdp-required-modal-right-side",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pdp-required-modal-container-list ".concat(requiredItemsProductData.length <= 1 ? "required-item-single" : ""),
                                            children: requiredItemsProductData.map((item, upSellDataIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        dynamicClass: "-pdp",
                                                        requiredProductItem: item,
                                                        persona: persona,
                                                        showQtyInput: false,
                                                        includedItems: includedItems,
                                                        parentSku: updatedSku,
                                                        updateRequiredItems: checkChangeHandlerForReqItems,
                                                        baseUrl: baseUrl,
                                                        parsedConfigs: parsedPresetConfigs,
                                                        upSellDataIndex: "0",
                                                        recommendationSource: recommendationSource,
                                                        index: upSellDataIndex,
                                                        ...authData,
                                                        productData: item,
                                                        quickViewAuthData: quickViewAuthData,
                                                        openQuickViewModal: openQuickViewModal,
                                                        isPdp: true
                                                    })
                                                }, item.sku_s))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "subtotal-add-to-cart--mobile",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "number-total-mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "selected-mobile",
                                        children: [
                                            selectedTitle,
                                            " (",
                                            selectedIncludesNum,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "total-price",
                                        children: subTotal > 0 && subTotal !== "0.00" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            price: subTotal
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "add-to-cart-",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    role: "button",
                                    label: "Add to Cart",
                                    size: "large",
                                    type: "primary",
                                    flexible: true,
                                    loading: addToCartLoader,
                                    disabled: !subTotal || subTotal === "0.00",
                                    onClick: ()=>addSelectedItems(subTotal)
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PDPCuratedProducts);


/***/ }),

/***/ 2797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ addAnalyticsProductNameDisplayClick; },
/* harmony export */   "Dx": function() { return /* binding */ addAnalyticsClickChangeZipSubmit; },
/* harmony export */   "P6": function() { return /* binding */ addAnalyticsStoreNumberClick; },
/* harmony export */   "XZ": function() { return /* binding */ addAnalyticsBrowseStoreNotFound; },
/* harmony export */   "gU": function() { return /* binding */ addAnalyticsCloseSliderProductOnDisplay; },
/* harmony export */   "jr": function() { return /* binding */ addAnalyticsBrowseAllStoreClick; },
/* harmony export */   "xb": function() { return /* binding */ addAnalyticsClickStoreNear; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);

const addAnalyticsClickStoreNear = (data)=>{
    const { productDisplayTitle ="" , sectionHeadingProductNotAvailable =""  } = data;
    const eventInfo = {
        eventAction: "pdp:cross-sell:".concat(sectionHeadingProductNotAvailable),
        eventName: "pdp:cross-sell:".concat(sectionHeadingProductNotAvailable),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: sectionHeadingProductNotAvailable,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(productDisplayTitle),
        internalLinkZoneName: "pdp:cross-sell:".concat(productDisplayTitle),
        internalLinkURL: window.location.href,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickChangeZipSubmit = (data)=>{
    const { zipCode ="n/a" , eventZipStatus ="n/a" , eventZipCodeAction ="n/a" , submitLabel ="n/a" , eventMessageLabel ="n/a"  } = data;
    const eventInfo = {
        eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY, ":").concat(eventZipCodeAction),
        eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY, ":").concat(eventZipCodeAction),
        eventType: "navigation",
        eventMsg: eventMessageLabel,
        eventStatus: eventZipStatus || "n/a",
        internalLinkName: (submitLabel === null || submitLabel === void 0 ? void 0 : submitLabel.toLowerCase()) || "n/a",
        internalLinkPosition: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY, ":").concat(eventZipCodeAction),
        internalLinkType: "pdp".concat(zipCode ? ":".concat(zipCode) : ""),
        internalLinkZoneName: _constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY,
        internalLinkURL: window.location.href,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsBrowseStoreNotFound = (data)=>{
    const { nonAvailableLabel ="n/a" , browseAllLabel ="n/a" , zipCode ="n/a" , submitLabel ="n/a"  } = data;
    const eventInfo = {
        eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY, ":").concat(browseAllLabel, " not found"),
        eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY, ":").concat(browseAllLabel, " not found"),
        eventType: "navigation",
        eventMsg: nonAvailableLabel,
        eventStatus: "failure",
        internalLinkName: (submitLabel === null || submitLabel === void 0 ? void 0 : submitLabel.toLowerCase()) || "n/a",
        internalLinkPosition: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY, ":").concat(browseAllLabel, " not found"),
        internalLinkType: "pdp:".concat(zipCode),
        internalLinkZoneName: _constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FIND_ON_DISPLAY,
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsProductNameDisplayClick = (data)=>{
    const { locationName ="n/a" , locality ="n/a" , adminDistrict ="" , url =""  } = data;
    const eventInfo = {
        eventAction: "pdp:find on display:browse all stores:store name",
        eventName: "pdp:find on display:browse all stores:store name",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: locationName,
        internalLinkPosition: "pdp:find on display:".concat(locationName),
        internalLinkType: "pdp:find on display".concat(locality ? ":".concat(locality) : "").concat(adminDistrict ? ":".concat(adminDistrict) : ""),
        internalLinkZoneName: "pdp:find on display:browse all stores",
        internalLinkURL: window.location.origin + url,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsStoreNumberClick = (data)=>{
    const { locationName ="n/a" , locality ="n/a" , adminDistrict ="" , url ="" , contactNumber =""  } = data;
    const eventInfo = {
        eventAction: "pdp:find on display:browse all stores:store name",
        eventName: "pdp:find on display:browse all stores:store name",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "call us:".concat(contactNumber),
        internalLinkPosition: "pdp:find on display:".concat(locationName),
        internalLinkType: "pdp:find on display".concat(locality ? ":".concat(locality) : "").concat(adminDistrict ? ":".concat(adminDistrict) : ""),
        internalLinkZoneName: "pdp:find on display:browse all stores",
        internalLinkURL: window.location.origin + url,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsBrowseAllStoreClick = (data)=>{
    const { browseAllLabel ="n/a" , browseAllStoreUrl ="n/a"  } = data;
    const eventInfo = {
        eventAction: "pdp:find on display:".concat(browseAllLabel),
        eventName: "pdp:find on display:".concat(browseAllLabel),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: browseAllLabel,
        internalLinkPosition: "pdp:find on display:".concat(browseAllLabel),
        internalLinkType: "pdp:find on display",
        internalLinkZoneName: "pdp:find on display:".concat(browseAllLabel),
        internalLinkURL: window.location.origin + browseAllStoreUrl,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsCloseSliderProductOnDisplay = (data)=>{
    const eventInfo = {
        eventAction: "pdp:find on display:close",
        eventName: "pdp:find on display:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "pdp:find on display:close",
        internalLinkType: "pdp:find on display",
        internalLinkZoneName: "pdp:find on display",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    const { productInfo  } = page;
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 14899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pq": function() { return /* binding */ handleAddToCart; },
/* harmony export */   "YI": function() { return /* binding */ installserviceClickHandler; },
/* harmony export */   "ZL": function() { return /* binding */ titleclickhandler; },
/* harmony export */   "eS": function() { return /* binding */ fetchProductsOnDisplayStores; },
/* harmony export */   "gf": function() { return /* binding */ getStoreUrl; },
/* harmony export */   "pi": function() { return /* binding */ getProsessionalClickHandler; },
/* harmony export */   "zP": function() { return /* binding */ servicesClick; }
/* harmony export */ });
/* harmony import */ var _utils_addTocart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27522);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _components_FindStore_v1_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2182);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_analytics_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85660);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88751);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85518);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88032);







const getStoreUrl = (data)=>{
    const { findStoreUtilityDetails , shortendPagePath , bpNumber  } = data;
    const bpNumberProcessed = findStoreUtilityDetails[bpNumber];
    const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
    const htmlRegExp = new RegExp(".html", "g");
    const htmlRemovedUrl = "".concat(bpNumberProcessed === null || bpNumberProcessed === void 0 ? void 0 : bpNumberProcessed.replace(htmlRegExp, ""));
    const shortUrlRegEx = new RegExp(shortUrl, "g");
    return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
};
const servicesClick = (e, productInfo)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    (0,_components_ProductDetail_v3_ProductDetailView_analytics_analytics__WEBPACK_IMPORTED_MODULE_3__/* .addAnalyticsForBuymore */ .G5)(textContent, href, productInfo);
    window.open(href);
};
const titleclickhandler = (e, productInfo)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    (0,_components_ProductDetail_v3_ProductDetailView_analytics_analytics__WEBPACK_IMPORTED_MODULE_3__/* .addAnalyticsForBuymore */ .G5)(textContent, href, productInfo);
    window.open(href);
};
const installserviceClickHandler = (e, productInfo)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    (0,_components_ProductDetail_v3_ProductDetailView_analytics_analytics__WEBPACK_IMPORTED_MODULE_3__/* .addAnalyticsForBathroomDesign */ .Zy)(textContent.toLowerCase(), href, productInfo);
};
const getProsessionalClickHandler = (e, productInfo)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    (0,_components_ProductDetail_v3_ProductDetailView_analytics_analytics__WEBPACK_IMPORTED_MODULE_3__/* .addAnalyticsForGetProfessionalClick */ .Mi)(textContent, href, productInfo);
};
const handleAddToCart = (data)=>{
    const { e , productServices , zipCodeInputVal , brandName  } = data;
    e.preventDefault();
    if (!productServices.length) return;
    const item = {
        sku: productServices[0],
        quantity: 1,
        userZipCode: zipCodeInputVal,
        brand: brandName
    };
    const { quantity  } = item;
    const itemCountMessage = "".concat(quantity, " ");
    const ToasterMsg = "".concat(itemCountMessage);
    (0,_utils_addTocart__WEBPACK_IMPORTED_MODULE_0__/* .addToCartItem */ .q)([
        {
            ...item,
            isBundle: false,
            backorder: false
        }
    ]).then((response)=>{
        const body = {
            actions: response
        };
        _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
            if (res) {
                if (react_device_detect__WEBPACK_IMPORTED_MODULE_5__/* .isMobile */ .tq) {
                    _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__/* .showToast */ .CF)({
                        message: ToasterMsg,
                        isVisible: true
                    }));
                } else {
                    _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__/* .showPreviewCart */ .z0)());
                }
            }
        });
    });
};
const fetchProductsOnDisplayStores = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { colorsData =[] , findStoresUrl ="" , zipCode , brandName  } = data;
    var ref;
    const skus = (ref = colorsData.map((item)=>item.id)) !== null && ref !== void 0 ? ref : [];
    const { data: { info =[]  } = {}  } = await (0,_components_FindStore_v1_api__WEBPACK_IMPORTED_MODULE_2__/* .getFindAStoresResult */ .R)(findStoresUrl, zipCode, brandName, null, 3, "", null, skus.join(","));
    return info;
};


/***/ }),

/***/ 63426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_core_ColorSwatch_ColorSwatch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32982);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21328);




const SwatchList = (props)=>{
    const { colorsData: colorsDataList = [] , isDiscontinued =false , sku ="" , staticTexts: { discontinuedColorFinish ="" , colorOrFinish =""  } = {} , setSkuVariant =()=>{} , selectedColor =""  } = props;
    const colorsData = (0,_components_ProductDetail_v3_ProductDetailView_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFirstSkuColor */ .ku)(colorsDataList);
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_2__["default"];
        const ele = e.target.parentNode.childNodes;
        switch(e.keyCode){
            case KEYCODE.UP:
                e.preventDefault();
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                e.preventDefault();
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
            case KEYCODE.ENTER:
                e.preventDefault();
                ele[i].querySelector("input").click();
                break;
            default:
                break;
        }
    };
    const selectedColorName = (0,_components_ProductDetail_v3_ProductDetailView_utils__WEBPACK_IMPORTED_MODULE_3__/* .getSelectedColor */ .VQ)(colorsData, sku);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            colorsData.filter((c)=>!c.notApplicable).length > 0 ? isDiscontinued ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row no-gutters product-detail-page__finish-sample",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-detail-page__discontinued",
                    tabIndex: "0",
                    "aria-roledescription": "Finish Type ".concat(selectedColorName, " selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "discontinued-text",
                            children: discontinuedColorFinish
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "discontinued-color-value",
                            children: selectedColorName
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row no-gutters product-detail-page__finish-sample",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-detail-page__finish",
                    tabIndex: "0",
                    "aria-roledescription": "Finish Type ".concat(selectedColorName, " selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "product-detail-page__finish_text",
                            children: colorOrFinish
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "product-detail-page__finish_value",
                            children: selectedColorName
                        })
                    ]
                })
            }) : null,
            colorsData.filter((c)=>!c.notApplicable).length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row no-gutters product-detail-page__color-swatch-main",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "finish-type-list",
                    className: "product-detail-page__color-swatch",
                    role: "listbox",
                    children: colorsData.filter((c)=>!c.notApplicable).map((item, i)=>{
                        const isChecked = item.id === sku || selectedColor === item.label;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            role: "radio",
                            tabIndex: 0,
                            "aria-label": item.label,
                            "aria-checked": isChecked ? true : false,
                            onKeyDown: (e)=>handleKeyDown(i, e),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ColorSwatch_ColorSwatch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                type: "selector",
                                id: item.id,
                                name: item.name,
                                value: item.value,
                                label: item.label,
                                colorUrl: item.colorUrl,
                                checked: isChecked,
                                onClick: (sku)=>setSkuVariant(sku)
                            }, i)
                        }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-").concat(i));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwatchList);


/***/ }),

/***/ 85660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I6": function() { return /* binding */ addAnalyticsForAddService; },
  "Zy": function() { return /* binding */ addAnalyticsForBathroomDesign; },
  "G5": function() { return /* binding */ addAnalyticsForBuymore; },
  "DG": function() { return /* binding */ addAnalyticsForChangeZipCode; },
  "f6": function() { return /* binding */ addAnalyticsForCloseClick; },
  "Mi": function() { return /* binding */ addAnalyticsForGetProfessionalClick; },
  "yQ": function() { return /* binding */ addAnalyticsForRightToKnowInfoButtonClick; },
  "Xr": function() { return /* binding */ addAnalyticsForUpdate; },
  "Y2": function() { return /* binding */ addAnalyticsForViewNowClick; },
  "jb": function() { return /* binding */ addAnalyticsPdpAffirmText; },
  "nM": function() { return /* binding */ addPageLoadAnalytics; }
});

// UNUSED EXPORTS: addAnalyticsForStoreNearYou

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/analytics/constant.js
const PDP_DEATAIL = "product details";
const PDP_VIEW = "view this product in your space";
const constant_PDP = "pdp";
const constant_NAVIGATION = "navigation";
const constant_CROSS_SELL = "cross-sell";
const BASED_ON_LOCATION = "based on your current location";
const ADD_INSTALL = "add an install service";
const PURCHASE_DESIGN = "purchase a design plan";
const constant_STORE_NEAR = "see product on display";
const FIND_PRO = "find a local pro";
const WAIT_TIME_FOR_DATALAYER = 5000;
const ADD_TO_CART = "add to cart";
const PRODUCT_DECS = "flat fee pricing. kohler trusted professionals.";
const PRODUCT_TYPE = "regular w/required Items";
const PRODUCT_INSATLL = "install service";

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/analytics/analytics.js


const addAnalyticsForViewNowClick = (productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(PDP_DEATAIL, ":view in your space"),
        eventName: "".concat(constant_PDP, ":").concat(PDP_DEATAIL, ":view in your space"),
        eventType: constant_NAVIGATION,
        internalLinkName: "view in your space",
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(PDP_VIEW),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(PDP_DEATAIL),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForCloseClick = (productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(PDP_DEATAIL, ":modal:").concat(PDP_VIEW, ":close"),
        eventName: "".concat(constant_PDP, ":").concat(PDP_DEATAIL, ":modal:").concat(PDP_VIEW, ":close"),
        eventType: constant_NAVIGATION,
        internalLinkName: "close",
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":close"),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(PDP_DEATAIL, ":modal:").concat(PDP_VIEW),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForChangeZipCode = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, zipval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(zipval),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(BASED_ON_LOCATION),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForUpdate = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, zipval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, showcard = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    const title = titleName.toLowerCase();
    const eventStatusItem = showcard ? "success" : "failure";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title, " zip code"),
        eventName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title, " zip code"),
        eventMsg: "n/a",
        eventStatus: "".concat(eventStatusItem),
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(zipval),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(BASED_ON_LOCATION),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForBuymore = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(ADD_INSTALL),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(ADD_INSTALL),
        internalLinkURL: url ? url : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForAddService = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productitem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, serviceName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", servicePrice = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, productServices = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const title = titleName.toLowerCase();
    const service = (0,helper/* getPureText */.OM7)(serviceName).toLowerCase();
    const { productName ="" , quantity =1 , productBrand =""  } = productitem;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(ADD_INSTALL, ":").concat(ADD_TO_CART),
        eventName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(ADD_INSTALL, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(service),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(ADD_INSTALL),
        internalLinkURL: "n/a"
    };
    const productInfo = {
        defaultImageName: "n/a",
        description: PRODUCT_DECS,
        frequency: "n/a",
        globalPromotionPrice: servicePrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        numberOfReviews: "n/a",
        pdpType: PRODUCT_TYPE,
        priceState: "regular price",
        productBasePrice: servicePrice,
        productBrand: productBrand,
        productCategory: PRODUCT_INSATLL,
        productCollectionsName: PRODUCT_INSATLL,
        productColor: "n/a",
        productCouponCode: "n/a",
        productCoupondiscount: "n/a",
        productFindingMethod: "n/a",
        productID: "K-" + productServices,
        productName: productName,
        productPartnerBuyNow: "n/a",
        productRoom: PRODUCT_INSATLL,
        productSalePrice: servicePrice,
        productSaleable: "true",
        productStatus: "in stock",
        productSuperSku: "false",
        productTileName: "installation services",
        quantity: quantity,
        ratings: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForBathroomDesign = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(PURCHASE_DESIGN),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(PURCHASE_DESIGN),
        internalLinkURL: url
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForStoreNearYou = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventName: "".concat(PDP, ":").concat(CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: PDP,
        internalLinkType: "".concat(PDP, ":").concat(STORE_NEAR),
        internalLinkZoneName: "".concat(PDP, ":").concat(CROSS_SELL, ":").concat(STORE_NEAR),
        internalLinkURL: url
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsForGetProfessionalClick = function() {
    let titleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 ? arguments[1] : void 0, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = titleName.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(title),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: title,
        internalLinkPosition: constant_PDP,
        internalLinkType: "".concat(constant_PDP, ":").concat(FIND_PRO),
        internalLinkZoneName: "".concat(constant_PDP, ":").concat(constant_CROSS_SELL, ":").concat(FIND_PRO),
        internalLinkURL: url
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsPdpAffirmText = function() {
    let affirmTitle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", affirmClickText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isBundleProduct = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PDP, ":product details:").concat(affirmTitle, ":").concat(affirmClickText),
        eventName: "".concat(constant_PDP, ":product details:").concat(affirmTitle, ":").concat(affirmClickText),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: affirmClickText,
        internalLinkPosition: "".concat(constant_PDP).concat(isBundleProduct ? ":bundle" : ""),
        internalLinkType: "".concat(constant_PDP, ":").concat(constant_NAVIGATION),
        internalLinkZoneName: "".concat(constant_PDP, ":product details:").concat(affirmTitle, ":").concat(affirmClickText),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};
const addAnalyticsForRightToKnowInfoButtonClick = function() {
    let productInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const eventInfo = {
        eventAction: "pdp:product details:right to know information",
        eventName: "pdp:product details:right to know information",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "right to know information",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:navigation",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "false"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
// analytic for cmp:show
const addPageLoadAnalytics = (data)=>{
    var ref, ref1, ref2;
    const { pageLoadAnalyticsTimer , getProcessedProductInfo , productLocalCategory , imagesData , isShowAnalyticsEventLoaded , getUserAnalyticsObject , setProductInfo , productImagesWithUrls  } = data;
    const asset = imagesData[0] || [];
    const assetType = (asset === null || asset === void 0 ? void 0 : asset.type) === "video" ? "videoId" : "imageId" || 0;
    const assetId = (asset === null || asset === void 0 ? void 0 : asset.type) === "video" ? asset === null || asset === void 0 ? void 0 : asset.url : (asset === null || asset === void 0 ? void 0 : asset.assetId) || "";
    const resourceType = ((ref2 = (ref1 = (ref = productImagesWithUrls[0]) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.split("|")) === null || ref2 === void 0 ? void 0 : ref2[2]) || "";
    const { productAnalyticsData ={} , productInfo ={}  } = getProcessedProductInfo(true);
    if (window.datalayerTopLoaded && window.adobeDataLayer.length > 0) {
        var ref3, ref4, ref5, ref6;
        clearInterval(pageLoadAnalyticsTimer);
        const page = window.pageObj || {};
        const category = ((ref3 = window.pageObj) === null || ref3 === void 0 ? void 0 : ref3.category) || {};
        const pageType = ((ref4 = window.pageObj) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.category) === null || ref5 === void 0 ? void 0 : ref5.pageType) || "";
        const siteName = productAnalyticsData.brandName;
        const pageInfo = ((ref6 = window.pageObj) === null || ref6 === void 0 ? void 0 : ref6.pageInfo) || {};
        category["subCategory1"] = pageType + ":" + productAnalyticsData.category;
        category["productLocalCategory"] = productLocalCategory;
        category["subCategory2"] = pageType + ":" + productAnalyticsData.category + ":" + productAnalyticsData.customerFacingSKU;
        category["subCategoryID"] = productAnalyticsData.customerFacingSKU;
        category["room"] = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productRoom) || "";
        if (window.needPdpdata) {
            const url = new URL(window.location.href);
            const pdpSkuUrl = url.searchParams.get("skuId");
            const { productSubCatergory ="" , skuID =""  } = window.needPdpdata;
            const { pageInfo: { contentType ="pdp"  } = {}  } = page;
            page.category["subCategoryName"] = productSubCatergory;
            page.pageInfo["pageName"] = "".concat(siteName, ":").concat(contentType || "pdp", ":").concat(productSubCatergory, ":").concat(skuID || pdpSkuUrl);
            category["subCategory1"] = pageType + ":" + productSubCatergory;
            category["subCategory2"] = pageType + ":" + productSubCatergory + ":" + productAnalyticsData.customerFacingSKU;
            delete window.needPdpdata;
        }
        pageInfo[assetType] = assetId;
        pageInfo["resourceType"] = resourceType;
        pageInfo["defaultImage"] = imagesData.length ? imagesData[0].assetId || imagesData[0].url : "n/a";
        page.category = category;
        if (!isShowAnalyticsEventLoaded()) {
            page.user = getUserAnalyticsObject();
            page.productInfo = {
                ...productInfo
            };
            if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
                page.pageInfo = pageInfo;
                window.pageObj = page;
                window.isShowAnalyticsEvent = true;
            } else {
                window.adobeDataLayer.push({
                    event: "cmp:show",
                    pageInfo,
                    productInfo,
                    page
                });
                // delete window.pageObj
                setProductInfo(productAnalyticsData.stringProductInfo);
            }
        }
    }
};


/***/ }),

/***/ 21328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getFormatedImages; },
/* harmony export */   "FP": function() { return /* binding */ getDefaultStateData; },
/* harmony export */   "VQ": function() { return /* binding */ getSelectedColor; },
/* harmony export */   "gI": function() { return /* binding */ showToaster; },
/* harmony export */   "ku": function() { return /* binding */ getFirstSkuColor; },
/* harmony export */   "xU": function() { return /* binding */ getPdpProps; }
/* harmony export */ });
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88751);



const getDefaultStateData = (pdpData)=>{
    return {
        isProductVariantClicked: false,
        clickedProductVariant: false,
        selectedSku: "",
        customerFacingSKU: "",
        productDetailData: pdpData ? pdpData : {},
        docId: "",
        fusionQueryId: "",
        masterSku: "",
        options: {},
        facetLabels: [],
        currOptions: {},
        selectMoreTooltipData: {},
        reqCartData: [],
        ctData: {},
        persona: "",
        toaster: {
            show: false,
            message: "",
            mobileOnly: false
        },
        reverseGeo: "",
        jsonFileUrl: "",
        zipCodeData: [],
        installationData: [],
        designServiceData: [],
        servicesData: {},
        installationDataFromProp: [],
        designServiceDataFromProp: [],
        availableStock: 0,
        promoTitle: null,
        promoDescription: false,
        enablePromo: false,
        viewLoader: pdpData ? true : false,
        findInstallerPath: "",
        loadShowEvent: false,
        installerArea: "",
        statesData: [],
        mboxes: [],
        imageClickCounter: 1,
        variantData: []
    };
};
const getFormatedImages = (data)=>{
    const { variantImageLabels , variantImageURLs , authorData  } = data;
    const images = [];
    if (authorData) {
        for(let i = 0; i < variantImageURLs.length; i++){
            var ref;
            const urlPaths = (ref = variantImageURLs[i].split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
            const assetId = urlPaths[urlPaths.length - 1];
            var _i, _i1;
            images.push({
                label: (_i = variantImageLabels[i]) !== null && _i !== void 0 ? _i : "",
                assetId,
                url: (_i1 = variantImageURLs[i]) !== null && _i1 !== void 0 ? _i1 : ""
            });
        }
    }
    return images;
};
const getPdpProps = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { state: { productDetailData ={} , selectedSku ="" , availableStock =0 , masterSku ="" , variantData =[] , ctData ={} , loadShowEvent , clickedProductVariant  } , customerSkus , selectedColor , isParts , currencySign , requiredItemstoInstall , colorsData , comparedProducts , disableEcommerce , favorites , superSku , cartLoaded , cart , pricesData , // locale,
    discountedPrices  } = data;
    const { title_s: title = "" , productName_s: productNames = "" , features_s: features , RegionBrandName_s: regionBrandNames = "" , ProductBrandName_s: productBrandNames = [] , ProductDescriptionProductShort_s: desc , ProductNarrativeDescription_s: narrativeDescription = "" , CustomerFacingBrand_s: customerBrandName = "" , productRegionAllVariantDiscontinued_b: discontinuedProduct = false , ProductProductRecommendedAccessories_ss: ProductRequiredAccessoriesGroupsList = [] , RegionOnBackOrder_s: backOrder = "No" , ProductOverallLengthInches_s: productOverallLength = 0 , ProductOverallWidthInches_s: productOverallWidth = 0 , ProductOverallHeightInches_s: productOverallHeight = 0 , ProductWebFeatures_ss: productWebFeatures = [] , ProductPriceSpiderIncluded_s: productPriceSpiderIncluded , ProductFreightPolicyType_s: freightPolicyType = "" , category1_s: category1s , ProductBrandNameDisplay_t: productBrandNameDisplayt , ctProductType_s: ctProductTypes , primaryBundleSKU_s: primaryBundleSKUs = ""  } = productDetailData;
    var ref1;
    const { RegionSpecialOrder_s: specialOrder = "No"  } = (ref1 = variantData.find((item)=>item.sku_s === selectedSku)) !== null && ref1 !== void 0 ? ref1 : {};
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const productName = isBundleProduct || isParts ? productNames : regionBrandNames;
    const name = productName ? productName : productNames;
    const productDisc = isBundleProduct ? title : desc;
    var ref2, _selectedSku;
    return {
        features,
        sku: selectedSku,
        customerFacingSKU: customerSkus[selectedSku],
        name,
        desc: productDisc,
        narrativeDescription,
        customerBrandName,
        currencySign,
        discontinuedProduct: discontinuedProduct,
        ProductRequiredAccessoriesGroupsList,
        stickyHeaderProps: {
            selectedSku,
            title: isParts ? productNames : isBundleProduct ? productNames : productBrandNames,
            description: isBundleProduct ? title : desc,
            itemStatus: "available",
            color: {
                label: selectedColor,
                url: (ref = colorsData.find((item)=>item.id === selectedSku)) === null || ref === void 0 ? void 0 : ref.colorUrl
            }
        },
        requiredItems: requiredItemstoInstall !== null && requiredItemstoInstall !== void 0 ? requiredItemstoInstall : [],
        productOnStock: availableStock,
        colorsData: colorsData,
        addToCartProps: {
            compareChecked: Boolean(comparedProducts.find((prod)=>masterSku === prod["masterSKU_s"])),
            backOrder,
            specialOrder
        },
        detailsProps: {
            length: productOverallLength,
            width: productOverallWidth,
            height: productOverallHeight,
            dimensionUnit: "in",
            detailsData: productWebFeatures
        },
        ProductPriceSpiderIncluded_s: productPriceSpiderIncluded === "true" && !disableEcommerce ? true : false,
        isProjectPack: productDetailData["SKUIsProjectPack_s"] === "Yes",
        freightPolicyType,
        isFavorite: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(favorites) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.find((vl)=>{
            var ref;
            return vl.productId === ctData.id && ((ref = vl.variant) === null || ref === void 0 ? void 0 : ref.sku) === selectedSku;
        })) ? true : false,
        favItem: (ref2 = favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) !== null && ref2 !== void 0 ? ref2 : [],
        ctProductId: ctData.id,
        superSku,
        loadShowEvent: cartLoaded || loadShowEvent,
        cart,
        clickedProductVariant,
        selectedColor: selectedColor,
        businessUnitName: category1s || category1s,
        globalDiscount: Number((pricesData[selectedSku] - ((_selectedSku = discountedPrices[selectedSku]) !== null && _selectedSku !== void 0 ? _selectedSku : 0)).toFixed(2)),
        productSaleable: true,
        productPartnerBuyNow: false,
        productCollectionsName: productBrandNameDisplayt,
        productType: ctProductTypes
    };
};
const showToaster = (mssg)=>{
    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)({
        message: mssg,
        isVisible: true
    }));
    setTimeout(()=>_store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)({
            message: mssg,
            isVisible: false
        })), 3000);
};
const getFirstSkuColor = (data)=>{
    const colorList = [];
    const newData = data.filter((e)=>{
        if (!colorList.includes(e.label)) {
            colorList.push(e.label);
            return e;
        }
    });
    return newData.map((e)=>{
        const newData = data.filter((el)=>el.label === e.label).map((a)=>a.value);
        return {
            ...e,
            skus: newData
        };
    });
};
const getSelectedColor = (colorsData, sku)=>{
    var ref;
    const { label =""  } = (ref = colorsData.find((item)=>{
        const { skus =[] , id =""  } = item;
        if (id === sku || (skus === null || skus === void 0 ? void 0 : skus.includes(sku))) {
            return item;
        }
    })) !== null && ref !== void 0 ? ref : {};
    return label;
};


/***/ }),

/***/ 97167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getFavIconStatus; }
/* harmony export */ });
const getFavIconStatus = (data)=>{
    const { isSaveProductToList =false , productSavedToList =false , inSavedItems =false , isFavorite =false , filledWishIcon ={} , wishIcon ={}  } = data || {};
    if (isSaveProductToList) {
        return productSavedToList || inSavedItems ? filledWishIcon.src : wishIcon.src;
    } else {
        return isFavorite ? filledWishIcon.src : wishIcon.src;
    }
};


/***/ }),

/***/ 51952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(96724);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/core/Accordion/analytics/index.js

const addAnalyticsObjForAccordion = (analyticTitleData, productInfoData)=>{
    const eventInfo = analyticTitleData ? JSON.parse(analyticTitleData) : {};
    const productInfo = productInfoData ? JSON.parse(productInfoData) : {};
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click", {}, productInfo);
};

;// CONCATENATED MODULE: ./components/core/Accordion/Accordion.jsx








const Accordion = (props)=>{
    const { isOpen =false , analyticTitleData , analyticTitleCustomData , contentOverflow =false , trigger =false , children ="" , title , handleOpen , handleClose , containerElementProps , isArrow =false  } = props;
    const accordionWrapperStyle = "".concat((Accordion_module_default()).accordionWrapper, " accordion-container");
    const CollapsibleHeader = (param)=>/*#__PURE__*/ {
        let { title  } = param;
        return (0,jsx_runtime.jsxs)("div", {
            className: "collapsible__header ".concat(analyticTitleData ? "gbh-data-layer" : ""),
            onClick: ()=>addAnalyticsObjForAccordion(analyticTitleData, analyticTitleCustomData),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "heading",
                    "aria-level": "5",
                    children: title
                }),
                !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "plus",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "arrow",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "down-arrow",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default */.Z,
                                    alt: "Arrow Down"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "up-arrow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: arrow_up/* default */.Z,
                                alt: "Arrow Up"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: accordionWrapperStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collapsible-accordion",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                open: isOpen,
                onTriggerOpening: handleOpen,
                onTriggerClosing: handleClose,
                containerElementProps: containerElementProps,
                overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                openedClassName: "collapsible--open",
                tabIndex: "0",
                triggerOpenedClassName: "collapsible__trigger--open",
                trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                    title: title
                }),
                transitionTime: 400,
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                children: children
            })
        })
    });
};
/* harmony default export */ var Accordion_Accordion = (Accordion);


/***/ }),

/***/ 20812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);






const NextHead = (props)=>{
    var ref, ref1, ref2, ref3;
    const { fullUrl ="" , psKey ="" , psCountry ="" , psLanguage ="" , metaLanguage ="" , pdpData: { ProductBrandName_s: productName = "" , productName_s: partsName = "" , // ProductDescriptionProductShort_s: productDescription = "",
    "Color.SKU.Details_ss": skuDetails = [] , productIsInStock_b: available = true , masterVariantDataResponse: variants = [] , productName_s: productFullName = "" , metaDescription_s: productMetaDescription = "" , productRegionAllVariantDiscontinued_b: allVariantDiscontinued = false , RegionOnBackOrder_s: backorder = ""  } = {} , pdpData ={} , initialImageFullUrl ="" , isPart =false , skuId ="" , siteName ="" , isBundleProduct =false , persona ="GST" , config ={}  } = props;
    const { internationalization: { currencyCode ="USD"  } = {}  } = config;
    var ref4;
    const selectedSkuDetails = (ref4 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    const selectSkuList = (ref5 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6;
    const selectedSku = (ref6 = selectSkuList[selectSkuList.length - 1]) !== null && ref6 !== void 0 ? ref6 : "";
    const getVariantImage = (variantImages, tmpSkuId)=>{
        let initialImgUrl = "";
        let initialImageFullUrl = "";
        let variantImageLabels = [];
        let variantImageURLs = [];
        if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
            const selVarImageUrls = [];
            const selVarImageLabels = [];
            variantImages.forEach((img)=>{
                const imgDetail = img.split("|");
                if (tmpSkuId === imgDetail[0]) {
                    var ref;
                    selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                    selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                } else if (!variants.find((v)=>v === imgDetail[0])) {
                    var ref1;
                    variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                    variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                }
            });
            variantImageLabels = [
                ...selVarImageLabels,
                ...variantImageLabels
            ];
            variantImageURLs = [
                ...selVarImageUrls,
                ...variantImageURLs
            ];
            if (variantImageURLs.length < 1) {
                variantImageLabels.push(tmpSkuId);
                variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
            }
        } else {
            variantImageLabels.push(tmpSkuId);
            variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
        }
        const assetIdArray = variantImageURLs ? variantImageURLs[0].split("PAWEB/") : [
            ""
        ];
        initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : "";
        var ref;
        initialImageFullUrl = (ref = variantImageURLs.find((image)=>image.includes(initialImgUrl))) !== null && ref !== void 0 ? ref : "";
        return initialImageFullUrl;
    };
    const getVariantsSchema = ()=>{
        let variantsSchema = [];
        if (variants.length > 1) {
            variantsSchema = variants.map((variant)=>{
                var ref;
                const skuId = (ref = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const selectedSkuDetails = (ref1 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref1 !== void 0 ? ref1 : "";
                var ref2;
                const selectSkuList = (ref2 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref2 !== void 0 ? ref2 : [];
                var ref3;
                const selectedSku = (ref3 = selectSkuList[selectSkuList.length - 1]) !== null && ref3 !== void 0 ? ref3 : "";
                var ref4, ref5, ref6, ref7, ref8, ref9;
                return {
                    "@type": "Product",
                    sku: selectedSku,
                    gtin: (ref4 = variant === null || variant === void 0 ? void 0 : variant.SKUUPCCode_s) !== null && ref4 !== void 0 ? ref4 : "",
                    image: getVariantImage(variant["productImages.labelWithUrl_ss"], variant.sku_s),
                    name: (ref5 = variant === null || variant === void 0 ? void 0 : variant.productName_s) !== null && ref5 !== void 0 ? ref5 : "",
                    description: (ref6 = variant === null || variant === void 0 ? void 0 : variant.metaDescription_s) !== null && ref6 !== void 0 ? ref6 : "",
                    color: (ref7 = variant === null || variant === void 0 ? void 0 : variant.ColorFinish_s) !== null && ref7 !== void 0 ? ref7 : "",
                    offers: {
                        "@type": "Offer",
                        url: "".concat(fullUrl, "?skuId=").concat((ref8 = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref8 !== void 0 ? ref8 : ""),
                        priceCurrency: currencyCode,
                        price: (ref9 = variant === null || variant === void 0 ? void 0 : variant["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref9 !== void 0 ? ref9 : 0,
                        itemCondition: "https://schema.org/NewCondition",
                        availability: variant.productIsInStock_b ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
                    }
                };
            });
        }
        return variantsSchema;
    };
    const getSkuWithoutColorFinsih = function() {
        let skuId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return skuId.substring(0, skuId.lastIndexOf("-"));
    };
    var ref7, ref8, ref9;
    const productSchema = variants.length > 1 ? [
        {
            "@context": "https://schema.org",
            "@type": "ProductGroup",
            "@id": fullUrl,
            url: fullUrl,
            additionalType: isPart ? "Service Part" : "",
            name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
            image: initialImageFullUrl,
            description: isBundleProduct ? partsName : productMetaDescription,
            sku: getSkuWithoutColorFinsih(isBundleProduct ? skuId : selectedSku),
            gtin: (ref7 = (ref = variants === null || variants === void 0 ? void 0 : variants.filter((variant)=>variant.masterVariant_b)) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.SKUUPCCode_s) !== null && ref7 !== void 0 ? ref7 : "",
            brand: {
                "@type": "Brand",
                name: siteName
            },
            productGroupID: getSkuWithoutColorFinsih(isBundleProduct ? skuId : selectedSku),
            variesBy: [
                "https://schema.org/color"
            ],
            hasVariant: getVariantsSchema()
        }
    ] : {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": fullUrl,
        url: fullUrl,
        additionalType: isPart ? "Service Part" : "",
        name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
        image: initialImageFullUrl,
        description: isBundleProduct ? partsName : productMetaDescription,
        sku: isBundleProduct ? skuId : selectedSku,
        gtin: (ref8 = (ref2 = variants === null || variants === void 0 ? void 0 : variants.filter((variant)=>variant.masterVariant_b)) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.SKUUPCCode_s) !== null && ref8 !== void 0 ? ref8 : "",
        brand: {
            "@type": "Brand",
            name: siteName
        },
        offers: {
            "@type": "Offer",
            price: (ref9 = pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref9 !== void 0 ? ref9 : 0,
            priceCurrency: currencyCode,
            availability: available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            itemCondition: "http://schema.org/NewCondition"
        }
    };
    var ref10;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "Kohler US Plumbing Bathroom Kitchen"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:price:amount",
                content: parseFloat((ref10 = pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref10 !== void 0 ? ref10 : 0).toFixed(2)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:price:currency",
                content: currencyCode || "USD"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:availability",
                content: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getProductStatus */ .AEk)(allVariantDiscontinued, backorder, available)
            }),
            metaLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: metaLanguage === null || metaLanguage === void 0 ? void 0 : metaLanguage.toLocaleLowerCase()
            }) : null,
            fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            }) : null,
            psKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-key",
                content: psKey
            }) : null,
            psCountry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-country",
                content: psCountry
            }) : null,
            psLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-language",
                content: psLanguage
            }) : null,
            productName || partsName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(productSchema))
                }
            }, "structured-data") : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextHead);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67166);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11763);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2595);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)("guest"));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 57207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pdp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 192 modules
var AemGrid = __webpack_require__(64799);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./components/ProductDetail/v3/productDetailsHelper.js
var productDetailsHelper = __webpack_require__(14887);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
// EXTERNAL MODULE: ./utils/cart.js
var utils_cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/utils.js
var utils = __webpack_require__(21328);
// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/productDetailsView.module.scss
var productDetailsView_module = __webpack_require__(14427);
var productDetailsView_module_default = /*#__PURE__*/__webpack_require__.n(productDetailsView_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v2/ProgressiveLoader/PdpProgressiveLoader.jsx


const PdpProgressiveLoader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "progressive-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "progressive-loader__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row progressive-loader__filter-row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 progressive-loader__filter-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "progressive-loader__filter-heading"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row progressive-loader__filter-contents",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 progressive-loader__filter-contents-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-1 col-lg-1 col-md-1 progressive-loader__filter-details-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__filter-contents-heading"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__filter-contents-share"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-lg-6 col-md-6 progressive-loader__plp-contents-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "progressive-loader__plp-products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "progressive-loader__plp-products-image"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-5 col-lg-5 col-md-5 progressive-loader__plp-details-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "progressive-loader__plp-products-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progressive-loader__plp-products-details-image1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progressive-loader__plp-products-details-image2"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProgressiveLoader_PdpProgressiveLoader = (PdpProgressiveLoader);

// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./public/icons/youtube-play.svg
/* harmony default export */ var youtube_play = ({"src":"/_next/static/media/youtube-play.fcf5eeeb.svg","height":64,"width":64});
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./components/VideoWrapper/VideoWrapper.jsx




const waitTimeForResetingIsClick = 500;
const VideoWrapper = (props)=>{
    const { videoId ="" , thumb ="" , height ="100%" , width =0 , alt ="image" , playThumb =false , onClick =()=>{} , getVideoInfo =()=>{} , index =0 , totalPdpImages =0 , zoomEntryPoint ="" , anyliticsText =""  } = props;
    const addAnalyticsData = (type, event)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        var ref;
        const { videoTitle ="" , title =""  } = (ref = event === null || event === void 0 ? void 0 : event.target) !== null && ref !== void 0 ? ref : {};
        const videoName = type === "fullscreen" ? title.toLowerCase() : videoTitle.toLowerCase();
        const page = getState && getState("page") || {};
        const { imageSequence  } = props;
        const eventInfo = {
            eventAction: "pdp:product details:".concat(anyliticsText ? anyliticsText : "carousel", " image click:video ").concat(type),
            eventName: "pdp:product details:".concat(anyliticsText ? anyliticsText : "carousel", "  image click:video ").concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "video ".concat(type),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "video navigation"),
            internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint ? zoomEntryPoint : "view gallery"),
            internalLinkURL: "n/a",
            videoId,
            clickInternalLinks: "true",
            ...imageSequence && {
                imageSequence
            },
            videoName,
            imageSequence: "".concat(index, "_").concat(totalPdpImages)
        };
        const { productInfo  } = page;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo
        });
    };
    const youtubePlayerPayload = {
        height,
        width,
        videoId,
        playerVars: {
            rel: 0,
            frameBorder: 0,
            allowFullScreen: true,
            autoPlay: 1
        }
    };
    const videoFullScreenCallback = (event)=>{
        if (window.isClick === true) {
            return;
        }
        window.isClick = true;
        setTimeout(()=>{
            delete window.isClick;
        }, waitTimeForResetingIsClick);
        if (document.webkitIsFullScreen || document.mozFullScreen || document.fullScreen) {
            if (event.target.tagName === "IFRAME") {
                addAnalyticsData("fullscreen", event);
            }
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("fullscreenchange", videoFullScreenCallback);
        document.addEventListener("webkitfullscreenchange", videoFullScreenCallback);
    }, []);
    const onReady = (e)=>{
        getVideoInfo(e.target, index, videoId);
    };
    return thumb || playThumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                role: "button",
                onClick: ()=>playThumb && onClick(videoId),
                src: "https://i.ytimg.com/vi/".concat(videoId, "/").concat(playThumb ? "mqdefault" : "default", ".jpg"),
                alt: alt,
                tabIndex: 0,
                className: "img-fluid"
            }),
            playThumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: youtube_play === null || youtube_play === void 0 ? void 0 : youtube_play.src,
                onClick: ()=>onClick(videoId),
                className: "img-play-button",
                alt: alt
            }),
            " "
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
        videoId: videoId,
        opts: youtubePlayerPayload,
        onPlay: (e)=>addAnalyticsData("play", e),
        onEnd: (e)=>addAnalyticsData("complete", e),
        className: "pdp-image-reel__image-list pdp-image-reel__modal-image",
        onReady: onReady
    });
};
/* harmony default export */ var VideoWrapper_VideoWrapper = (VideoWrapper);

// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./styles/images/zoom-close-icon.svg
/* harmony default export */ var zoom_close_icon = ({"src":"/_next/static/media/zoom-close-icon.91e663a4.svg","height":50,"width":50});
;// CONCATENATED MODULE: ./styles/images/zoom-video-icon.svg
/* harmony default export */ var zoom_video_icon = ({"src":"/_next/static/media/zoom-video-icon.dddeb007.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./styles/images/play-button-overlay.svg
/* harmony default export */ var play_button_overlay = ({"src":"/_next/static/media/play-button-overlay.67b4b5c0.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./styles/images/tap-image-zoom.svg
/* harmony default export */ var tap_image_zoom = ({"src":"/_next/static/media/tap-image-zoom.870cb4c5.svg","height":58,"width":224});
;// CONCATENATED MODULE: ./styles/images/360-spin-overlay.svg
/* harmony default export */ var _360_spin_overlay = ({"src":"/_next/static/media/360-spin-overlay.220435f7.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./components/ImageGallery/v2/constants.js
const SCENE7_JS_URL = "https://kohler.scene7.com/s7viewers/html5/js/";
const SCENE7_SERVER_IMAGE = "https://kohler.scene7.com/is/image/";
const constants_THREE_SIXTY_LABLE = "360 spin";
const THREE_SIXTY_MAIN = "main";
const THREE_SIXTY_CAROUSEL_LABLE = "carousel";
const constants_THREE_SIXTY_FULL_SCREEN = "360 spin fullscreen";

;// CONCATENATED MODULE: ./components/ImageGallery/v2/utlis.js


const openModal = ()=>{};
let count = 0;
const openModalAction = function(image) {
    let isVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!isVideo) {
        pauseAllVideo();
    }
    const s7viewerSpinThreeSixty = document.querySelector("#s7viewerSpinThreeSixty");
    if (s7viewerSpinThreeSixty) {
        document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    }
    document.body.classList.add("zoom-image-scroll");
    count++;
    const element = document.querySelector(".product-detail-page");
    element === null || element === void 0 ? void 0 : element.classList.add("zoom-image-product-section");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
    document.getElementById("imageoverlay").style.display = "block";
    if (count >= 3) {
        const elementImage = document.querySelector("#imageoverlay");
        elementImage === null || elementImage === void 0 ? void 0 : elementImage.classList.add("zoom-activated");
    }
    document.body.classList.add("zoom-image-scroll");
    initZoomviewer(image, isVideo);
};
const initZoomviewer = function(assetID) {
    let isVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const s7viewerSpinThreeSixty = document.querySelector("#s7viewerSpinThreeSixty");
    if (s7viewerSpinThreeSixty) {
        document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    }
    const element = document.querySelector(".product-detail-page");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
    count++;
    const zoomViewer = new window.s7viewers.ZoomViewer();
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setContainerId("s7viewer");
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setParam("serverurl", SCENE7_SERVER_IMAGE);
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setAsset("PAWEB/".concat(assetID));
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.init();
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "none";
    }
    if (isVideo) {
        document.getElementById("s7viewer").style.display = "none";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
        const zoomPopupVideo = document.querySelector("#zoomVideo");
        if (zoomPopupVideo) {
            document.getElementById("zoomVideo").style.display = "block";
        }
    } else {
        if (zoomVideo) {
            document.getElementById("zoomVideo").style.display = "none";
        }
        document.getElementById("s7viewer").style.display = "block";
    }
    if (count >= 3) {
        const elementImage = document.querySelector("#imageoverlay");
        elementImage === null || elementImage === void 0 ? void 0 : elementImage.classList.add("zoom-activated");
    }
};
const closeZoomImage = ()=>{
    pauseAllVideo();
    const s7viewerSpinThreeSixty = document.querySelector("#s7viewerSpinThreeSixty");
    const s7viewerZoomImg = document.querySelector("#s7viewer");
    if (s7viewerZoomImg) {
        document.getElementById("s7viewer").innerHTML = "";
    }
    if (s7viewerSpinThreeSixty) {
        document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    }
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").innerHTML = "";
        document.getElementById("zoomVideo").style.display = "none";
    }
    document.body.classList.remove("zoom-image-scroll");
    const element = document.querySelector(".product-detail-page");
    element === null || element === void 0 ? void 0 : element.classList.remove("zoom-image-product-section");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
    document.getElementById("imageoverlay").style.display = "none";
};
const zoomVideoImage = ()=>{
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "block";
    }
    document.getElementById("s7viewer").style.display = "none";
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
    const element = document.querySelector(".product-detail-page");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
};
const getSlickSettings = ()=>{
    const { desktopSliderImages  } = constants.PDP_SLIDER_SIZES;
    return {
        dots: false,
        slidesToShow: desktopSliderImages,
        slidesToScroll: 3,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: false,
        centerMode: false,
        centerPadding: "0px",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 4.8,
                    focusOnSelect: false,
                    centerPadding: "10px"
                }
            }
        ]
    };
};
const spin360Open = function() {
    let assetID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", zoomSpinCB = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    pauseAllVideo();
    const zoomViewer = new window.s7viewers.SpinViewer({
        handlers: {
            trackEvent: function(objID, compClass, instName, timeStamp, eventInfo) {
                zoomSpinCB(eventInfo);
            }
        }
    });
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setContainerId("s7viewerSpinThreeSixty");
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setParam("serverurl", SCENE7_SERVER_IMAGE);
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setAsset("PAWEB/".concat(assetID));
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.init();
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "none";
    }
};
const spin360PdpGallery = function() {
    let assetID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", zoomSpinCBPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    pauseAllVideo();
    if ( true && (window === null || window === void 0 ? void 0 : window.s7viewers)) {
        const zoomViewer = new window.s7viewers.SpinViewer({
            handlers: {
                trackEvent: function(objID, compClass, instName, timeStamp, eventInfo) {
                    zoomSpinCBPdp(eventInfo);
                }
            }
        });
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setContainerId("s7viewerGallery");
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setParam("serverurl", SCENE7_SERVER_IMAGE);
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setAsset("PAWEB/".concat(assetID));
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.init();
    }
};
const pauseAllVideo = ()=>{
    const iframes = document.querySelectorAll("iframe");
    if (iframes) {
        Array.prototype.forEach.call(iframes, (iframe)=>{
            iframe.contentWindow.postMessage(JSON.stringify({
                event: "command",
                func: "stopVideo"
            }), "*");
        });
    }
};

;// CONCATENATED MODULE: ./components/ImageGallery/v2/analytics/index.js

const addAnalyticsClickPdpImageVideo = (data)=>{
    const { index =0 , mediaType ="" , imageVideoName ="" , totalImages =0 , pdpType ="" , assetId ="" , resourceType ="n/a"  } = data;
    const imageVideoIdKey = mediaType === "image reel" ? "imageId" : "videoId";
    const imageVideoNameKey = mediaType === "image reel" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:main image click",
        eventName: "pdp:product details:main image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: assetId,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(mediaType),
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(index, "_").concat(totalImages),
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: imageVideoName,
        resourceType
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickSliderImageVideo = (data)=>{
    const { index =0 , imageVideoId ="n/a" , totalImages =0 , pdpType ="" , zoomEntryPoint ="image reel" , imageName ="n/a" , imageClick =false , resourceType ="n/a" , isThreeSixtyImage =""  } = data;
    const imageVideoIdKey = imageClick ? "imageId" : "videoId";
    const imageVideoNameKey = imageClick ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click",
        eventName: "pdp:product details:carousel image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: imageVideoId,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint).concat(isThreeSixtyImage ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint).concat(isThreeSixtyImage ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(index, "_").concat(totalImages),
        [imageVideoIdKey]: imageVideoId,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
        resourceType
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickCloseZoom = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , currentImageData ={} , totalImages ="" , resourceType ="n/a" , isThreeSixty =""  } = data;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:close button",
        eventName: "pdp:product details:carousel image click:close button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint).concat(isThreeSixty ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkZoneName: "pdp:product details:view gallery".concat(isThreeSixty ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickZoomReset = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , currentImageData ={} , totalImages ="" , resourceType ="n/a" , is360Image ="" , threeSixtyImageClick =""  } = data;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:".concat(is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE, " image click:zoom reset"),
        eventName: "pdp:product details:".concat(is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE, " image click:zoom reset"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "zoom reset:applied",
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "image reel").concat(is360Image || threeSixtyImageClick ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkZoneName: "pdp:product details:view gallery".concat(is360Image || threeSixtyImageClick ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickZoomSpinnerAndFullscreen = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image gallary" , currentImageData ={} , totalImages ="" , resourceType ="n/a" , is360Image ="" , buttonType ="" , threeSixtyImageClick ="" , screenType  } = data;
    const linkName = buttonType || screenType;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:".concat(is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE, " image click:360 ").concat(buttonType || screenType),
        eventName: "pdp:product details:".concat(is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE, " image click:360 ").concat(buttonType || screenType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkName,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "image gallary").concat(is360Image || threeSixtyImageClick ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkZoneName: "pdp:product details:image gallery".concat(is360Image || threeSixtyImageClick ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsZoomImageSliderArrow = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , arrowLable ="right" , resourceType ="n/a"  } = data;
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:".concat(arrowLable),
        eventName: "pdp:product details:carousel image click:".concat(arrowLable),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLable, " arrow"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        resourceType,
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickZoomImage = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , zoomAction ="zoom in" , currentImageData ={} , totalImages =0 , counter , resourceType ="n/a" , is360Image ="" , counterThreeSixty =""  } = data;
    const { assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const eventInfo = {
        eventAction: "pdp:product details:".concat(is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE, " image click:").concat(zoomAction),
        eventName: "pdp:product details:".concat(is360Image ? THREE_SIXTY_MAIN : THREE_SIXTY_CAROUSEL_LABLE, " image click:").concat(zoomAction),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(zoomAction, ":applied"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint, ":").concat(constants_THREE_SIXTY_LABLE),
        internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint, ":").concat(constants_THREE_SIXTY_LABLE),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageId: assetId,
        resourceType,
        imageName: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages),
        zoomUsageDepth: "".concat(zoomAction, "_").concat(counterThreeSixty || counter)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsPdpSlider = (data)=>{
    const { pdpImageInfo ={} , totalImages =0 , pdpType ="" , arrowLabel ="right" , resourceType ="n/a" , checkIs360Spin =""  } = data;
    const { label: imageName = "n/a" , index: imageIndex = 0 , type: imageType = "" , assetId: imageAssetId = "" , url: imageUrl = ""  } = pdpImageInfo;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:slider main image click:".concat(arrowLabel),
        eventName: "pdp:product details:slider main image click:".concat(arrowLabel),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLabel, " arrow"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:image reel".concat(checkIs360Spin ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkZoneName: "pdp:product details:image reel".concat(checkIs360Spin ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        imageSequence: "".concat(imageIndex + 1, "_").concat(totalImages),
        [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsPdpSliderFilmStrip = (data)=>{
    const { pdpImageInfo ={} , totalImages =0 , pdpType ="" , arrowLabel ="right" , resourceType ="n/a"  } = data;
    const { label: imageName = "n/a" , index: imageIndex = 0 , type: imageType = "" , assetId: imageAssetId = "" , url: imageUrl = ""  } = pdpImageInfo;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:filmstrip main image click:".concat(arrowLabel),
        eventName: "pdp:product details:filmstrip main image click:".concat(arrowLabel),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLabel, " arrow"),
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:image reel",
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        imageSequence: "".concat(imageIndex + 1, "_").concat(totalImages),
        [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addPdpThumbnailAnylticsClick = (data)=>{
    const { pdpType ="" , currentIndex ="" , totalImages ="" , pdpImageInfo ={} , resourceType ="n/a"  } = data;
    const { label: imageName = "n/a" , assetId: imageAssetId = "" , type: imageType = "" , url: imageUrl = "" , resourceName ="" , resourceAltText =""  } = pdpImageInfo;
    const imageId = (resourceName === null || resourceName === void 0 ? void 0 : resourceName.length) ? resourceName === null || resourceName === void 0 ? void 0 : resourceName[0] : imageAssetId;
    const imageNamePdp = (resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText.length) ? resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0] : imageName;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:thumbnail image click",
        eventName: "pdp:product details:thumbnail image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: imageId,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:image reel".concat(resourceName ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkZoneName: "pdp:product details:image reel".concat(resourceName ? ":".concat(constants_THREE_SIXTY_LABLE) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        [imageVideoIdKey]: imageType !== "video" ? imageId : imageUrl,
        [imageVideoNameKey]: imageNamePdp.toLowerCase() || "n/a",
        imageSequence: "".concat(currentIndex, "_").concat(totalImages),
        resourceType
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addViewGalleryAnylticsClick = (data)=>{
    const { pdpType =""  } = data;
    const eventInfo = {
        eventAction: "pdp:product details:thumbnail image click:view gallery",
        eventName: "pdp:product details:thumbnail image click:view gallery",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view gallery",
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:image reel",
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsClickFullScreen360 = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , totalImages ="" , resourceName ="" , image360Lable ="" , resourceType ="" , isPdpGallery  } = data;
    const text360Action = isPdpGallery ? "main image click" : "carousel image click";
    const imageId = (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) || "n/a";
    const eventInfo = {
        eventAction: "pdp:product details:".concat(text360Action, ":").concat(THREE_SIXTY_FULL_SCREEN),
        eventName: "pdp:product details:".concat(text360Action, ":").concat(THREE_SIXTY_FULL_SCREEN),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: imageId,
        internalLinkPosition: "pdp".concat(pdpType === "bundle" ? ":bundle" : ""),
        internalLinkType: "pdp:".concat(zoomEntryPoint, ":").concat(THREE_SIXTY_LABLE),
        internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint, ":").concat(THREE_SIXTY_LABLE),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "2_".concat(totalImages),
        imageId: imageId,
        imageName: image360Lable ? image360Lable.toLowerCase() : "n/a",
        resourceType
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    let { productInfo  } = page;
    let objDL = {
        event,
        eventInfo,
        page
    };
    if (productInfo) {
        productInfo.productImageGallery = true;
        productInfo = {
            ...productInfo,
            productImageGallery: true
        };
        objDL = {
            ...objDL,
            productInfo: productInfo
        };
    }
    window.adobeDataLayer.push(objDL);
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(4839);
;// CONCATENATED MODULE: ./components/ImageGallery/v2/ImageReel.jsx




















const ImageReel = (props)=>{
    var ref;
    const { data =[] , isModel =false , swatchUrl ="" , productInfo ={} , isHorizontal =false , galleryStackId ="" , assetAccountName ="" , imageClickCounter =0 , presetConfigObject ={} , productGalleryLabel ={} , initialImgAlt ="" , initialImgUrl ="" , pdpDesktopImage ="" , productImagesWithUrls ={} , threeSixtyResourceData ={} , staticTexts ={} , clickedProductVariant =false  } = props || {};
    swiper_esm/* default.use */.ZP.use([
        swiper_esm/* Thumbs */.o3,
        swiper_esm/* Keyboard */.N1,
        swiper_esm/* Mousewheel */.Gk,
        swiper_esm/* A11y */.s5,
        swiper_esm/* Scrollbar */.LW,
        swiper_esm/* FreeMode */.Rv
    ]);
    const swiperThumbRef = (0,react.useRef)(null);
    const swiperPdpRef = (0,react.useRef)(null);
    const iframeContainer = (0,react.useRef)(null);
    const threeSixtyIframeContainer = (0,react.useRef)(null);
    const pdpInfo = JSON.parse(productInfo);
    pdpInfo.productInfo["productImageGallery"] = true;
    const { productInfo: { pdpType: pdpType = []  }  } = pdpInfo;
    const { resourceFullWebUrl ="" , resourceName ="" , resourceTypeImg ="" , resourceAltText =""  } = threeSixtyResourceData;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [activeImage, setactiveImage] = (0,react.useState)(null);
    const [zoomVideoId, setZoomVideoId] = (0,react.useState)(null);
    const [currentVideoId, setCurrentVideoId] = (0,react.useState)(null);
    const [zoomEntryPoint, setZoomEntryPoint] = (0,react.useState)(null);
    const [thumbnailClicked, setThumbnailClicked] = (0,react.useState)(false);
    const [threeSixtyZoomClick, setThreeSixtyZoomClick] = (0,react.useState)(false);
    const [currentSlide, setCurrentSlide] = (0,react.useState)(0);
    const [isThreeSixtyRender, setIsThreeSixtyRender] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [thumbsSwiper, setThumbsSwiper] = (0,react.useState)(null);
    const slickRef = (0,react.useRef)(null);
    const totalImages = isHorizontal ? data.length : 3;
    const { largeIpadSize , imageReelTitle , mobileSize  } = constants.PDP_SLIDER_SIZES;
    const resourceCredits = productGalleryLabel && productGalleryLabel.resourceCredit_s && productGalleryLabel.resourceCredit_s.match("http") == null ? productGalleryLabel.resourceCredit_s : "";
    const imageSequence = imageClickCounter ? imageClickCounter + 1 : null;
    const pdpImages = data.reduce((acc, ini)=>{
        if (acc.filter((item)=>item.assetId === ini.assetId).length === 0 || ini.type === "video") {
            acc.push(ini);
        }
        return acc;
    }, []);
    const allPdpImages = [
        ...pdpImages.filter((item)=>!item.type),
        threeSixtyResourceData,
        ...pdpImages.filter((item)=>item.type === "video")
    ];
    const pdpCustomImagesArray = allPdpImages.filter((value)=>Object.keys(value).length !== 0);
    const pdpImageArrayLength = pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length;
    let fullScreenTimer;
    const ZoomValue = (0,react.useRef)(0);
    const ZoomValuePDP = (0,react.useRef)(0);
    const zoomSpinCBPdp = (eventInfo)=>{
        const [eventType, eventValue] = eventInfo.split(",");
        if (eventType === "SPIN" && eventValue > 0) {
            zoom360SpinnerClickAction();
        } else if (eventType === "ZOOM" && (eventValue !== 0 || eventValue !== 100)) {
            if (Number(ZoomValuePDP.current) > Number(eventValue)) {
                zoomOut360ButtonClickAction({
                    is360Image: true,
                    isImageGallery: true
                });
            } else {
                zoomInButton360ClickAction({
                    is360Image: true,
                    isImageGallery: true
                });
            }
            ZoomValuePDP.current = eventValue;
            ZoomValue.current = 0;
        }
    };
    const zoomSpinCB = (eventInfo)=>{
        const [eventType, eventValue] = eventInfo.split(",");
        if (eventType === "SPIN" && eventValue > 0) {
            zoom360CarasoulSpinnerClickAction();
        } else if (eventType === "ZOOM" && (eventValue !== 0 || eventValue !== 100)) {
            if (Number(ZoomValue.current) > Number(eventValue)) {
                zoomOut360ButtonClickAction({
                    is360Image: false,
                    isImageGallery: true
                });
            } else {
                zoomInButton360ClickAction({
                    is360Image: false,
                    isImageGallery: true
                });
            }
            ZoomValue.current = eventValue;
            ZoomValuePDP.current = 0;
        }
    };
    const threeSixtyOpen = function() {
        let assetId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", imageLable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        if (assetId) {
            setactiveImage("");
            setactiveImage(assetId);
            setThreeSixtyZoomClick(true);
            const s7viewerZoom = document.querySelector("#s7viewer");
            if (s7viewerZoom) {
                document.getElementById("s7viewer").innerHTML = "";
            }
            document.getElementById("s7viewer").style.display = "none";
            document.getElementById("s7viewerSpinThreeSixty").style.display = "block";
            const element = document.querySelector(".product-detail-page");
            element === null || element === void 0 ? void 0 : element.classList.add("three-sixty-image-gallery");
            spin360Open(assetId, zoomSpinCB);
            addAnalyticsClickSliderImageVideo({
                index: i + 1,
                imageVideoId: assetId,
                totalImages: pdpImageArrayLength,
                pdpType,
                zoomEntryPoint: zoomEntryPoint,
                imageLable,
                imageClick: true,
                resourceType: resourceTypeImg.length ? resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase() : "n/a",
                isThreeSixtyImage: true
            });
        }
    };
    const isOnePdpImage = initialImgUrl && pdpDesktopImage ? initialImgUrl : "";
    const firstImageForZoom = data && (pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length) ? pdpImages[0].assetId : isOnePdpImage;
    const beforeChangeHandler = function() {
        let swiper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const elementThumbSlider = document.querySelector(".pdp-thumbnail-vertical .swiper-slide");
        if (elementThumbSlider) {
            elementThumbSlider === null || elementThumbSlider === void 0 ? void 0 : elementThumbSlider.classList.remove("imageActiveThumb");
        }
        const current = swiper === null || swiper === void 0 ? void 0 : swiper.previousIndex;
        const next = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex;
        setCurrentSlide(next);
        setActiveIndex(next);
        const imagesLength = pdpImages.filter((item)=>!item.type).length;
        const checkIs360Spin = (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0]) && next === imagesLength;
        if (next === imagesLength) {
            if ((resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0])) {
                document.getElementById("s7viewerGallery").innerHTML = "";
                spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0], zoomSpinCBPdp);
            }
        }
        if (width <= largeIpadSize && (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0])) {
            document.body.classList.remove("full-screen-open");
            document.body.style.overflow = "";
        }
        pauseAllVideo();
        const elementSlider = document.querySelector(".pdp-thumbnail-vertical");
        elementSlider === null || elementSlider === void 0 ? void 0 : elementSlider.classList.add("pdp-slide-change");
        const arrowLabel = current > next ? "left" : "right";
        const pdpImageInfo = pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.map((item, index)=>({
                ...item,
                index
            })).find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.index) === next;
        });
        if (thumbnailClicked) {
            setThumbnailClicked(false);
        } else {
            addAnalyticsPdpSlider({
                pdpImageInfo,
                totalImages: pdpImageArrayLength,
                pdpType,
                arrowLabel,
                resourceType: checkImageResoruceType(pdpImageInfo === null || pdpImageInfo === void 0 ? void 0 : pdpImageInfo.assetId) || "",
                checkIs360Spin
            });
        }
    };
    const beforeChangeHandlerFilmStrip = function() {
        let swiper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const current = swiper === null || swiper === void 0 ? void 0 : swiper.previousIndex;
        const next = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex;
        if (width < largeIpadSize) {
            const arrowLabel = current > next ? "left" : "right";
            const pdpImageInfo = pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.map((item, index)=>({
                    ...item,
                    index
                })).find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.index) === next;
            });
            addAnalyticsPdpSliderFilmStrip({
                pdpImageInfo,
                totalImages: pdpImageArrayLength,
                pdpType,
                arrowLabel,
                resourceType: checkImageResoruceType(pdpImageInfo === null || pdpImageInfo === void 0 ? void 0 : pdpImageInfo.assetId) || ""
            });
        }
    };
    const handleOpenModal = ()=>{
        openModal(window.s7viewers);
        window.addEventListener("keydown", handleKey);
    };
    (0,react.useEffect)(()=>{
        handleOpenModal();
        if ((resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0]) && (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0])) {
            spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0], zoomSpinCBPdp);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if ((swiperThumbRef === null || swiperThumbRef === void 0 ? void 0 : swiperThumbRef.current) && clickedProductVariant && (swiperPdpRef === null || swiperPdpRef === void 0 ? void 0 : swiperPdpRef.current) && (data === null || data === void 0 ? void 0 : data.length)) {
            var ref, ref1;
            (ref = swiperThumbRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideTo(0);
            (ref1 = swiperPdpRef.current) === null || ref1 === void 0 ? void 0 : ref1.swiper.slideTo(0);
            setActiveIndex(0);
        }
    }, [
        clickedProductVariant
    ]);
    let isZoomClick = false;
    const slickGotoSlider = (sliderNumber)=>{
        slickRef.current.slickGoTo(sliderNumber);
    };
    const openImageZoom = function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currentImageName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", element = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var ref, ref1;
        if ((element === null || element === void 0 ? void 0 : (ref = element.resourceFullWebUrl) === null || ref === void 0 ? void 0 : ref[0]) && (element === null || element === void 0 ? void 0 : (ref1 = element.resourceName) === null || ref1 === void 0 ? void 0 : ref1[0])) {
            var ref2, ref3;
            spin360Open(element === null || element === void 0 ? void 0 : (ref2 = element.resourceName) === null || ref2 === void 0 ? void 0 : ref2[0], zoomSpinCB);
            setactiveImage("");
            setactiveImage(element === null || element === void 0 ? void 0 : (ref3 = element.resourceName) === null || ref3 === void 0 ? void 0 : ref3[0]);
        } else {
            const resourceType = checkImageResoruceType(image);
            setZoomEntryPoint("image gallery");
            setZoomVideoId("");
            setactiveImage("");
            setactiveImage(image);
            openModalAction(image);
            if (width < mobileSize) {
                slickGotoSlider(i);
            }
            addAnalyticsClickPdpImageVideo({
                index: i + 1,
                mediaType: imageReelTitle,
                imageVideoName: currentImageName,
                totalImages: pdpImageArrayLength,
                pdpType,
                assetId: image,
                resourceType: resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase()
            });
        }
    };
    const viewGalleryImageClick = (0,react.useCallback)(function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        setZoomEntryPoint("image gallery");
        setactiveImage(image);
        openModalAction(image);
        addViewGalleryAnylticsClick({
            pdpType
        });
    });
    const imageZoomClick = function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, imageName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", element = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        setThreeSixtyZoomClick(false);
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
        document.getElementById("s7viewer").style.display = "block";
        if (image) {
            const resourceType = checkImageResoruceType(image);
            setZoomVideoId("");
            setactiveImage("");
            initZoomviewer(image);
            setactiveImage(image);
            addAnalyticsClickSliderImageVideo({
                index: i + 1,
                imageVideoId: image,
                totalImages: pdpImageArrayLength,
                pdpType,
                zoomEntryPoint: zoomEntryPoint,
                imageName,
                imageClick: true,
                resourceType: resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase(),
                isThreeSixtyImage: false
            });
            setTabIndexGallery();
        }
    };
    const imageZoomVideoClick = function() {
        let video = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        setZoomVideoId(video);
        setactiveImage("");
        setActiveIndex(i);
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        setactiveImage(video);
        setCurrentVideoId(i + 1);
        zoomVideoImage();
        setTabIndexGallery();
    };
    const getVideoInfo = function() {
        let targetElement = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", videoId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        addAnalyticsClickSliderImageVideo({
            index,
            imageVideoId: videoId,
            totalImages: pdpImageArrayLength,
            pdpType,
            zoomEntryPoint: zoomEntryPoint,
            imageName: targetElement === null || targetElement === void 0 ? void 0 : targetElement.videoTitle,
            imageClick: false,
            isThreeSixtyImage: false
        });
    };
    const imageZoomMobileVideoClick = function() {
        let video = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        setactiveImage("");
        setCurrentVideoId(i + 1);
        setZoomVideoId(video);
        if (width < mobileSize) {
            slickGotoSlider(i);
        }
        openModalAction(video, true);
        setactiveImage(video);
    };
    const closeZoomImageClick = (0,react.useCallback)(()=>{
        const checkIsThreeSixty = document.querySelector(".three-sixty-image-gallery");
        counter = 0;
        zoomOutCounter = 0;
        setZoomVideoId(false);
        closeZoomImage();
        let currentImageData = {};
        let resourceType = null;
        if (checkIsThreeSixty) {
            currentImageData = {
                assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
                label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
                index: 1
            };
            resourceType = (resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].length) ? resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase() : null;
        } else {
            currentImageData = pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.map((item, index)=>({
                    ...item,
                    index
                })).find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.assetId) === activeImage || (item === null || item === void 0 ? void 0 : item.url) === activeImage;
            });
            resourceType = checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId) || null;
        }
        addAnalyticsClickCloseZoom({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpImageArrayLength,
            productInfo: pdpInfo === null || pdpInfo === void 0 ? void 0 : pdpInfo.productInfo,
            resourceType,
            isThreeSixty: checkIsThreeSixty
        });
    });
    const currentImageData = pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.map((item, index)=>({
            ...item,
            index
        })).find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.assetId) === activeImage || (item === null || item === void 0 ? void 0 : item.url) === activeImage;
    });
    (0,react.useEffect)(()=>{
        let zoomImageClick = null;
        let zoomGallaryAddEventListner;
        if ((iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current) && activeImage && zoomEntryPoint && !zoomGallaryAddEventListner) {
            zoomGallaryAddEventListner = setTimeout(()=>{
                var ref, ref1, ref2, ref3, // Add fullscreen click
                ref4;
                const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                if (zoomInButtonClick) {
                    setTabIndexGallery();
                    zoomInButtonClick.addEventListener("click", (e)=>{
                        var ref, ref1;
                        var ref2;
                        const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
                        !threeSixtyImageClick && zoomInButtonClickAction();
                    }, false);
                }
                (ref1 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref = iframeContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector(".s7button.s7zoomoutbutton")) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", (e)=>{
                    var ref, ref1;
                    var ref2;
                    const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
                    !threeSixtyImageClick && zoomOutButtonClickAction();
                }, false);
                (ref3 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref2 = iframeContainer.current) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".s7button.s7zoomresetbutton")) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("click", zoomResetButtonClickAction, false);
                (ref4 = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref4 === void 0 ? void 0 : ref4.addEventListener("click", zoom360CarasoulFullScreenClickAction, false);
                zoomImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
                if (zoomImageClick) {
                    if (width <= largeIpadSize) {
                        zoomImageClick.addEventListener("touchstart", (ev)=>{
                            setTimeout(function() {
                                zoomImageIconAction();
                            }, 1000);
                        }, false);
                    }
                }
                if (zoomImageClick) {
                    const delta = 6;
                    let startX;
                    let startY;
                    zoomImageClick.addEventListener("mousedown", function(event) {
                        startX = event.pageX;
                        startY = event.pageY;
                        isZoomClick = true;
                    });
                    zoomImageClick.addEventListener("mouseup", function(event) {
                        const diffX = Math.abs(event.pageX - startX);
                        const diffY = Math.abs(event.pageY - startY);
                        isZoomClick = true;
                        if (diffX < delta && diffY < delta) {
                            isZoomClick = false;
                        }
                    });
                    zoomImageClick.addEventListener("click", zoomImageClickAction, false);
                }
            }, 500);
            const silckSliderNext = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".slick-next");
            if (silckSliderNext) {
                silckSliderNext.addEventListener("click", (e)=>{
                    e.preventDefault();
                    addAnalyticsZoomImageSliderArrow({
                        pdpType,
                        zoomEntryPoint,
                        arrowLable: "right",
                        currentImageData,
                        totalImages: pdpImageArrayLength,
                        productInfo: pdpInfo === null || pdpInfo === void 0 ? void 0 : pdpInfo.productInfo,
                        resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId) || null
                    });
                });
            }
            const silckSliderPrev = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".slick-prev");
            if (silckSliderPrev) {
                silckSliderPrev.addEventListener("click", (e)=>{
                    e.preventDefault();
                    addAnalyticsZoomImageSliderArrow({
                        pdpType,
                        zoomEntryPoint,
                        arrowLable: "left",
                        currentImageData,
                        totalImages: pdpImageArrayLength,
                        productInfo: pdpInfo === null || pdpInfo === void 0 ? void 0 : pdpInfo.productInfo,
                        resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId) || ""
                    });
                });
            }
        }
        return ()=>{
            if (zoomGallaryAddEventListner) {
                clearTimeout(zoomGallaryAddEventListner);
                zoomGallaryRemoveEventListner();
            }
        };
    }, [
        iframeContainer,
        zoomEntryPoint,
        activeImage
    ]);
    const zoomGallaryRemoveEventListner = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, // Remove fullscreen click
        ref8;
        (ref1 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref = iframeContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector(".s7zoomview")) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", zoomImageClickAction, false);
        (ref3 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref2 = iframeContainer.current) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".s7button.s7zoominbutton")) === null || ref3 === void 0 ? void 0 : ref3.removeEventListener("click", (e)=>{
            var ref, ref1;
            var ref2;
            const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
            !threeSixtyImageClick && zoomInButtonClickAction();
        }, false);
        (ref5 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref4 = iframeContainer.current) === null || ref4 === void 0 ? void 0 : ref4.querySelector(".s7button.s7zoomoutbutton")) === null || ref5 === void 0 ? void 0 : ref5.removeEventListener("click", (e)=>{
            var ref, ref1;
            var ref2;
            const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
            !threeSixtyImageClick && zoomOutButtonClickAction();
        }, false);
        (ref7 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref6 = iframeContainer.current) === null || ref6 === void 0 ? void 0 : ref6.querySelector(".s7button.s7zoomresetbutton")) === null || ref7 === void 0 ? void 0 : ref7.removeEventListener("click", zoomResetButtonClickAction, false);
        (ref8 = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref8 === void 0 ? void 0 : ref8.removeEventListener("click", zoom360CarasoulFullScreenClickAction, false);
    };
    // 360 zoom icon code start
    (0,react.useEffect)(()=>{
        let threeSixtyAddEventListners;
        if (currentSlide === 1 && (threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current)) {
            threeSixtyAddEventListners = setTimeout(()=>{
                var // Add fullscreen click
                ref, ref1;
                (ref = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref === void 0 ? void 0 : ref.addEventListener("click", zoom360FullScreenClickAction, false);
                (ref1 = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector("#s7viewerGallery")) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", zoomInButton360full, false);
            }, 500);
        }
        return ()=>{
            if (threeSixtyAddEventListners) {
                clearTimeout(threeSixtyAddEventListners);
                threeSixtyRemoveEventListners();
                setIsThreeSixtyRender(false);
            }
        };
    }, [
        currentSlide,
        isThreeSixtyRender
    ]);
    const threeSixtyRemoveEventListners = ()=>{
        var // Remove fullscreen click
        ref, ref1;
        (ref = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", zoom360FullScreenClickAction, false);
        (ref1 = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector("#s7viewerGallery")) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", zoomInButton360full, false);
        clearTimeout(fullScreenTimer);
        clearTimeout(fullScreenTabTimer);
    };
    let counterThreeSixty = 0;
    let counterThreeSixtyZoomOut = 0;
    const zoomInButton360ClickAction = (param)=>{
        let { is360Image =false , isImageGallery =false  } = param;
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        counterThreeSixty++;
        addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint: isImageGallery ? "image gallery" : "image reel",
            zoomAction: "zoom in",
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            counterThreeSixty,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image
        });
    };
    const zoomOut360ButtonClickAction = (param)=>{
        let { is360Image =false , isImageGallery =false  } = param;
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        counterThreeSixtyZoomOut++;
        addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint: isImageGallery ? "image gallery" : "image reel",
            zoomAction: "zoom out",
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            counter: counterThreeSixtyZoomOut,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image
        });
    };
    const zoom360CarasoulSpinnerClickAction = ()=>{
        zoom360SpinnerClickAction(false, true);
    };
    const zoom360SpinnerClickAction = function() {
        let is360Image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, threeSixtyImageClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, spinType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        setTabIndexGallery();
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        addAnalyticsClickZoomSpinnerAndFullscreen({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image,
            buttonType: "spin interaction",
            threeSixtyImageClick,
            spinType
        });
    };
    const zoom360CarasoulFullScreenClickAction = ()=>{
        zoom360FullScreenClickAction(false, true);
    };
    const zoomInButton360full = ()=>{
        if (width <= largeIpadSize) {
            const threeSixtyData = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7container");
            const zoomCursorType = threeSixtyData === null || threeSixtyData === void 0 ? void 0 : threeSixtyData.getAttribute("mode");
            if (zoomCursorType === "fullscreen") {
                document.body.style.overflow = "";
            }
        }
    };
    const zoom360FullScreenClickAction = function() {
        let is360Image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, threeSixtyImageClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref, ref1;
        setTabIndexGallery();
        if (width <= largeIpadSize) {
            fullScreenTimer = setTimeout(function() {
                const threeSixtyData = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7container");
                if (threeSixtyData) {
                    threeSixtyData === null || threeSixtyData === void 0 ? void 0 : threeSixtyData.addEventListener("click", zoomInButton360full, false);
                }
                const zoomCursorType = threeSixtyData === null || threeSixtyData === void 0 ? void 0 : threeSixtyData.getAttribute("mode");
                if (zoomCursorType === "fullscreen") {
                    document.body.classList.add("full-screen-open");
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                } else {
                    document.body.style.overflow = "";
                    document.body.classList.remove("full-screen-open");
                    document.getElementById("s7viewerGallery").innerHTML = "";
                    if (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) {
                        spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0], zoomSpinCBPdp);
                        setIsThreeSixtyRender(true);
                    }
                }
            }, 100);
        }
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        const screenTypeGallary = (ref = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7container")) === null || ref === void 0 ? void 0 : ref.getAttribute("mode");
        const screenTypeMain = (ref1 = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7container")) === null || ref1 === void 0 ? void 0 : ref1.getAttribute("mode");
        let screenType = "";
        if (!is360Image) {
            screenType = screenTypeMain === "normal" ? "full screen" : "minimise";
        } else {
            screenType = screenTypeGallary === "normal" ? "full screen" : "minimise";
        }
        addAnalyticsClickZoomSpinnerAndFullscreen({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image,
            threeSixtyImageClick,
            screenType
        });
    };
    // 360 zoom icon code end
    let counter = 0;
    let zoomOutCounter = 0;
    let fullScreenTabTimer;
    const zoomImageClickAction = (0,react.useCallback)((e)=>{
        const zoomImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
        const cursortype = zoomImageClick === null || zoomImageClick === void 0 ? void 0 : zoomImageClick.getAttribute("cursortype");
        if (width <= largeIpadSize) {
            isZoomClick = false;
        }
        setTimeout(function() {
            setTabIndexGallery();
        }, 1000);
        if (!isZoomClick) {
            setTimeout(function() {
                setTabIndexGallery();
                checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId);
                if (cursortype !== "reset" || cursortype !== "drag") {
                    setTabIndexGallery();
                    if (cursortype === "zoomin") {
                        counter++;
                        addAnalyticsClickZoomImage({
                            pdpType,
                            zoomEntryPoint,
                            zoomAction: "zoom in",
                            currentImageData,
                            totalImages: pdpImageArrayLength,
                            counter,
                            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                            is360Image: false
                        });
                    } else {
                        zoomOutCounter++;
                        addAnalyticsClickZoomImage({
                            pdpType,
                            zoomEntryPoint,
                            zoomAction: "zoom out",
                            currentImageData,
                            totalImages: pdpImageArrayLength,
                            counter: zoomOutCounter,
                            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                            is360Image: false
                        });
                    }
                }
            }, 50);
        }
    });
    const zoomInButtonClickAction = (0,react.useCallback)(()=>{
        const threeSixtyImageClick = false;
        if (width <= largeIpadSize) {
            setTimeout(function() {
                const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
                const zoomCursorType = zoomInImageClick.getAttribute("state");
                if (!threeSixtyImageClick) {
                    if (zoomCursorType === "disabled") {
                        zoomInImageClick.setAttribute("style", "display: none !important");
                        zoomImageOutClick.setAttribute("style", "display: block !important");
                    } else {
                        zoomInImageClick.setAttribute("style", "display: block !important");
                        zoomImageOutClick.setAttribute("style", "display: none !important");
                    }
                }
            }, 1000);
        }
        counter++;
        !threeSixtyImageClick && addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint,
            zoomAction: "zoom in",
            currentImageData,
            totalImages: pdpImageArrayLength,
            counter,
            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
            is360Image: false,
            threeSixtyImageClick
        });
        setTabIndexGallery();
    });
    const zoomOutButtonClickAction = (0,react.useCallback)(()=>{
        zoomOutCounter++;
        const threeSixtyImageClick = false;
        !threeSixtyImageClick && addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint,
            zoomAction: "zoom out",
            currentImageData,
            totalImages: pdpImageArrayLength,
            counter: zoomOutCounter,
            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
            is360Image: false,
            threeSixtyImageClick
        });
        if (width <= largeIpadSize) {
            setTimeout(function() {
                const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
                if (!threeSixtyImageClick) {
                    const zoomCursorType = zoomImageOutClick.getAttribute("state");
                    if (zoomCursorType === "disabled") {
                        zoomInImageClick.setAttribute("style", "display: block !important");
                        zoomImageOutClick.setAttribute("style", "display: none !important");
                    } else {
                        zoomInImageClick.setAttribute("style", "display: none !important");
                        zoomImageOutClick.setAttribute("style", "display: block !important");
                    }
                }
            }, 1000);
        }
    });
    const zoomResetButtonClickAction = (0,react.useCallback)((e)=>{
        var ref, ref1;
        counter = 0;
        zoomOutCounter = 0;
        var ref2;
        const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
        !threeSixtyImageClick && addAnalyticsClickZoomReset({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpImageArrayLength,
            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
            is360Image: false,
            threeSixtyImageClick
        });
    });
    const lastTabIndex = 0;
    let currentIndex = 90;
    const handleKey = ()=>{
        window.addEventListener("focusin", function() {
            currentIndex = document.activeElement.tabIndex;
        }, true);
        let curIndex = currentIndex;
        if (curIndex === lastTabIndex) {
            curIndex = 90;
        }
        const tabbables = document.querySelectorAll(".image-overlay");
        for(let i = 0; i < tabbables.length; i++){
            if (tabbables[i].tabIndex === curIndex) {
                tabbables[i].focus();
                break;
            }
        }
    };
    const setTabIndexGallery = ()=>{
        fullScreenTabTimer = setTimeout(function() {
            const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
            const zoomOutButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomoutbutton");
            const zoomResetButton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomresetbutton");
            const zoomLeftArrow = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7panleftbutton");
            const zoomRightArrow = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7panrightbutton");
            const zooms7fullscreenbutton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7fullscreenbutton");
            if (zoomInButtonClick) {
                zoomInButtonClick.setAttribute("tabindex", "96");
                zoomOutButtonClick.setAttribute("tabindex", "97");
                zoomResetButton.setAttribute("tabindex", "98");
            }
            if (zoomLeftArrow || zoomRightArrow) {
                zoomLeftArrow.setAttribute("tabindex", "98");
                zoomRightArrow.setAttribute("tabindex", "98");
            }
            if (zooms7fullscreenbutton) {
                zooms7fullscreenbutton.setAttribute("tabindex", "98");
            }
        }, 100);
    };
    const zoomImageIconAction = ()=>{
        const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
        const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
        const zoomCursorType = zoomInImageClick.getAttribute("state");
        if (zoomCursorType === "disabled") {
            zoomOutCounter++;
            addAnalyticsClickZoomImage({
                pdpType,
                zoomEntryPoint,
                zoomAction: "zoom out",
                currentImageData,
                totalImages: pdpImageArrayLength,
                counter: zoomOutCounter,
                resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                is360Image: false
            });
            zoomInImageClick.setAttribute("style", "display: none !important");
            zoomImageOutClick.setAttribute("style", "display: block !important");
        } else {
            counter++;
            addAnalyticsClickZoomImage({
                pdpType,
                zoomEntryPoint,
                zoomAction: "zoom in",
                currentImageData,
                totalImages: pdpImageArrayLength,
                counter,
                resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                is360Image: false
            });
            zoomInImageClick.setAttribute("style", "display: block !important");
            zoomImageOutClick.setAttribute("style", "display: none !important");
        }
    };
    const checkImageResoruceType = function() {
        let assetId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if ((productImagesWithUrls === null || productImagesWithUrls === void 0 ? void 0 : productImagesWithUrls.length) > 0) {
            var ref, ref1, ref2;
            return (ref2 = (ref1 = (ref = productImagesWithUrls.filter((img)=>{
                return img.includes(assetId);
            })) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.split("|")) === null || ref2 === void 0 ? void 0 : ref2[2];
        }
    };
    const pdpThumbnailAnyltics = function(element) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var ref;
        setActiveIndex(i);
        setThumbnailClicked(true);
        if ((element === null || element === void 0 ? void 0 : element.assetId) || (element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0])) {
            var ref1, ref2;
            const resourceType = (element === null || element === void 0 ? void 0 : (ref1 = element.resourceName) === null || ref1 === void 0 ? void 0 : ref1[0]) ? element === null || element === void 0 ? void 0 : (ref2 = element.resourceTypeImg) === null || ref2 === void 0 ? void 0 : ref2[0] : checkImageResoruceType(element === null || element === void 0 ? void 0 : element.assetId);
            addPdpThumbnailAnylticsClick({
                pdpImageInfo: element,
                totalImages: pdpImageArrayLength,
                pdpType,
                currentIndex: i + 1,
                resourceType: resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase()
            });
        }
    };
    const render360Image = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-image-reel__image-display",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "s7viewerGallery"
            })
        }, "gallery-zoom-image-360-product");
    };
    (0,react.useEffect)(()=>{
        const timerSpin360PdpGallery = setTimeout(()=>{
            if (resourceName) {
                spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]);
            }
        }, 100);
        return ()=>{
            clearTimeout(timerSpin360PdpGallery);
        };
    }, [
        resourceName
    ]);
    const renderTotalImages = ()=>{
        return data && pdpCustomImagesArray && totalImages ? pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.map((element, i)=>{
            var ref, ref1;
            const isVideo = element.type === "video";
            const resourceImageName = element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0];
            const resourceImgFullWebUrl = element === null || element === void 0 ? void 0 : (ref1 = element.resourceFullWebUrl) === null || ref1 === void 0 ? void 0 : ref1[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                elementid: element.assetId,
                id: i,
                className: "pdp-image-reel__image-list ".concat(resourceImageName && resourceImgFullWebUrl ? "noSwiping swiper-no-swiping" : "", "  "),
                role: "listitem",
                "aria-label": element === null || element === void 0 ? void 0 : element.label,
                onClick: ()=>{
                    return !isVideo ? openImageZoom(element.assetId, i, element === null || element === void 0 ? void 0 : element.label, element) : imageZoomMobileVideoClick(element.url, i);
                },
                children: [
                    resourceImageName && resourceImgFullWebUrl ? render360Image() : null,
                    !element.type && !resourceImageName && !resourceImgFullWebUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-image-reel__image-display",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                onError: (e)=>{
                                    return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                },
                                src: (0,helper/* appendPresetToUrl */.QCk)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                alt: element.label,
                                tabIndex: "0",
                                className: "".concat(i === 0 ? "print" : "no-print")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: tap_image_zoom === null || tap_image_zoom === void 0 ? void 0 : tap_image_zoom.src,
                                alt: element.label,
                                tabIndex: "0",
                                className: "tap-image-zoom"
                            })
                        ]
                    }, "gallery-zoom-image-".concat(element.assetId)) : !resourceImgFullWebUrl && !resourceImageName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-video-wrapper",
                        id: "pdpVideos",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "pdp-video",
                            children: width < 971 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoWrapper, {
                                thumb: true,
                                alt: element.label,
                                videoId: element.url,
                                imageSequence: imageSequence,
                                playThumb: width < largeIpadSize && !isModel,
                                width: "100%",
                                height: "350",
                                getVideoInfo: getVideoInfo,
                                zoomEntryPoint: zoomEntryPoint
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoWrapper, {
                                videoId: element.url,
                                width: "100%",
                                height: "350",
                                index: i + 1,
                                totalPdpImages: pdpImageArrayLength,
                                anyliticsText: "main",
                                zoomEntryPoint: zoomEntryPoint
                            })
                        })
                    }, "gallery-zoom-image-".concat(element.url)) : ""
                ]
            }, "gallery-zoom-image-".concat(i));
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "pdp-image-reel__image-list",
            onClick: ()=>openImageZoom(initialImgUrl),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-image-reel__image-display",
                children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    role: "img",
                    src: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")),
                    alt: initialImgAlt,
                    tabIndex: "0",
                    className: "print"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "shimmer-loading__para shimmer height-400"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-overlay ".concat(zoomVideoId ? "video-open" : ""),
                id: "imageoverlay",
                tabIndex: 90,
                role: "dialog",
                "aria-labelledby": "gallery-pdp",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "close-zoom-image",
                        onClick: closeZoomImageClick,
                        tabIndex: 91,
                        role: "dialog",
                        "aria-labelledby": "close",
                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.closeZoomImageModel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: zoom_close_icon === null || zoom_close_icon === void 0 ? void 0 : zoom_close_icon.src,
                            role: "button",
                            alt: "close",
                            tabIndex: 152
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "popup-content",
                        tabIndex: 93,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "iframe-container",
                            ref: iframeContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "s7viewer",
                                    tabIndex: 99
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "s7viewerSpinThreeSixty",
                                    tabIndex: 99
                                }),
                                zoomVideoId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "zoom-video",
                                    id: "zoomVideo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoWrapper, {
                                        videoId: zoomVideoId,
                                        width: "100%",
                                        playVideoClick: true,
                                        index: currentVideoId,
                                        totalPdpImages: pdpImageArrayLength,
                                        zoomEntryPoint: zoomEntryPoint,
                                        getVideoInfo: getVideoInfo
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "gallery",
                                    id: "gallery-pdp",
                                    tabIndex: 150,
                                    role: "dialog",
                                    "aria-labelledby": "myLargeModalLabel3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                        ...getSlickSettings(width),
                                        ref: (ref)=>slickRef.current = ref,
                                        tabIndex: 151,
                                        children: data && pdpCustomImagesArray && pdpImageArrayLength ? pdpCustomImagesArray.map((element, i)=>{
                                            var ref, ref1, ref2, ref3;
                                            const resourcePdpImageName = (element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0]) || "";
                                            const resourcePdpImageUrl = (element === null || element === void 0 ? void 0 : (ref1 = element.resourceFullWebUrl) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
                                            const resourcePdpImageAlt = (element === null || element === void 0 ? void 0 : (ref2 = element.resourceAltText) === null || ref2 === void 0 ? void 0 : ref2[0]) || "";
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "image-wrapper ".concat((element === null || element === void 0 ? void 0 : element.assetId) === activeImage || resourcePdpImageName === activeImage ? "imageActive " : "", " \n                          ").concat(resourcePdpImageUrl && resourcePdpImageName ? "overlay-image-360 " : "", "\n                          ").concat((element === null || element === void 0 ? void 0 : element.assetId) === activeImage && threeSixtyZoomClick || resourcePdpImageName === activeImage && !threeSixtyZoomClick ? "remove-border " : "", "\n                          "),
                                                    children: resourcePdpImageUrl && resourcePdpImageName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "zoom-three-sixty",
                                                        onClick: ()=>threeSixtyOpen(resourcePdpImageName, resourcePdpImageAlt, i),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                role: "img",
                                                                src: resourcePdpImageUrl,
                                                                alt: resourcePdpImageAlt,
                                                                width: 60,
                                                                height: 60
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "zoom-video-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: _360_spin_overlay === null || _360_spin_overlay === void 0 ? void 0 : _360_spin_overlay.src,
                                                                    alt: resourcePdpImageAlt || (pdpInfo === null || pdpInfo === void 0 ? void 0 : (ref3 = pdpInfo.productInfo) === null || ref3 === void 0 ? void 0 : ref3.description),
                                                                    tabIndex: "10 ".concat(+i)
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        role: "img",
                                                        src: (0,helper/* appendPresetToUrl */.QCk)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                                        alt: element.label,
                                                        width: 60,
                                                        height: 60,
                                                        tabIndex: "10".concat(+i),
                                                        onClick: ()=>{
                                                            return imageZoomClick(element.assetId, i, element === null || element === void 0 ? void 0 : element.label);
                                                        }
                                                    })
                                                }, "zoom-image-".concat(i)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    onClick: ()=>imageZoomVideoClick(element.url, i),
                                                    className: "image-wrapper zoom-video-section ".concat(element.url === activeImage ? "imageActive" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoWrapper, {
                                                            thumb: true,
                                                            videoId: element.url,
                                                            getVideoInfo: getVideoInfo,
                                                            index: i,
                                                            totalPdpImages: pdpImageArrayLength,
                                                            zoomEntryPoint: zoomEntryPoint
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "zoom-video-icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: zoom_video_icon === null || zoom_video_icon === void 0 ? void 0 : zoom_video_icon.src,
                                                                alt: "zoom video",
                                                                tabIndex: 110 + i
                                                            })
                                                        })
                                                    ]
                                                }, "zoom-video-".concat(i))
                                            });
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-wrapper imageActive",
                                            children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                role: "button",
                                                src: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")),
                                                alt: initialImgAlt,
                                                tabIndex: "105",
                                                className: "print",
                                                onClick: ()=>imageZoomClick(initialImgUrl, 0, initialImgAlt)
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__para shimmer height-400"
                                            })
                                        })
                                    }, "slider-zoom-gallery")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-image-reel ".concat(pdpImageArrayLength && pdpImageArrayLength <= 1 ? "full-image-pdp " : "", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-thumbnail-vertical ".concat(pdpImageArrayLength && pdpImageArrayLength <= 1 ? "hide-slider " : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                onSlideChange: (swiper)=>beforeChangeHandlerFilmStrip(swiper),
                                direction: width >= largeIpadSize ? "vertical" : "horizontal",
                                slideToClickedSlide: true,
                                focusableElements: true,
                                slidesPerView: width >= largeIpadSize ? 6 : "auto",
                                spaceBetween: width >= largeIpadSize ? "15px" : "20px",
                                freeMode: true,
                                watchSlidesProgress: true,
                                className: "slider-pdp-thumbnail",
                                onSwiper: setThumbsSwiper,
                                keyboard: true,
                                mousewheel: true,
                                modules: [
                                    swiper_esm/* Navigation */.W_,
                                    swiper_esm/* Keyboard */.N1,
                                    swiper_esm/* A11y */.s5,
                                    swiper_esm/* FreeMode */.Rv
                                ],
                                a11y: {
                                    enabled: true
                                },
                                ref: swiperThumbRef,
                                scrollbar: width >= 1024 ? false : {
                                    draggable: true
                                },
                                roundLengths: true,
                                shouldSwiperUpdate: true,
                                children: data && pdpCustomImagesArray && pdpImageArrayLength ? pdpCustomImagesArray.map((element, i)=>{
                                    var ref, ref1, ref2, ref3;
                                    const resourcePdpImageName = (element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0]) || "";
                                    const resourcePdpImageUrl = (element === null || element === void 0 ? void 0 : (ref1 = element.resourceFullWebUrl) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
                                    const resourcePdpImageAlt = (element === null || element === void 0 ? void 0 : (ref2 = element.resourceAltText) === null || ref2 === void 0 ? void 0 : ref2[0]) || "";
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            virtualIndex: i,
                                            className: "image-wrapper ".concat(activeIndex === i ? "imageActiveThumb" : "", " ").concat(resourcePdpImageUrl && resourcePdpImageName ? "overlay-image-360" : ""),
                                            onClick: (event)=>pdpThumbnailAnyltics(element, i, event),
                                            children: resourcePdpImageUrl && resourcePdpImageName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        role: "img",
                                                        src: resourcePdpImageUrl,
                                                        alt: resourcePdpImageAlt,
                                                        width: 60,
                                                        height: 60,
                                                        tabIndex: "0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "zoom-video-icon",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: _360_spin_overlay === null || _360_spin_overlay === void 0 ? void 0 : _360_spin_overlay.src,
                                                            alt: pdpInfo === null || pdpInfo === void 0 ? void 0 : (ref3 = pdpInfo.productInfo) === null || ref3 === void 0 ? void 0 : ref3.description,
                                                            tabIndex: "10 ".concat(+i)
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                role: "img",
                                                src: (0,helper/* appendPresetToUrl */.QCk)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                                alt: element === null || element === void 0 ? void 0 : element.label,
                                                width: 60,
                                                height: 60
                                            })
                                        }, "zoom-image-".concat(element === null || element === void 0 ? void 0 : element.assetId)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                            onClick: ()=>imageZoomVideoClick(element.url, i),
                                            className: "image-wrapper zoom-video-section".concat(activeIndex === i ? " imageActiveThumb" : "", " "),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoWrapper, {
                                                    thumb: true,
                                                    videoId: element.url,
                                                    getVideoInfo: getVideoInfo,
                                                    index: i,
                                                    tabIndex: "0",
                                                    totalPdpImages: pdpImageArrayLength,
                                                    zoomEntryPoint: zoomEntryPoint
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "zoom-video-icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: play_button_overlay === null || play_button_overlay === void 0 ? void 0 : play_button_overlay.src,
                                                        alt: "pdp video"
                                                    })
                                                })
                                            ]
                                        }, "zoom-video-".concat(i))
                                    });
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "image-wrapper ",
                                    children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        role: "button",
                                        src: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")),
                                        alt: initialImgAlt
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__para shimmer height-400"
                                    })
                                })
                            }, "slider-pdp-thumbnail"),
                            pdpImageArrayLength && pdpImageArrayLength > 6 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-gallery-view",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "gallery-image-number",
                                    tabIndex: "0",
                                    onClick: ()=>viewGalleryImageClick(firstImageForZoom),
                                    children: [
                                        "+",
                                        pdpImageArrayLength - 6
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-image-reel__image-stack-view  ".concat(pdpImageArrayLength && pdpImageArrayLength <= 1 ? "full-image-width " : "").concat(width < largeIpadSize ? " pdp-image-reel__slider-container" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "pl-0 list-inline pdp-image-reel__image-stack-list ".concat((resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0]) ? "three-sixty-image-pdp-gallery" : ""),
                            role: "list",
                            id: galleryStackId,
                            ref: threeSixtyIframeContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                modules: [
                                    swiper_esm/* Navigation */.W_,
                                    swiper_esm/* Keyboard */.N1,
                                    swiper_esm/* A11y */.s5
                                ],
                                navigation: true,
                                slidesPerView: 1,
                                onSlideChange: (swiper)=>beforeChangeHandler(swiper),
                                thumbs: {
                                    swiper: thumbsSwiper
                                },
                                focusableElements: false,
                                keyboard: true,
                                className: "slider-pdp",
                                a11y: {
                                    enabled: true
                                },
                                ref: swiperPdpRef,
                                children: renderTotalImages()
                            }, "pdpSliderKey")
                        })
                    })
                ]
            }),
            resourceCredits ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pdp-image-reel__photo-credit",
                children: resourceCredits
            }) : null
        ]
    });
};
ImageReel.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object,
    productInfo: (prop_types_default()).string,
    updateImageClickCounter: (prop_types_default()).func,
    imageClickCounter: (prop_types_default()).number,
    threeSixtyResourceData: (prop_types_default()).object
};
/* harmony default export */ var v2_ImageReel = (ImageReel);

;// CONCATENATED MODULE: ./components/ImageGallery/v2/ImageGallery.jsx





const ImageGallery = (props)=>{
    const [showModal, setShowModal] = (0,react.useState)(null);
    const viewBtnRef = (0,react.useRef)();
    const { page ="" , productInfo ={} , initialImgAlt ="" , initialImgUrl ="" , pdpDesktopImage ="" , productImagesWithResourceTypes ={} , threeSixtyResourceData ={} , clickedProductVariant =false  } = props;
    (0,react.useEffect)(()=>{
        (0,helper/* preventBodyScroll */.MVu)(showModal);
        if (showModal) document.body.classList.add("image-gallery-modal-opened");
        else if (showModal === false) {
            document.body.classList.remove("scroll-lock", "image-gallery-modal-opened");
            viewBtnRef.current.focus();
        }
    }, [
        showModal
    ]);
    const handleModalPopup = ()=>{
        setShowModal(true);
    };
    const onModalClose = ()=>{
        setShowModal(false);
    };
    const isHorizontalView = window.innerWidth < 1024;
    const eventInfo = JSON.stringify({
        eventAction: page + ":modal:gallery:close",
        eventName: page + "modal:gallery:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:gallery",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ImageReel, {
                viewBtnRef: viewBtnRef,
                isHorizontal: isHorizontalView,
                ...props,
                initialImgAlt: initialImgAlt,
                initialImgUrl: initialImgUrl,
                pdpDesktopImage: pdpDesktopImage,
                handlePopup: handleModalPopup,
                galleryStackId: "image-gallery__image-stack-gallery",
                productImagesWithUrls: productImagesWithResourceTypes,
                threeSixtyResourceData: threeSixtyResourceData,
                clickedProductVariant: clickedProductVariant
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                onModalClose: onModalClose,
                showModal: showModal,
                closeButtonAnalytics: eventInfo,
                analyticsCustomData: productInfo || null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-image-gallery-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ImageReel, {
                        viewBtnRef: viewBtnRef,
                        isPopup: true,
                        isHorizontal: true,
                        isModel: true,
                        ...props,
                        handlePopup: handleModalPopup,
                        galleryStackId: "image-gallery__image-stack-kohler",
                        clickedProductVariant: clickedProductVariant
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v2_ImageGallery = (ImageGallery);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription/utils.js

const getBundleIncludedItems = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { currencyCode , items =[] , ctData , projectionData =[] , persona  } = data;
    const sitePersona = persona;
    const { masterVariant: { attributes =[]  } = {}  } = ctData;
    return items.map((el)=>{
        var ref, ref1, ref2, ref3, ref4;
        const { sku_s: sku = "" , slug_s: slug = "" , productName_s: name = "" , ColorFinish_s: color = "" , ProductDescriptionProductShort_s: desc = "" , ProductLocalCategory_s: category = "" , ProductBrandNameDisplay_t: collection = "" , category1_s: productRoom = "" , ["productImages.labelWithUrl_ss"]: productImages , ["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]: specPDFFiles , ["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]: installGuides , ProductWebFeatures_ss: productFeatures = [] , ["priceList.".concat(sitePersona, ".price_d")]: priceDiscount = 0 , ["priceList.".concat(sitePersona, ".finalPrice_d")]: finalPriceDiscount = 0 , ["priceList.".concat(sitePersona, ".discountedPrice_d")]: discountedPriceFinal = 0 , ["priceList.".concat(sitePersona, ".saleOffer_s")]: saleOffer = 0 , ["priceStartingAt.".concat(sitePersona, "_d")]: priceStart = 0  } = el;
        var ref5;
        const imageUrls = (ref5 = (ref1 = (ref = productImages.find((e)=>e.startsWith(sku))) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.find((im)=>im.startsWith("http"))) !== null && ref5 !== void 0 ? ref5 : "";
        var ref6;
        const { value: productsData = []  } = (ref6 = attributes.find((e)=>e.name === "products")) !== null && ref6 !== void 0 ? ref6 : {};
        var ref7;
        const currentSkuCtData = (ref7 = productsData.find((pd)=>{
            return pd.find((vl)=>vl.value === sku);
        })) !== null && ref7 !== void 0 ? ref7 : [];
        var ref8;
        const { variants =[]  } = (ref8 = projectionData.find((pj)=>{
            return pj.variants.find((ve)=>ve.sku === sku);
        })) !== null && ref8 !== void 0 ? ref8 : {};
        var ref9;
        const { prices: variantsPrices = []  } = (ref9 = variants.find((e)=>e.sku === sku)) !== null && ref9 !== void 0 ? ref9 : {};
        var ref10;
        const { masterVariant: { prices: masterPrices  } = {}  } = (ref10 = projectionData.find((e)=>e.masterVariant.sku === sku)) !== null && ref10 !== void 0 ? ref10 : {};
        const prices = masterPrices ? masterPrices : variantsPrices;
        const persona = (0,helper/* getUserPersona */.shu)();
        let productPrice = prices === null || prices === void 0 ? void 0 : prices.find((price)=>{
            var ref, ref1, ref2;
            return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
        });
        if (!(productPrice === null || productPrice === void 0 ? void 0 : productPrice.value)) {
            productPrice = prices === null || prices === void 0 ? void 0 : prices.find((price)=>{
                var ref;
                return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
            });
        }
        var ref11;
        const unitPrice = Number((((ref11 = productPrice === null || productPrice === void 0 ? void 0 : (ref2 = productPrice.value) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref11 !== void 0 ? ref11 : 0) / 100).toFixed(2));
        var ref12;
        const discountedPrice = Number((((ref12 = productPrice === null || productPrice === void 0 ? void 0 : (ref3 = productPrice.discounted) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.centAmount) !== null && ref12 !== void 0 ? ref12 : 0) / 100).toFixed(2));
        let newData = {};
        currentSkuCtData.forEach((element)=>{
            const { name ="" , value  } = element;
            newData = {
                ...newData,
                [name]: value
            };
        });
        const { quantity  } = newData;
        return {
            name,
            desc,
            sku,
            category,
            productRoom,
            collection,
            image: imageUrls,
            color,
            slug,
            productFeatures,
            specPDFFiles,
            installGuides,
            quantity,
            unitPrice,
            discountedPrice,
            priceDiscount,
            finalPriceDiscount,
            discountedPriceFinal,
            saleOffer,
            priceStart
        };
    });
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/analytics.js
var analytics = __webpack_require__(3155);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/analytics/analytics.js + 1 modules
var analytics_analytics = __webpack_require__(85660);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.jsx + 1 modules
var Accordion = __webpack_require__(51952);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/ListPrice.jsx
var ListPrice = __webpack_require__(65670);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/SwatchList.jsx
var SwatchList = __webpack_require__(63426);
// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/SuperSkuOption/utils.js

const getAvailableOptions = (data)=>{
    var ref;
    const { availableOptions ={} , option ="" , field =""  } = data;
    return !((ref = availableOptions[field]) === null || ref === void 0 ? void 0 : ref.includes(option));
};
const formatFacetName = (data)=>{
    const { field ="" , facetLabels ={}  } = data;
    if (facetLabels && facetLabels[field]) {
        return facetLabels[field];
    }
    return field.replace(/\./g, "/").replace(/_/g, " ");
};
const checkFacetData = (facet)=>{
    return facet && facet[0] && facet[1] && facet[1].length;
};
const isMatchWithCurrent = (data)=>{
    const { obj , currOptions , currentKey , optionKeys  } = data;
    const isData = [];
    Object.entries(obj).forEach((param)=>{
        let [key, val] = param;
        if (optionKeys.includes(key) && key !== currentKey) {
            isData.push(currOptions[key] === val);
        }
    });
    return !isData.includes(false);
};
const getAvailableOptionsFields = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { options: optionsObjData = {} , currOptions ={} , variantOptions =[]  } = data;
    const excludeCurrent = variantOptions;
    const options = Object.fromEntries(Object.entries(optionsObjData).map((param)=>{
        let [key, val] = param;
        return [
            key,
            val.filter((e)=>(0,utils_0/* isString */.HD)(e))
        ];
    }));
    const optionKeys = Object.keys(options);
    const removeValue = {};
    Object.entries(options).forEach((param)=>{
        let [key, values = []] = param;
        values.forEach((el)=>{
            const isExit = currOptions[key] === el;
            if (!isExit) {
                const exData = excludeCurrent.filter((e)=>e[key] === el);
                exData.forEach((obj)=>{
                    const isMatched = isMatchWithCurrent({
                        obj,
                        currOptions,
                        currentKey: key,
                        optionKeys
                    });
                    Object.entries(obj).forEach((param)=>{
                        let [objKey, objVal] = param;
                        if (optionKeys.includes(objKey)) {
                            if (isMatched || currOptions[objKey] === objVal) {
                                if (removeValue[objKey]) {
                                    removeValue[objKey].push(objVal);
                                } else {
                                    removeValue[objKey] = [
                                        objVal
                                    ];
                                }
                            }
                        }
                    });
                });
            }
        });
    });
    return removeValue;
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/SuperSkuOption/index.module.scss
var index_module = __webpack_require__(13642);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/SuperSkuOption/SuperSkuOptionButton.jsx



const SuperSkuOptionButton = (props)=>{
    const { option , isActive , disabled , onClick  } = props;
    const selectedClass = isActive ? (index_module_default()).activeBttn : disabled ? (index_module_default()).disabledBttn : "";
    const classButton = "".concat((index_module_default()).superSkuOptionButton, " ").concat(selectedClass, " ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        disabled: disabled,
        className: classButton,
        onClick: ()=>onClick(option),
        children: option
    });
};
/* harmony default export */ var SuperSkuOption_SuperSkuOptionButton = (SuperSkuOptionButton);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/SuperSkuOption/SuperSkuOptionSetButtons.jsx





const SuperSkuOptionSetButtons = (props)=>{
    const { field ="" , data =[] , value ="" , onChange =()=>{} , availableOptions  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).superSkuOptionSet,
        children: data.map((option)=>{
            const isActive = value === option;
            const disabled = getAvailableOptions({
                availableOptions,
                option,
                field
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuperSkuOption_SuperSkuOptionButton, {
                option: option,
                isActive: isActive,
                onClick: onChange,
                disabled: disabled
            }, "".concat(field, "-").concat(option));
        })
    });
};
/* harmony default export */ var SuperSkuOption_SuperSkuOptionSetButtons = (SuperSkuOptionSetButtons);

;// CONCATENATED MODULE: ./public/icons/super-sku-tooltip.svg
/* harmony default export */ var super_sku_tooltip = ({"src":"/_next/static/media/super-sku-tooltip.1926f324.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./components/ProductDetail/v3/SuperSkuOption/index.jsx









const SuperSkuOption = (props)=>{
    const { i18n ={} , options ={} , tooltipdata ={} , curroptions: currOptions = {} , selectoption , className ="" , variantOptions , facetLabels , selectMoreTooltipHandler  } = props;
    const [isActive, setIsActive] = (0,react.useState)("");
    const handleChange = (value, facet, dropdownName)=>{
        if (value !== currOptions[facet]) {
            selectoption(value, facet, dropdownName);
        }
    };
    const handleTooltipMouseOver = (e, title, tooltipContent)=>{
        const { target: { className  }  } = e;
        if (className) setIsActive(e.target.className);
        const mouseoverTitle = (title + " mouseover").toLowerCase();
        selectMoreTooltipHandler(mouseoverTitle, false, tooltipContent);
    };
    const availableOptions = getAvailableOptionsFields({
        options,
        currOptions,
        variantOptions
    });
    const showSuperSku = ()=>{
        if (!options) return false;
        return Object.entries(options).some((facet)=>{
            const [, facetValues = []] = facet;
            const values = facetValues === null || facetValues === void 0 ? void 0 : facetValues.filter((e)=>(0,utils_0/* isString */.HD)(e));
            return checkFacetData(facet) && (values === null || values === void 0 ? void 0 : values.length) > 1;
        });
    };
    const styleClass = showSuperSku() ? classnames_default()("options-selector", className) : "hide-options";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).superSkuOption,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: styleClass,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "options-selector__options",
                children: Object.entries(options).map((facet, i)=>{
                    var ref;
                    const [field = "", facetValues = []] = facet;
                    const values = facetValues.filter((e)=>(0,utils_0/* isString */.HD)(e));
                    const value = (ref = currOptions[field]) === null || ref === void 0 ? void 0 : ref.toString();
                    const isShowOption = values.length > 1;
                    if (checkFacetData(facet) && isShowOption) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "options-selector__option",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "options-selector__heading",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: formatFacetName({
                                                field,
                                                facetLabels
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            tabIndex: 0,
                                            src: super_sku_tooltip === null || super_sku_tooltip === void 0 ? void 0 : super_sku_tooltip.src,
                                            alt: i18n.toolTip,
                                            className: facet[0],
                                            onMouseLeave: (e)=>e.target.className ? setIsActive("") : "",
                                            onMouseOver: (e)=>handleTooltipMouseOver(e, formatFacetName({
                                                    field,
                                                    facetLabels
                                                }), tooltipdata[facet[0]]),
                                            onFocus: (e)=>e.target.className ? setIsActive(e.target.className) : "",
                                            onBlur: (e)=>e.target.className ? setIsActive("") : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "selectedSpanValue",
                                            children: value
                                        }),
                                        isActive === field && Object.prototype.hasOwnProperty.call(tooltipdata, field) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                            message: tooltipdata[field]
                                        }) : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuperSkuOption_SuperSkuOptionSetButtons, {
                                    field: field,
                                    data: values,
                                    variantOptions: variantOptions,
                                    value: value,
                                    availableOptions: availableOptions,
                                    onChange: (val)=>handleChange(val, field, formatFacetName({
                                            field,
                                            facetLabels
                                        }))
                                })
                            ]
                        }, i);
                    }
                })
            })
        })
    });
};
/* harmony default export */ var v3_SuperSkuOption = (SuperSkuOption);

// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPRequiredItemModal/PDPRequiredItemModalAnalytics.js
const getEventInfo = function(type) {
    let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pagetitle = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
    const eventInfo = {
        eventAction: "".concat(pagetitle, ":select a product required for installation:").concat(type),
        eventName: "".concat(pagetitle, ":select a product required for installation:").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "items required for install",
        internalLinkType: "".concat(pagetitle, ":select a product required for installation:").concat(type),
        internalLinkZoneName: "".concat(pagetitle, ":select a product required for installation"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const pushAnalyticsData = (title, productInfoObj)=>{
    var ref;
    const eventInfo = getEventInfo(title, true);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfo = productInfoObj ? (ref = JSON.parse(productInfoObj)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};

// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
// EXTERNAL MODULE: ./components/core/ColorSwatch/ColorSwatch.jsx
var ColorSwatch = __webpack_require__(32982);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPRequiredItem/index.jsx
/* provided dependency */ var process = __webpack_require__(83454);











const PDPRequiredItem = (props)=>{
    var ref;
    const { item ={} , addItemsData =[] , productInfo ={} , staticTexts ={} , colorId ="" , cart ={} , locale ="" , currencyCode ="" , backorder ="" , currencySign ="" , updateItems =()=>{} , isKohlerCanada =false  } = props;
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [selectedSkuItem, setSelectedSkuItem] = (0,react.useState)(item === null || item === void 0 ? void 0 : (ref = item.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
    const persona = (0,helper/* getUserPersona */.shu)();
    const isMobile = window.innerWidth <= 480;
    const requiredProductsData = [];
    let colorsDataMaster = [];
    const colorsDataVariants = [];
    let imagesDataMaster = [];
    const imagesDataVariants = [];
    let priceOfMaster = [];
    const priceOfVariants = [];
    let category = "";
    let slug = "";
    let customerFacingSKUMaster = [];
    const customerFacingSKUVariant = [];
    if (item) {
        var ref1;
        const product = {};
        const masterVariant = get_default()(item, "masterVariant", []);
        const variants = get_default()(item, "variants", []);
        const masterVariantSku = get_default()(masterVariant, "sku", "");
        slug = get_default()(item, 'slug["en-US"]', "");
        product.skuid = selectedSkuItem;
        product.masterVariantSku = masterVariantSku;
        const masterAttributes = get_default()(masterVariant, "attributes", []);
        customerFacingSKUMaster = [
            {
                id: masterVariantSku,
                CustomerFacingSKU: get_default()(masterAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "")
            }
        ];
        const masterColorName = get_default()(masterAttributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), "");
        const masterColorFiles = get_default()(masterAttributes.find((attr)=>attr.name === "SKUColorSwatchFilename"), "value", "");
        product.brandName = get_default()(masterVariant.attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
        product.productName = get_default()(masterVariant.attributes.find((attr)=>attr.name === "RegionBrandName"), "value", "");
        product.productDescription = get_default()(masterVariant.attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), "");
        imagesDataMaster = [
            {
                id: masterVariantSku,
                image: masterVariant.images.length > 0 ? get_default()(masterVariant, "images[0].url", "") : image_missing/* default */.Z
            }
        ];
        category = (0,helper/* getAttributeValue */.kDl)(masterAttributes, "ProductLocalCategory");
        priceOfMaster = [
            {
                id: masterVariantSku,
                price: (Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "value.centAmount", 0)) / 100).toFixed(2),
                discountedPrice: (Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "discounted.value.centAmount", 0)) / 100).toFixed(2),
                discountPercent: Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.permyriad", 0)) / 100,
                discountType: get_default()(masterVariant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.type", "")
            }
        ];
        if (!masterVariant.prices.find((item)=>{
            var ref, ref1, ref2;
            return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
        })) {
            priceOfMaster[0].price = (Number(get_default()(masterVariant.prices.find((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
            }), "value.centAmount", 0)) / 100).toFixed(2);
        }
        var ref2;
        const cartMasterVar = (ref2 = cart === null || cart === void 0 ? void 0 : (ref1 = cart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.variant.sku) === masterVariantSku;
        })) !== null && ref2 !== void 0 ? ref2 : {};
        if (cartMasterVar === null || cartMasterVar === void 0 ? void 0 : cartMasterVar.discountedPrice) {
            priceOfMaster[0].discountedPrice = (Number(get_default()(cartMasterVar.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
            priceOfMaster[0].discountType = get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
            priceOfMaster[0].discountPercent = priceOfMaster[0].discountType === "absolute" ? Number(get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
        }
        let OutOfStockMaster;
        const channels = Object.values(get_default()(masterVariant.availability, "channels", {}));
        if (channels.length > 0) {
            var ref3, ref4, ref5;
            const availableQtyMaster = ((ref5 = masterVariant === null || masterVariant === void 0 ? void 0 : (ref3 = masterVariant.availability) === null || ref3 === void 0 ? void 0 : ref3.channels[process === null || process === void 0 ? void 0 : (ref4 = process.env) === null || ref4 === void 0 ? void 0 : "eb939fc2-53eb-49d4-ac24-ba60d0345a93"]) === null || ref5 === void 0 ? void 0 : ref5.availableQuantity) || 0;
            OutOfStockMaster = availableQtyMaster > 0 ? false : true;
        }
        const getDiscontinuedValue = get_default()(masterAttributes.find((attr)=>attr.name === "RegionDiscontinuedDate"), "value", "");
        const discontinuedMasterVariant = Date.parse(getDiscontinuedValue) < Date.now();
        colorsDataMaster = [
            {
                id: masterVariantSku,
                name: "product-color-".concat(colorId),
                value: masterVariantSku,
                label: masterColorName,
                colorUrl: constants["default"].COLOR_FILE_URL + masterColorFiles,
                checked: masterVariantSku === selectedSkuItem ? true : false,
                isOutOfStock: OutOfStockMaster,
                isDiscontinued: discontinuedMasterVariant,
                notApplicable: masterColorFiles.toLowerCase() === constants.SWATCH_NA.toLowerCase()
            }
        ];
        variants.forEach((variant, i)=>{
            var ref;
            const variantAttributes = get_default()(variant, "attributes", []);
            const colorName = get_default()(variantAttributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), "");
            const colorFiles = get_default()(variantAttributes.find((attr)=>attr.name === "SKUColorSwatchFilename"), "value", "");
            const getDiscontinuedValue = get_default()(variantAttributes.find((attr)=>attr.name === "RegionDiscontinuedDate"), "value", "");
            const isDiscontinuedVariant = Date.parse(getDiscontinuedValue) < Date.now();
            let OutOfStockVariant;
            const channels = Object.values(get_default()(variant, "availability.channels", {}));
            if (channels.length > 0) {
                const availableQtyvariants = get_default()(channels[0], "availableQuantity", 0);
                OutOfStockVariant = availableQtyvariants > 0 ? false : true;
            }
            const variantSku = get_default()(variant, "sku", "");
            const isImgVariant = variantSku.startsWith("IMGV");
            customerFacingSKUVariant[i] = {
                id: variantSku,
                CustomerFacingSKU: get_default()(variantAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "")
            };
            colorsDataVariants[i] = {
                id: variantSku,
                name: "product-color-".concat(colorId),
                value: variantSku,
                label: colorName,
                colorUrl: constants["default"].COLOR_FILE_URL + colorFiles,
                checked: variantSku === selectedSkuItem ? true : false,
                isOutOfStock: OutOfStockVariant,
                isDiscontinued: isDiscontinuedVariant || isImgVariant,
                notApplicable: colorFiles.toLowerCase() === constants.SWATCH_NA.toLowerCase()
            };
            imagesDataVariants[i] = {
                id: variantSku,
                image: variant.images.length > 0 ? get_default()(variant, "images[0].url", "") : image_missing/* default */.Z
            };
            priceOfVariants[i] = {
                id: variantSku,
                price: (Number(get_default()(variant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "value.centAmount", 0)) / 100).toFixed(2),
                discountedPrice: (Number(get_default()(variant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "discounted.value?.centAmount", 0)) / 100).toFixed(2),
                discountPercent: Number(get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.permyriad", 0)) / 100,
                discountType: get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.type", "")
            };
            if (!variant.prices.find((item)=>{
                var ref, ref1, ref2;
                return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
            })) {
                priceOfVariants[i].price = (Number(get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "value.centAmount", 0)) / 100).toFixed(2);
            }
            var ref1;
            const cartItem = (ref1 = cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === variantSku;
            })) !== null && ref1 !== void 0 ? ref1 : {};
            if (cartItem === null || cartItem === void 0 ? void 0 : cartItem.discountedPrice) {
                priceOfVariants[i].discountedPrice = (Number(get_default()(cartItem.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                priceOfVariants[i].discountType = get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                priceOfVariants[i].discountPercent = priceOfVariants[i].discountType === "absolute" ? Number(get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
        });
        product.customerFacingSKU = [
            ...customerFacingSKUMaster,
            ...customerFacingSKUVariant
        ];
        product.priceData = [
            ...priceOfMaster,
            ...priceOfVariants
        ];
        product.imagesData = [
            ...imagesDataMaster,
            ...imagesDataVariants
        ];
        product.colorsData = [
            ...colorsDataMaster,
            ...colorsDataVariants
        ];
        product.backorder = backorder;
        requiredProductsData.push(product);
    }
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const selectedVariant = addItemsData && addItemsData.filter((list)=>{
            var ref;
            return (list === null || list === void 0 ? void 0 : list.masterVariantSku) === (item === null || item === void 0 ? void 0 : (ref = item.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
        });
        var ref2;
        const selectedSku = (ref2 = selectedVariant && ((ref = selectedVariant[0]) === null || ref === void 0 ? void 0 : ref.skuid)) !== null && ref2 !== void 0 ? ref2 : item === null || item === void 0 ? void 0 : (ref1 = item.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.sku;
        setSelectedSkuItem(selectedSku);
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>{
            return (list === null || list === void 0 ? void 0 : list.skuid) === selectedSku;
        })));
    }, []);
    (0,react.useEffect)(()=>{
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>list.skuid === selectedSkuItem)));
    }, [
        addItemsData
    ]);
    (0,react.useEffect)(()=>{
        if (category && slug) {
            (0,helper/* getPDPUrl */.ir5)(category, slug).then((url)=>{
                setPdpUrl(url);
            });
        }
    }, [
        category,
        slug
    ]);
    const getSelectedSku = (sku)=>{
        setSelectedSkuItem(sku);
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>list.skuid === sku)));
    };
    const getPrice = (sku, type)=>{
        return get_default()(requiredProductsData[0].priceData.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.id) === sku;
        }), type, 0);
    };
    const isItemOutOfStock = backorder ? false : get_default()(requiredProductsData[0].colorsData.find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
    }), "isOutOfStock", "");
    const getEventInfo = function(type) {
        let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, link = arguments.length > 2 ? arguments[2] : void 0;
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const pagetitle = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
        const eventInfo = {
            eventAction: "".concat(pagetitle, ":select a product required for installation:").concat(type),
            eventName: "".concat(pagetitle, ":select a product required for installation:").concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type,
            internalLinkPosition: "items required for install",
            internalLinkType: "".concat(pagetitle, ":select a product required for installation:").concat(type),
            internalLinkZoneName: "".concat(pagetitle, ":select a product required for installation"),
            internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
            clickInternalLinks: "true"
        };
        if (needJSON) {
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const colorswatchClickHandler = (id)=>{
        getSelectedSku(id);
        pushAnalyticsData("color selection", productInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "line-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-tile__image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            src: get_default()(requiredProductsData[0].imagesData.find((item)=>{
                                return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                            }), "image", ""),
                            width: "120px",
                            height: "120px"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "line-item__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-and-description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "brand-name",
                                children: requiredProductsData[0].productName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item-description",
                                children: requiredProductsData[0].productDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "line-item__sku",
                        children: [
                            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sku-id",
                                children: get_default()(requiredProductsData[0].customerFacingSKU.find((item)=>{
                                    return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                                }), "CustomerFacingSKU", "")
                            }) : "",
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line-item__include--mobile",
                                children: !isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    className: "include-text",
                                    value: "",
                                    checked: isChecked,
                                    onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                                })
                            }) : ""
                        ]
                    }),
                    !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "line-item__price--desktop",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "list-item__price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    }),
                                    getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "list-item__discounted",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "list-item__percent-off",
                                                children: getPrice(selectedSkuItem, "discountType") === "absolute" ? "".concat(currencySign, "  ").concat(getPrice(selectedSkuItem, "discountPercent")) : "".concat(getPrice(selectedSkuItem, "discountPercent"), "% ").concat(staticTexts.percentOff)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: getPrice(selectedSkuItem, "price"),
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                checked: isChecked,
                                onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                            })
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "line-item__info",
                children: [
                    isMobile && !dist_lib/* isTablet */.Em ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sku-id",
                        children: get_default()(requiredProductsData[0].customerFacingSKU.find((item)=>{
                            return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                        }), "CustomerFacingSKU", "")
                    }) : "",
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-item__price--mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "price_item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true
                                    })
                                }),
                                getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "discount-price",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: getPrice(selectedSkuItem, "price"),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "discount-percent-off",
                                            children: [
                                                getPrice(selectedSkuItem, "discountType") === "absolute" ? currencySign + getPrice(selectedSkuItem, "discountPercent") : getPrice(selectedSkuItem, "discountPercent") + "%",
                                                " ",
                                                staticTexts.percentOff
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item-color",
                        children: [
                            requiredProductsData[0].colorsData && requiredProductsData[0].colorsData.filter((col)=>!col.notApplicable && !col.isDiscontinued).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "color-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "color-finish",
                                        children: staticTexts.colorOrFinish
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "color-value",
                                        children: get_default()(requiredProductsData[0].colorsData.find((item)=>{
                                            return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                                        }), "label", "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item-color-swatches",
                                children: requiredProductsData[0].colorsData && requiredProductsData[0].colorsData.filter((col)=>!col.notApplicable && !col.isDiscontinued).map((color, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch/* default */.Z, {
                                        type: "selector",
                                        id: color.id,
                                        name: color.name,
                                        value: color.value,
                                        label: color.label,
                                        colorUrl: color.colorUrl,
                                        checked: color.checked ? true : false,
                                        onClick: (id)=>colorswatchClickHandler(id)
                                    }, i))
                            }),
                            isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "out-of-stock-section --desktop",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "out-of-stock-msg",
                                        children: staticTexts.outOfStockErr
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "back-in-stock",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": getEventInfo(staticTexts.backInStock.toLowerCase(), false, pdpUrl === null || pdpUrl === void 0 ? void 0 : pdpUrl.trim().toLowerCase()),
                                            "data-gbh-data-layer-custom": productInfo,
                                            href: pdpUrl,
                                            children: staticTexts.backInStock
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__include--mobile",
                children: !isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    className: "include-text",
                    value: staticTexts.includeTextCTA,
                    checked: isChecked,
                    onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                })
            }) : "",
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__price--mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "price",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "price_item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                displayType: "text",
                                thousandSeparator: true,
                                prefix: currencySign,
                                decimalScale: 2,
                                fixedDecimalScale: true
                            })
                        }),
                        getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "discount-price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: getPrice(selectedSkuItem, "price"),
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "discount-percent-off",
                                    children: [
                                        getPrice(selectedSkuItem, "discountType") === "absolute" ? currencySign + getPrice(selectedSkuItem, "discountPercent") : getPrice(selectedSkuItem, "discountPercent") + "%",
                                        " ",
                                        staticTexts.percentOff
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : "",
            isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "out-of-stock-section --mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "out-of-stock-msg",
                        children: staticTexts.outOfStockErr
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "back-in-stock",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": getEventInfo(staticTexts.backInStock.toLowerCase(), false, pdpUrl === null || pdpUrl === void 0 ? void 0 : pdpUrl.trim().toLowerCase()),
                            "data-gbh-data-layer-custom": productInfo,
                            href: pdpUrl,
                            children: staticTexts.backInStock
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v3_PDPRequiredItem = (PDPRequiredItem);

// EXTERNAL MODULE: ./components/ProductDetail/v3/PDPRequiredItemModal/index.module.scss
var PDPRequiredItemModal_index_module = __webpack_require__(61184);
var PDPRequiredItemModal_index_module_default = /*#__PURE__*/__webpack_require__.n(PDPRequiredItemModal_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPRequiredItemModal/index.jsx
/* eslint-disable new-cap */ 













const PDPRequiredItemModal = (props)=>{
    var ref;
    const { name ="" , desc ="" , customerFacingSKU ="" , sku ="" , staticTexts ={} , imagesData =[] , installReq =[] , colorsData =[] , price =0 , discountedPrice =0 , currencySign ="" , reqItemLwData =[] , currencyCode ="" , locale ="" , productInfo ={} , discountPercent =0 , isType ="" , getRequireItemsData =()=>{} , onModalClose =()=>{} , showModal =false , installRequiredItemsData =[]  } = props;
    const [addItems, setAddItems] = (0,react.useState)([]);
    const [enableInclude, setEnableInclude] = (0,react.useState)(false);
    const [config, setConfig] = (0,react.useState)("");
    const [imageUrl, setImageUrl] = (0,react.useState)("");
    const modalWindow = (0,react.useRef)(null);
    const itemScroll = (0,react.useRef)(null);
    const [width] = (0,useWindowResize/* default */.Z)();
    const isKohlerCanada = (0,helper/* isCanadaSite */.guj)(config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName);
    window.addEventListener("click", function(e) {
        var ref;
        if (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.contains(modalWindow === null || modalWindow === void 0 ? void 0 : modalWindow.current)) {
            onModalClose();
        }
    });
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>setConfig(config));
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            var ref;
            const { general: { swatchUrl =""  } = {}  } = config;
            const imageUrl = swatchUrl + ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId);
            setImageUrl(imageUrl);
        }
    }, [
        config,
        imagesData
    ]);
    (0,react.useEffect)(()=>{
        setAddItems(installReq);
    }, [
        installReq
    ]);
    (0,react.useEffect)(()=>{
        if (addItems.length !== 0) {
            setEnableInclude(true);
        } else {
            setEnableInclude(false);
        }
    }, [
        addItems
    ]);
    const updateItems = (checked, item)=>{
        let installRequireItems = addItems;
        if (checked) {
            installRequireItems = installRequireItems.filter((requiredProduct)=>requiredProduct.masterVariantSku !== item.masterVariantSku);
            installRequireItems.push(item);
        } else {
            installRequireItems = installRequireItems.filter((requiredProduct)=>requiredProduct.skuid !== item.skuid);
        }
        setAddItems([
            ...installRequireItems
        ]);
    };
    const includeOnClick = ()=>{
        getRequireItemsData(addItems);
        onModalClose();
    };
    (0,react.useEffect)(()=>{
        if (width > 991 && showModal && itemScroll.current && (installRequiredItemsData === null || installRequiredItemsData === void 0 ? void 0 : installRequiredItemsData.length) > 0) {
            window.OverlayScrollbars ? window.OverlayScrollbars(itemScroll === null || itemScroll === void 0 ? void 0 : itemScroll.current, {
                className: "os-theme-dark",
                resize: "none",
                sizeAutoCapable: true,
                clipAlways: true,
                normalizeRTL: true,
                paddingAbsolute: false,
                autoUpdate: null,
                autoUpdateInterval: 33,
                nativeScrollbarsOverlaid: {
                    showNativeScrollbars: false,
                    initialize: true
                },
                overflow: {
                    x: "hidden"
                },
                scrollbars: {
                    visibility: "auto",
                    autoHide: "never",
                    autoHideDelay: 800,
                    dragScrolling: true,
                    clickScrolling: true,
                    touchSupport: true,
                    snapHandle: true
                }
            }) : null;
        }
    }, [
        showModal,
        itemScroll === null || itemScroll === void 0 ? void 0 : itemScroll.current,
        installRequiredItemsData,
        width
    ]);
    const includeButtonClickHandler = (event)=>{
        includeOnClick();
        const btnText = event.target.innerHTML;
        pushAnalyticsData(btnText === null || btnText === void 0 ? void 0 : btnText.toLowerCase(), productInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PDPRequiredItemModal_index_module_default()).pdpRequiredItemModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-detail-page__install-items-modal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                showModal: showModal,
                onModalClose: onModalClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "required-item",
                    ref: modalWindow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "required-item__container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "required-item__left-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-title",
                                        children: staticTexts.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "item-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-details__image",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-image",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "product-image-container",
                                                        src: imageUrl,
                                                        alt: name,
                                                        onError: (e)=>(0,utils_0/* onImageError */.Ac)(e, imageUrl),
                                                        width: "250px",
                                                        height: "250px"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item-details__info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-family-name",
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-description",
                                                        children: desc
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "sku-id",
                                                        children: customerFacingSKU || sku
                                                    }),
                                                    colorsData.filter((c)=>!c.notApplicable).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "color-finish",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Color/Finish"
                                                            }),
                                                            " :",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: get_default()(colorsData.find((item)=>item.id === sku), "label", "")
                                                            })
                                                        ]
                                                    }),
                                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "price",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "price-amount",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                value: discountedPrice > 0 ? discountedPrice : price,
                                                                displayType: "text",
                                                                thousandSeparator: true,
                                                                prefix: currencySign,
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true
                                                            })
                                                        })
                                                    }),
                                                    discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "required-item__display-discount --mobile",
                                                        children: [
                                                            discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "required-item__percent-off",
                                                                children: [
                                                                    isType === "absolute" ? currencySign + discountPercent : discountPercent + "%",
                                                                    " ",
                                                                    staticTexts.percentOff
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "required-item__discount-price --mobile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: price,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "required-item__right-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "required-product-title",
                                        children: isKohlerCanada ? staticTexts.cadRequiredProductTitle : staticTexts.requiredProductTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "required-product-description",
                                        children: isKohlerCanada ? staticTexts.cadRequiredProductDescription : staticTexts.requiredProductDescription
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "required-product-header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: staticTexts.productText
                                            }),
                                            isKohlerCanada ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: staticTexts.includeTextCTA
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: itemScroll,
                                        className: "product-line-items",
                                        children: installRequiredItemsData.length > 0 && installRequiredItemsData.map((product, i)=>{
                                            var ref;
                                            const lwProdData = (ref = reqItemLwData === null || reqItemLwData === void 0 ? void 0 : reqItemLwData.find((i)=>product.id === i.ctId_s)) !== null && ref !== void 0 ? ref : {};
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_PDPRequiredItem, {
                                                staticTexts: staticTexts,
                                                addItemsData: addItems,
                                                item: product,
                                                updateItems: (checked, item)=>updateItems(checked, item),
                                                currencyCode: currencyCode,
                                                currencySign: currencySign,
                                                locale: locale,
                                                colorId: i,
                                                backorder: lwProdData["RegionOnBackOrder_s"] === "Yes",
                                                productInfo: productInfo,
                                                isKohlerCanada: isKohlerCanada,
                                                ...props
                                            }, i);
                                        })
                                    }),
                                    isKohlerCanada ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "include-button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            useDefaultClass: true,
                                            role: "button",
                                            label: installReq.length ? staticTexts.updateText : staticTexts.includeTextCTA,
                                            size: "medium",
                                            type: "primary",
                                            onClick: includeButtonClickHandler,
                                            disabled: !enableInclude
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v3_PDPRequiredItemModal = (PDPRequiredItemModal);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/InstallReqItems.jsx







const InstallReqItems = (props)=>{
    const { isDiscontinued =false , staticTexts ={} , price =0 , discountedPrice =0 , currencySign ="" , installReq =[] , productAnalyticsData ={} , onInstallCTA =()=>{} , toolTipIcon ="" , handleInfoToolTipHover =()=>{} , setShowTooltip =()=>{} , showTooltip =false , isMobileOnly =false , handleRemove =()=>{} , priceList =[] , subTotal =0 , requiredItems =[] , getRequireItems =()=>{} , installReqData =[] , reqItemLwData =[] , onModalClose =()=>{} , showPDPInstallModal =false , config ={} , currencyCode =""  } = props;
    const { internationalization: { locale =""  } = {}  } = config;
    const { itemReqCTA ="" , editItemReqCTA =""  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isDiscontinued && (requiredItems === null || requiredItems === void 0 ? void 0 : requiredItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters product-detail-page__install-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-detail-page__install-item-btn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)((installReq.length === 0 ? itemReqCTA : editItemReqCTA).toLowerCase()),
                                "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                                label: installReq.length === 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.itemReqCTA : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.editItemReqCTA,
                                size: "small",
                                type: "ghost",
                                onClick: onInstallCTA
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-detail-page__tooltip-icon",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: toolTipIcon.src,
                                        alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip,
                                        onMouseOver: (e)=>handleInfoToolTipHover(e),
                                        onMouseLeave: ()=>setShowTooltip(false),
                                        width: "16px",
                                        height: "16px",
                                        "data-testid": "img-tooltip-installRqitm"
                                    }),
                                    showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                        message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.tooltipMsg
                                    })
                                ]
                            })
                        ]
                    })
                }),
                installReq.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "no-gutters product-detail-page__install-items-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__required-product-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.requiredItemsProduct
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.requiredItemsPrice
                                })
                            ]
                        }),
                        installReq && installReq.map((item, i)=>{
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "col-12 product-detail-page__install-item-details",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        !isMobileOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    src: get_default()(item.imagesData.find((list)=>list.id === item.skuid), "image", ""),
                                                    width: "80px",
                                                    height: "80px"
                                                })
                                            })
                                        }) : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: isMobileOnly ? "col-8" : "col-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "item-details",
                                                    children: item.productName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "item-description",
                                                    children: item.productDescription
                                                }),
                                                !get_default()(item.colorsData.find((list)=>list.id === item.skuid), "notApplicable", false) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "item-color-details",
                                                        children: [
                                                            staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.colorOrFinish,
                                                            " :",
                                                            " ",
                                                            get_default()(item.colorsData.find((list)=>list.id === item.skuid), "label", "")
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "item-price",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountedPrice", 0) > 0 ? get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountedPrice", 0) : get_default()(item.priceData.find((list)=>list.id === item.skuid), "price", 0),
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    })
                                                }),
                                                get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountedPrice", 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "discount-price-item",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "discount-price",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: get_default()(item.priceData.find((list)=>list.id === item.skuid), "price", 0),
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "discount-percent",
                                                                children: [
                                                                    get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountType", "") === "absolute" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountPercent", 0),
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: currencySign,
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    }) : get_default()(item.priceData.find((list)=>list.id === item.skuid), "discountPercent", 0) + "%",
                                                                    " ",
                                                                    staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.percentOff
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "remove",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "remove-link gbh-data-layer",
                                                        onClick: ()=>handleRemove(item),
                                                        "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)(staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.remove) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                                                        "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remove
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, i);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 product-detail-page__install-item-details",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "base-product",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.baseProduct
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "base-product",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.requiredItems
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "total",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.subTotal
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: discountedPrice > 0 ? discountedPrice : price,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "item-price",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: priceList,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sub-total",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: subTotal.toFixed(2),
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_PDPRequiredItemModal, {
                    ...props,
                    staticTexts: staticTexts,
                    getRequireItemsData: (addItems)=>getRequireItems(addItems),
                    installRequiredItemsData: installReqData,
                    reqItemLwData: reqItemLwData,
                    onModalClose: onModalClose,
                    showModal: showPDPInstallModal,
                    locale: locale,
                    currencyCode: currencyCode,
                    installReq: installReq,
                    currencySign: currencySign,
                    productInfo: productAnalyticsData.stringProductInfo
                })
            ]
        })
    });
};
/* harmony default export */ var ProductDetailView_InstallReqItems = (InstallReqItems);

// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/analytics.js
var AddToCart_analytics = __webpack_require__(30525);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/utils.js
var AddToCart_utils = __webpack_require__(29885);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/AddToCart/AddToCartActions/index.js










const AddToCartActions = (props)=>{
    const { cart ={} , onQtyChange =()=>{} , onAddToCart =()=>{} , isComboSku =false , customerBrandName ="" , sku ="" , price =0 , backOrder ="" , data: { setStockAlert , setProductStock , addToCartButton , productAnalyticsData ={} , addProductToCart , addToCartTxt , isBundleProduct  } = {}  } = props;
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [loading, setLoading] = (0,react.useState)(false);
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_DISABLE_ADD_CART: disableAddcart  } = featureFlags;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const handleChange = (qty)=>{
        var ref;
        setStockAlert({
            show: false,
            mssg: ""
        });
        if (backOrder === "Yes") {
            onQtyChange(qty);
            setQuantity(qty);
            setLoading(false);
            return;
        }
        onQtyChange(qty);
        setLoading(true);
        var ref1;
        const cartItem = (ref1 = (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === sku)) !== null && ref1 !== void 0 ? ref1 : {};
        var _quantity;
        const cartQuantity = (_quantity = cartItem.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        if (qty && qty > 0) {
            setQuantity(qty);
            (0,utils_cart/* getStock */.K5)(sku).then((stock)=>{
                if (cartQuantity > 0 && stock <= cartQuantity) {
                    setStockAlert({
                        show: true,
                        mssg: t("kf.pdp.label.noItemsToShip")
                    });
                } else if (stock >= qty + cartQuantity) {
                    onQtyChange(qty);
                } else {
                    setProductStock(stock);
                    if (stock > 0) {
                        setQuantity(stock - cartQuantity);
                        onQtyChange(stock - cartQuantity);
                        setStockAlert({
                            show: true,
                            mssg: t("kf.pdp.label.availableToShip", {
                                qty: stock
                            })
                        });
                    }
                }
                setLoading(false);
            }).catch(()=>setLoading(false));
        }
    };
    const handleATCKeydown = (e)=>{
        if (e.keyCode === 13 || e.keyCode === 32) {
            window.previewCartKeySource = true;
        } else {
            window.previewCartKeySource = false;
        }
    };
    const onAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleAddToCart = ()=>{
        var ref;
        setLoading(true);
        setStockAlert({
            show: false,
            mssg: ""
        });
        if (backOrder === "Yes") {
            onAddToCart([
                {
                    sku,
                    quantity,
                    isBundleProduct,
                    isBundle: isComboSku,
                    backorder: true,
                    brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase()
                }
            ], onAddToCartCb);
            return;
        }
        window.cartButtonElement = addToCartButton.current.firstElementChild;
        var ref1;
        const cartItem = (ref1 = (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === sku)) !== null && ref1 !== void 0 ? ref1 : {};
        var _quantity;
        const cartQuantity = (_quantity = cartItem.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        (0,utils_cart/* getStock */.K5)(sku).then((stock)=>{
            setLoading(false);
            setProductStock(stock);
            if (cartQuantity + quantity > stock) {
                if (stock > cartQuantity) {
                    onAddToCart([
                        {
                            sku,
                            isBundleProduct,
                            quantity: stock - cartQuantity,
                            brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase()
                        }
                    ], onAddToCartCb);
                    setStockAlert({
                        show: true,
                        mssg: t("kf.pdp.label.availableToShip", {
                            qty: stock
                        })
                    });
                } else {
                    setStockAlert({
                        show: true,
                        mssg: t("kf.pdp.label.noItemsToShip")
                    });
                }
            } else {
                onAddToCart([
                    {
                        sku,
                        quantity,
                        isBundleProduct,
                        isBundle: isComboSku,
                        brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase()
                    }
                ], onAddToCartCb);
            }
        }).catch((err)=>{
            setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "add-cart-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "quantity-selector-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                    productData: productAnalyticsData,
                    value: quantity,
                    onChange: handleChange,
                    loading: loading,
                    isPDPQuantitySelector: true,
                    doNotRequiredAnalyticsData: true,
                    isAddToCart: true,
                    onLoading: ()=>setLoading(true)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "add-to-cart-container",
                ref: addToCartButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    role: "button",
                    ariaLabel: addProductToCart,
                    className: "gbh-data-layer",
                    "data-gbh-data-layer": (0,AddToCart_analytics/* getAnalyticsData */.Eb)(addToCartTxt, "", "", isBundleProduct),
                    "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                    label: addToCartTxt,
                    onClick: debounce_default()(handleAddToCart, 500),
                    onKeyDown: handleATCKeydown,
                    size: "large",
                    type: "primary",
                    flexible: true,
                    disabled: loading || !quantity || parseInt(quantity) < 1 || !price || disableAddcart,
                    loading: loading
                })
            })
        ]
    });
};
/* harmony default export */ var AddToCart_AddToCartActions = (AddToCartActions);

// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/OutOfStockSection/index.js
var OutOfStockSection = __webpack_require__(94057);
// EXTERNAL MODULE: ./public/icons/tooltip.svg
var tooltip = __webpack_require__(7033);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(10502);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/index.module.scss
var AddToCart_index_module = __webpack_require__(98185);
var AddToCart_index_module_default = /*#__PURE__*/__webpack_require__.n(AddToCart_index_module);
// EXTERNAL MODULE: ./components/SaveToList/index.jsx
var SaveToList = __webpack_require__(4165);
// EXTERNAL MODULE: ./components/ListConfirmationModal/index.jsx + 1 modules
var ListConfirmationModal = __webpack_require__(63652);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/utils.js
var ProductTile_utils = __webpack_require__(97167);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/AddToCart/index.jsx
/* eslint-disable camelcase */ 


























const AddToCart = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { isDiscontinued =false , isColorDiscontinued =false , productOnStock =0 , compareData ={} , sku ="" , ProductPriceSpiderIncluded_s ="" , price =0 , backOrder ="No" , specialOrder ="No" , staticTexts ={} , onRemove =()=>{} , onAdd =()=>{} , ctProductId ="" , productData ={} , replaceAddToCartCtaLabel ="" , replaceAddToCartCtaLink ="" , onAvailableColor =()=>{} , disableEcommerce =false , isRegionSoldOnline =true , findStoreUrl ="" , replaceAddToCart =false , linkNewTab =false , disableRatings =false , handleNavChange =()=>{} , productCategory ="" , favItem =[] , isPdpPropsLoaded =false , analyticData ={} , isBundleProduct =false , onQtyChange =()=>{} , ctData ={} , resetSelectedFav =()=>{} , showFavirote =false , leadTime , isBackorderable , availableStock  } = props;
    const router = (0,next_router.useRouter)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { toaster , featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { userListItemsSkus ={}  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { isEnable  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const dispatch = (0,es/* useDispatch */.I0)();
    const enableFav = isDiscontinued || isColorDiscontinued ? true : false;
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const [stockAlert, setStockAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const [productStock, setProductStock] = (0,react.useState)(0);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const addToCartButton = (0,react.useRef)(null);
    const localStoreOrShowroomRef = (0,react.useRef)(null);
    const [outOfStockMsg, setOutOfStockMsg] = (0,react.useState)("");
    const [showAddToList, setShowAddToList] = (0,react.useState)(false);
    const [listActionText, setListActionText] = (0,react.useState)("");
    const [productSavedToList, setProductSavedToList] = (0,react.useState)(false);
    const [openModal, setOpenModal] = (0,react.useState)(false);
    const [deleteFromList, setDeleteFromList] = (0,react.useState)(false);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const COMPARE_VERSION_CHECK = "compare_products_v1";
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const { availColorCTA ="" , compareTxt ="" , favTxt ="" , outOfStockMsg: outOfStockMsgTxt , addToCart: addToCartTxt , ariaLabel: { addProductToCart  } = "" , saveToListText ="" , savedToListText ="" , deleteFromListText =""  } = staticTexts;
    const handleFavorite = (e)=>{
        if (isSaveProductToList) {
            if (userListItemsSkus[sku]) {
                setOpenModal(true);
                setDeleteFromList(true);
                return;
            }
            const element = document.querySelector(".product-detail-page__right-sticky");
            element === null || element === void 0 ? void 0 : element.classList.add("pdp-my-list");
            setShowAddToList(true);
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            return;
        }
        const favoriteData = {
            isFavorite: showFavirote,
            favItem,
            staticTexts,
            ctProductId,
            isAuth,
            toasterContent,
            sku,
            ctData
        };
        (0,AddToCart_utils/* callFavorite */.SH)(e, favoriteData, handleFavoriteSku);
    };
    const handleFavoriteSku = (fItems)=>{
        resetSelectedFav(fItems, sku);
    };
    const handleSaveToListSuccessCallBack = ()=>{
        setListActionText(savedToListText);
        setListActionText(deleteFromListText);
    };
    const handleDeleteFromListSuccessCallback = ()=>{
        setListActionText(saveToListText);
    };
    const handleListSaveAndCreateClose = ()=>{
        setShowAddToList(false);
        const element = document.querySelector(".product-detail-page__right-sticky");
        element === null || element === void 0 ? void 0 : element.classList.remove("pdp-my-list");
    };
    (0,react.useEffect)(()=>{
        if (userListItemsSkus[sku]) {
            setListActionText(deleteFromListText);
        } else {
            setListActionText(saveToListText);
        }
    }, [
        userListItemsSkus,
        sku
    ]);
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            if (productSavedToList || userListItemsSkus[sku]) {
                setListActionText(deleteFromListText);
            } else {
                setListActionText(saveToListText);
            }
        } else {
            setListActionText(favTxt);
        }
    }, [
        ctData === null || ctData === void 0 ? void 0 : ctData.id,
        userListItemsSkus
    ]);
    (0,react.useEffect)(()=>{
        if (outOfStockMsgTxt) {
            (0,helper/* getShortenedUrl */.Ppy)(outOfStockMsgTxt).then((res)=>setOutOfStockMsg(res !== null && res !== void 0 ? res : outOfStockMsgTxt));
        }
    }, [
        outOfStockMsgTxt
    ]);
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        setProductStock(productOnStock);
    }, [
        productOnStock
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (compareData === null || compareData === void 0 ? void 0 : (ref = compareData.comparedProducts) === null || ref === void 0 ? void 0 : ref.find((prod)=>{
            return (prod === null || prod === void 0 ? void 0 : prod.compareSku) === sku;
        })) setIsChecked(true);
        else setIsChecked(false);
    }, [
        compareData === null || compareData === void 0 ? void 0 : compareData.comparedProducts,
        sku
    ]);
    (0,react.useEffect)(()=>{
        setShowBuyBoxArea(!ProductPriceSpiderIncluded_s);
    }, [
        ProductPriceSpiderIncluded_s,
        price
    ]);
    const setToasterMessage = async ()=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,helper/* getShortenedUrl */.Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,helper/* getShortenedUrl */.Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleCompare = (e)=>{
        setIsChecked(!isChecked);
        if (e.target.checked) {
            var ref;
            if ((compareData === null || compareData === void 0 ? void 0 : (ref = compareData.comparedProducts) === null || ref === void 0 ? void 0 : ref.length) < 4) {
                var ref1, ref2;
                let variantFlag = false;
                const allVariants = (ref2 = (ref1 = props.compareData.comparedProducts) === null || ref1 === void 0 ? void 0 : ref1.map((cp)=>[
                        ...cp.variants,
                        cp.masterVariant
                    ])) === null || ref2 === void 0 ? void 0 : ref2.flat();
                const allVariantSkus = allVariants === null || allVariants === void 0 ? void 0 : allVariants.map((aV)=>aV.sku);
                if (allVariantSkus.includes(props.sku)) {
                    variantFlag = true;
                }
                if ((compareData === null || compareData === void 0 ? void 0 : compareData.category) !== "" && (compareData === null || compareData === void 0 ? void 0 : compareData.category) !== productCategory) {
                    setErrorMessage(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sameCategory);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    onRemove(sku);
                } else if (variantFlag && COMPARE_VERSION_CHECK === "compare_products_v2") {
                    setErrorMessage(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sameVariants);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    props.onRemove(props.sku);
                } else {
                    onAdd(sku);
                }
            } else {
                setErrorMessage(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.maxProduct);
                setTimeout(()=>{
                    setErrorMessage("");
                }, 2000);
                setIsChecked(false);
                onRemove(sku);
            }
        } else {
            onRemove(sku);
        }
        (0,AddToCart_analytics/* addToCompareAnalytics */.mw)(isChecked, productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo);
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        (0,AddToCart_analytics/* addDataLayerFavGuestUser */.fl)();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const productAnalyticsData = productData || {};
    (0,react.useEffect)(()=>{
        setToasterMessage();
        const timeOut = setTimeout(()=>{
            (0,AddToCart_utils/* addDatalayerForLocalStoreOrShowroom */.tB)({
                localStoreOrShowroomRef,
                productAnalyticsData
            });
        }, 500);
        return ()=>{
            clearTimeout(timeOut);
        };
    }, []);
    const actionButtonData = {
        setStockAlert,
        setProductStock,
        addToCartButton,
        productAnalyticsData,
        addProductToCart,
        addToCartTxt,
        isBundleProduct
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AddToCart_index_module_default()).addToCartWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters buy-area",
                ref: ref,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "add-to-cart col-12 ".concat(isDiscontinued ? "add-to-cart__discontinued" : ""),
                    onClick: (e)=>{
                        return (0,AddToCart_utils/* handleProductSuggestion */.YS)(e, productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo);
                    },
                    children: [
                        isBackorderable && availableStock <= 0 && leadTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__backorder-msg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "backorder-icon",
                                        src: tooltip/* default.src */.Z.src,
                                        alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "backorder-msg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.backOrderMssg(leadTime)
                                    })
                                })
                            ]
                        }) : null,
                        showBuyBoxArea ? isDiscontinued ? isColorDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-detail-page__available-color-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                className: "product-detail-page__available-color-btn",
                                onClick: onAvailableColor,
                                flexible: true,
                                label: availColorCTA,
                                size: "large",
                                type: "primary"
                            })
                        }) : null : !(productStock > 0) && !disableEcommerce ? specialOrder === "Yes" || backOrder === "Yes" && !isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                stockAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-detail-page__stock-alert",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            src: warning/* default */.Z
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: stockAlert.mssg
                                        })
                                    ]
                                }),
                                isRegionSoldOnline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart_AddToCartActions, {
                                    ...props,
                                    data: actionButtonData,
                                    onQtyChange: (qty)=>onQtyChange(qty)
                                }) : null
                            ]
                        }) : isPdpPropsLoaded && isRegionSoldOnline || isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockSection["default"], {
                            outOfStockMsg: outOfStockMsg,
                            localStoreOrShowroomRef: localStoreOrShowroomRef,
                            findStoreUrl: findStoreUrl,
                            sku: sku,
                            staticTexts: staticTexts,
                            productData: productData
                        }) : null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                stockAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-detail-page__stock-alert",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            src: warning/* default */.Z === null || warning/* default */.Z === void 0 ? void 0 : warning/* default.src */.Z.src
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: stockAlert.mssg
                                        })
                                    ]
                                }),
                                isRegionSoldOnline || isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart_AddToCartActions, {
                                    ...props,
                                    data: actionButtonData,
                                    onQtyChange: (qty)=>onQtyChange(qty)
                                }) : null
                            ]
                        }) : null,
                        replaceAddToCart && !isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "replace-add-to-cart-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "".concat(disableEcommerce ? "replace-add-to-cart-button" : ""),
                                onClick: ()=>{
                                    (0,AddToCart_analytics/* replaceAddToCartDatalayerPush */.ME)(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData);
                                    router.push(replaceAddToCartCtaLink);
                                },
                                role: "button",
                                ariaLabel: replaceAddToCartCtaLabel,
                                label: replaceAddToCartCtaLabel,
                                size: "".concat(disableEcommerce ? " " : "large"),
                                type: "primary",
                                flexible: true,
                                to: replaceAddToCartCtaLink,
                                target: linkNewTab ? "_blank" : "_self"
                            })
                        }) : null,
                        !isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottom-section ",
                            children: [
                                !isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "add-to-compare",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            value: compareTxt,
                                            checked: isChecked,
                                            onChange: handleCompare,
                                            disabled: isEnable
                                        }),
                                        errorMessage !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                            message: errorMessage
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()({
                                        favorites: true,
                                        "favorites--discontinued": enableFav
                                    }),
                                    id: "kf-pdp-favorites",
                                    "data-gbh-data-layer": (0,AddToCart_analytics/* getAnalyticsData */.Eb)(favTxt, "", "", (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.pdpType) === "bundle" ? true : ""),
                                    "data-gbh-data-layer-custom": productAnalyticsData.stringProductInfo,
                                    onClick: isAuth ? handleFavorite : handleLogin,
                                    role: "button",
                                    tabIndex: "0",
                                    "aria-label": favTxt,
                                    "data-gbh-clickable": "true",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,ProductTile_utils/* getFavIconStatus */.l)({
                                                isSaveProductToList,
                                                productSavedToList,
                                                inSavedItems: userListItemsSkus[sku],
                                                isFavorite: showFavirote,
                                                filledWishIcon: wishlist_gray_filled/* default */.Z,
                                                wishIcon: wish/* default */.Z
                                            }),
                                            alt: favTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text",
                                            children: [
                                                listActionText,
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                !isDiscontinued && !disableRatings ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-bv-show": "rating_summary",
                                    "data-bv-product-id": sku,
                                    className: "product-detail-page__inline-rating",
                                    onClick: ()=>handleNavChange(4, true)
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            openModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                openConforMationModal: openModal,
                deleteFromList: deleteFromList,
                closeConformationModal: ()=>setOpenModal(false),
                list: userListItemsSkus[sku],
                deleteConfirmationModal: ()=>setProductSavedToList(false),
                handleSuccessCallBack: handleDeleteFromListSuccessCallback
            }) : showAddToList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                productSku: sku,
                showListSaveAndCreate: showAddToList,
                listSaveAndCreateClose: handleListSaveAndCreateClose,
                handleSuccessCallBack: handleSaveToListSuccessCallBack
            }) : null
        ]
    });
});
AddToCart.propTypes = {
    staticTexts: (prop_types_default()).object
};
AddToCart.displayName = "AddToCart";
/* harmony default export */ var v3_AddToCart = (AddToCart);

// EXTERNAL MODULE: ./components/ProductDetail/v3/MoreFromCollection/index.module.scss
var MoreFromCollection_index_module = __webpack_require__(28416);
var MoreFromCollection_index_module_default = /*#__PURE__*/__webpack_require__.n(MoreFromCollection_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/MoreFromCollection/index.jsx









const MoreFromCollection = (props)=>{
    const { sku ="" , pdpJson ={} , presetConfigObject ={} , productType ="" , partReplacementSuggestions ="" , i18n: { partNumber ="" , partName =""  } = {}  } = props;
    const [data, setData] = (0,react.useState)([]);
    const [recommendations, setRecommendations] = (0,react.useState)([]);
    const [title, setTitle] = (0,react.useState)("");
    const [config, setConfig] = (0,react.useState)({});
    const [general, setGeneral] = (0,react.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react.useState)(null);
    if (!pdpJson.ctRecommendations) {
        pdpJson.ctRecommendations = [];
    }
    var ref;
    const { title: replacementTitle , producttype  } = (ref = 0 in pdpJson.ctRecommendations && pdpJson.ctRecommendations[0]) !== null && ref !== void 0 ? ref : {};
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (productType === producttype) {
            if (partReplacementSuggestions) {
                setTitle(replacementTitle);
                setRecommendations(partReplacementSuggestions.split(",").map((product)=>({
                        sku: product
                    })));
            } else {
                setTitle("");
                setRecommendations([]);
            }
        }
    }, [
        sku,
        partReplacementSuggestions
    ]);
    /**
   * Selects Appropriate preset for more collections and appends it to the image url based on screen size
   * as container size cannot be considered in this scenario
   *
   * @param {string} uUrl     the formatted url which contains swatch url and id
   * @return {string} final url with correct preset appended
   */ const appendPreset = (uUrl)=>{
        let sPreset = "";
        if (window.innerWidth < 660) {
            var _MoreCollectionMobilePotrait;
            sPreset = (_MoreCollectionMobilePotrait = presetConfigObject.MoreCollectionMobilePotrait) !== null && _MoreCollectionMobilePotrait !== void 0 ? _MoreCollectionMobilePotrait : "";
        } else if (dist_lib/* isMobile */.tq) {
            var _MoreCollectionMobileLandscape;
            sPreset = (_MoreCollectionMobileLandscape = presetConfigObject.MoreCollectionMobileLandscape) !== null && _MoreCollectionMobileLandscape !== void 0 ? _MoreCollectionMobileLandscape : "";
        } else {
            var _MoreCollectionDesktop;
            sPreset = (_MoreCollectionDesktop = presetConfigObject.MoreCollectionDesktop) !== null && _MoreCollectionDesktop !== void 0 ? _MoreCollectionDesktop : "";
        }
        return "".concat(uUrl, "?").concat(sPreset);
    };
    /**
   * Formats the base url using the logic of swatch url + id + preset, that way it can be
   * used to render the final image to the DOM
   *
   * @param {string} uUrl   the base url which will come from the api response
   * @return {string}
   */ const formatUrl = (uUrl)=>{
        var ref;
        const sUrlPath = (ref = uUrl.split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
        const sUrlId = sUrlPath[sUrlPath.length - 1];
        const swatchUrl = pdpJson.swatchUrl;
        const uFinalUrl = appendPreset("".concat(swatchUrl).concat(sUrlId));
        return uFinalUrl;
    };
    (0,react.useEffect)(()=>{
        const getProducts = async ()=>{
            var ref;
            const skus = (ref = recommendations.map((product)=>{
                if (product.sku) {
                    return product.sku.replace("K-", "");
                }
            })) !== null && ref !== void 0 ? ref : [];
            if (skus.length) {
                try {
                    const d = await (0,shareCartHelper/* getProductsBySku */.uX)(skus);
                    const productData = skus.map((sku)=>{
                        var ref, ref1, ref2, ref3, ref4;
                        const item = d.find((p)=>p.masterVariant.sku === sku || p.variants.find((v)=>v.sku === sku));
                        const variant = item.masterVariant.sku === sku ? item.masterVariant : item.variants.find((v)=>v.sku === sku);
                        var ref5;
                        const channels = (ref5 = variant === null || variant === void 0 ? void 0 : (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.channels) !== null && ref5 !== void 0 ? ref5 : {};
                        var ref6;
                        const inStock = (ref6 = (ref1 = channels[0]) === null || ref1 === void 0 ? void 0 : ref1.availableQuantity) !== null && ref6 !== void 0 ? ref6 : 0;
                        const image = (variant === null || variant === void 0 ? void 0 : (ref2 = variant.images) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? formatUrl(variant.images[0].url) : image_missing/* default */.Z;
                        const category = variant.attributes.filter((attr)=>attr.name === "ProductLocalCategory")[0];
                        const skuID = get_default()(variant.attributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "");
                        return {
                            name: item.name[(ref3 = config.internationalization) === null || ref3 === void 0 ? void 0 : ref3.locale],
                            slug: item.slug[(ref4 = config.internationalization) === null || ref4 === void 0 ? void 0 : ref4.locale],
                            inStock,
                            image,
                            category: category === null || category === void 0 ? void 0 : category.value,
                            sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                            skuID: skuID
                        };
                    });
                    setData(productData);
                } catch (e) {
                    setData([]);
                }
            } else {
                setData([]);
            }
        };
        getProducts();
    }, [
        recommendations,
        config
    ]);
    return data && data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MoreFromCollection_index_module_default()).moreFromCollectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-more-from-collection ".concat(productType === producttype ? "parts" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pdp-more-from-collection__title",
                    children: title
                }),
                productType === producttype ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "pdp-more-from-collection__parts",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: partNumber
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: partName
                                })
                            ]
                        }),
                        data.map((item, i)=>{
                            const url = (0,helper/* getPDPUrlWithConfig */.Upy)(item.category, item.slug, plpServletPath, general);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": '{"eventAction":"pdp:more from collection:carousel image","eventName":"pdp:more from collection:carousel image","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(item.name, '","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:cross-sell:more from collection","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                            href: "".concat(url).concat((url === null || url === void 0 ? void 0 : url.includes("?type=part")) ? "&" : "?", "skuId=").concat(item.sku),
                                            alt: item.name,
                                            children: item.skuID
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-more-from-collection__part-name",
                                        children: item.name
                                    })
                                ]
                            }, i);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-more-from-collection__track",
                    children: data.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pdp-more-from-collection__product",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": '{"eventAction":"pdp:more from collection:carousel image","eventName":"pdp:more from collection:carousel image","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(item.name, '","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:cross-sell:more from collection","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                href: (0,helper/* getPDPUrlWithConfig */.Upy)(item.category, item.slug, plpServletPath, general),
                                alt: item.name,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.image,
                                    onError: (e)=>e.target.src = image_missing/* default */.Z,
                                    className: "pdp-more-from-collection__image",
                                    alt: item.name
                                })
                            })
                        }, i))
                })
            ]
        })
    });
};
/* harmony default export */ var v3_MoreFromCollection = (MoreFromCollection);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/analytics.js

const addDownloadFilesAnalytics = function() {
    let productInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedFiles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], hasError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // add analytics
    const selectedFileList = [];
    selectedFiles.forEach((selectedObj)=>{
        const fileNameAndFileType = (selectedObj.title + "." + selectedObj.type).toLowerCase();
        selectedFileList.push(fileNameAndFileType);
    });
    const selectedUrlList = selectedFiles.map((selectedObj)=>selectedObj.url.toLowerCase());
    if (selectedFileList.length && window.adobeDataLayer) {
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = {
            eventAction: "pdp:design files:download",
            eventName: "pdp:design files:download",
            eventType: "navigation",
            eventMsg: hasError ? "download failed" : "success",
            eventStatus: hasError ? "failure" : "success",
            internalLinkName: selectedFileList.join(":"),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:download",
            internalLinkZoneName: "pdp:design files",
            internalLinkURL: selectedUrlList.join(":"),
            clickInternalLinks: "true"
        };
        const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo: dataLayerProductInfo
        });
    }
};
const addDownloadFilesAnalyticsInstSup = function() {
    let productInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", errMsg = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", link = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref;
    const title = type.toLowerCase().trim();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        eventAction: "pdp:installation & support:guides:".concat(title),
        eventName: "pdp:installation & support:guides:".concat(title),
        eventType: "navigation",
        eventMsg: errMsg || "success",
        eventStatus: errMsg ? "failure" : "success",
        internalLinkName: "".concat(title, " | ").concat(link.replace("https://www.us.kohler.com/webassets", "")),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:installation & support:".concat(title),
        internalLinkZoneName: "pdp:installation & support",
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo: dataLayerProductInfo
    });
};
const getEventInfoProdAccordion = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", tabName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, link = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", errMsg = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    var ref, ref1, ref2, ref3, ref4;
    const text = type.toLowerCase().trim();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventMsg = text === "view more" ? "n/a" : errMsg || "success";
    const eventStatus = text === "view more" ? "n/a" : errMsg ? "failure" : "success";
    const internalLinkName = "".concat(text).concat(text === "specifications sheet" ? " | ".concat(link.replace("https://www.us.kohler.com/webassets", "")) : "");
    const eventInfo = {
        eventAction: "".concat(page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType, ":").concat(tabName, ":").concat(text),
        eventName: "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType, ":").concat(tabName, ":").concat(text),
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName,
        internalLinkPosition: "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType),
        internalLinkType: "".concat(page === null || page === void 0 ? void 0 : (ref3 = page.category) === null || ref3 === void 0 ? void 0 : ref3.pageType, ":").concat(tabName, ":").concat(text),
        internalLinkZoneName: "".concat(page === null || page === void 0 ? void 0 : (ref4 = page.category) === null || ref4 === void 0 ? void 0 : ref4.pageType, ":").concat(tabName),
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const accordianAnalyticsData = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isExpanded = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const title = type.toLowerCase().trim();
    const eventInfo = {
        eventAction: "pdp:product details:accordion ".concat(isExpanded ? "collapse" : "expand"),
        eventName: "pdp:product details:accordion ".concat(isExpanded ? "collapse" : "expand"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isExpanded ? "collapse" : "expand"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(title),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const dimensionsTooltipAnalyticsData = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, message = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", needsJSON = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref;
    const title = type.toLowerCase().trim();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        eventAction: "pdp:product details:".concat(title, " mouseover"),
        eventName: "pdp:product details:".concat(title, " mouseover"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: message,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:mouseover:".concat(title),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo: dataLayerProductInfo
    });
};
const getEventInfoInstSup = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", avoidTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, url = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const addedTitle = avoidTitle ? "" : ":" + (0,helper/* sanitizeTextForAnalytics */.T68)(title);
    const typeText = type ? ":".concat(type) : "";
    return JSON.stringify({
        eventAction: "pdp:installation and support".concat(typeText).concat(addedTitle),
        eventName: "pdp:installation and support".concat(typeText).concat(addedTitle),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,helper/* sanitizeTextForAnalytics */.T68)(title),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:navigation",
        internalLinkZoneName: "pdp:installation and support",
        internalLinkURL: url ? (url.indexOf("http") === -1 ? window.location.origin : "") + url : "n/a",
        clickInternalLinks: "true"
    });
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordionList/utils.js
var ProductAccordionList_utils = __webpack_require__(4464);
// EXTERNAL MODULE: ./public/icons/2D-plan.svg
var _2D_plan = __webpack_require__(10108);
// EXTERNAL MODULE: ./public/icons/2D-front.svg
var _2D_front = __webpack_require__(11534);
// EXTERNAL MODULE: ./public/icons/2D-side.svg
var _2D_side = __webpack_require__(3089);
// EXTERNAL MODULE: ./public/icons/3D.svg
var _3D = __webpack_require__(65317);
// EXTERNAL MODULE: ./public/icons/3D-BIM.svg
var _3D_BIM = __webpack_require__(59363);
// EXTERNAL MODULE: ./public/icons/cutout.svg
var cutout = __webpack_require__(24425);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/designFiles.jsx














const DesignFiles = (props)=>{
    const { files ={} , staticTexts ={} , sku ="" , productInfo =""  } = props;
    const [selectedFiles, setSelectedFiles] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const handleSelect = (checked, clickedItem, title)=>{
        clickedItem.title = title;
        if (checked) setSelectedFiles([
            ...selectedFiles,
            clickedItem
        ]);
        else setSelectedFiles(selectedFiles.filter((item)=>item.url !== clickedItem.url));
    };
    const handleSelectAll = (checked)=>{
        if (checked) {
            const selected = [];
            files.twoDimension.plan.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "2D Plan";
                selected.push(newObj);
            });
            files.twoDimension.front.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "2D Front";
                selected.push(newObj);
            });
            files.twoDimension.side.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "2D Side";
                selected.push(newObj);
            });
            files.threeDimension.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "3D File";
                selected.push(newObj);
            });
            files.bim.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "Bim";
                selected.push(newObj);
            });
            files.cutout.forEach((obj)=>{
                const newObj = obj;
                newObj.title = "Cutout";
                selected.push(newObj);
            });
            setSelectedFiles(selected);
        } else setSelectedFiles([]);
    };
    const handleDownloadError = ()=>{
        setLoading(false);
        dispatch((0,genericSlice/* showToast */.CF)("Download failed"));
        addDownloadFilesAnalytics(productInfo, selectedFiles, true);
    };
    const handleDownload = ()=>{
        const urlList = selectedFiles.map((item)=>item.url);
        if (selectedFiles.length > 1) {
            setLoading(true);
            (0,helper/* handleZipDownload */.G12)(urlList, sku, ()=>{
                setLoading(false);
                addDownloadFilesAnalytics(productInfo, selectedFiles);
            }, handleDownloadError);
        } else if (urlList[0]) {
            window.open(urlList[0], "_blank");
            addDownloadFilesAnalytics(productInfo, selectedFiles);
        }
    };
    const designFilesLength = files.twoDimension.plan.length + files.twoDimension.front.length + files.twoDimension.side.length + files.threeDimension.length + files.bim.length + files.cutout.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pdp-technical-tile__download-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pdp-technical-tile__select-all",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "selectAllfiles",
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        inline: true,
                        textClassName: "checkbox_default_text",
                        tabIndex: 0,
                        value: staticTexts.selectAll,
                        checked: designFilesLength > 0 && selectedFiles.length === designFilesLength,
                        onChange: (e)=>handleSelectAll(e.target.checked),
                        disabled: !designFilesLength
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-technical-tile__button-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    role: "button",
                    loading: loading,
                    customClass: "pdp-technical-tile__download-btn",
                    size: "small",
                    onClick: ()=>handleDownload(),
                    flexible: true,
                    label: "".concat(staticTexts.download, " ").concat(selectedFiles.length > 0 ? selectedFiles.length + " " + (selectedFiles.length === 1 ? staticTexts.file : staticTexts.files) : ""),
                    disabled: selectedFiles.length === 0,
                    useDefaultClass: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-technical-tile__files",
                children: [
                    files.twoDimension.plan.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _2D_plan/* default */.Z === null || _2D_plan/* default */.Z === void 0 ? void 0 : _2D_plan/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.twoDplan
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.twoDimension.plan.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.twoDplan, "  ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "2D Plan")
                                    }, i))
                            })
                        ]
                    }),
                    files.twoDimension.front.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _2D_front/* default */.Z === null || _2D_front/* default */.Z === void 0 ? void 0 : _2D_front/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.twoDfront
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.twoDimension.front.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.twoDfront, " ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "2D Front")
                                    }, i))
                            })
                        ]
                    }),
                    files.twoDimension.side.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _2D_side/* default */.Z === null || _2D_side/* default */.Z === void 0 ? void 0 : _2D_side/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.twoDside
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.twoDimension.side.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.twoDside, " ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "2D Side")
                                    }, i))
                            })
                        ]
                    }),
                    files.threeDimension.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _3D/* default */.Z === null || _3D/* default */.Z === void 0 ? void 0 : _3D/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.threeDfile
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-group",
                                children: files.threeDimension.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        inline: true,
                                        textClassName: "checkbox_default_text",
                                        value: item.type,
                                        checkBoxAria: "".concat(staticTexts.threeDfile, " ").concat(item.type),
                                        checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                        onChange: (e)=>handleSelect(e.target.checked, item, "3D File")
                                    }, i))
                            })
                        ]
                    }),
                    files.bim.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: _3D_BIM/* default */.Z === null || _3D_BIM/* default */.Z === void 0 ? void 0 : _3D_BIM/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.bimFile
                                    })
                                ]
                            }),
                            files.bim.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    inline: true,
                                    textClassName: "checkbox_default_text",
                                    value: item.type,
                                    checkBoxAria: "".concat(staticTexts.bimFile, " ").concat(item.type),
                                    checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                    onChange: (e)=>handleSelect(e.target.checked, item, "Bim")
                                }, i))
                        ]
                    }),
                    files.cutout.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdp-technical-tile__file-type",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pt-0",
                                        alt: "",
                                        "aria-hidden": "true",
                                        src: cutout/* default */.Z === null || cutout/* default */.Z === void 0 ? void 0 : cutout/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-technical-tile__file-type__title",
                                        children: staticTexts.cutoutTemplate
                                    })
                                ]
                            }),
                            files.cutout.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    inline: true,
                                    textClassName: "checkbox_default_text",
                                    checkBoxAria: "".concat(staticTexts.cutoutTemplate, " ").concat(item.type),
                                    value: item.type,
                                    checked: selectedFiles.find((obj)=>obj.url === item.url) ? true : false,
                                    onChange: (e)=>handleSelect(e.target.checked, item, "Cutout")
                                }, i))
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductAccordionList_designFiles = (DesignFiles);

// EXTERNAL MODULE: ./components/VideoWrapper/index.module.scss
var VideoWrapper_index_module = __webpack_require__(7187);
var VideoWrapper_index_module_default = /*#__PURE__*/__webpack_require__.n(VideoWrapper_index_module);
;// CONCATENATED MODULE: ./components/VideoWrapper/VideoModal.jsx






const VideoModal = (props)=>{
    const { isWhiteCloseIcon ="" , videoId ="" , onClose =()=>{}  } = props;
    const [showModal, setShowModal] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setShowModal(true);
        (0,helper/* preventBodyScroll */.MVu)(true);
        return ()=>(0,helper/* preventBodyScroll */.MVu)(false);
    }, []);
    const closeModal = ()=>{
        setShowModal(false);
        onClose();
        (0,helper/* preventBodyScroll */.MVu)(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (VideoWrapper_index_module_default()).videoModalWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "video-modal__content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    onModalClose: closeModal,
                    showModal: showModal,
                    isWhiteCloseIcon: isWhiteCloseIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoWrapper, {
                        videoId: videoId,
                        isPopup: showModal,
                        width: "100%"
                    })
                })
            })
        })
    });
};
/* harmony default export */ var VideoWrapper_VideoModal = (VideoModal);

// EXTERNAL MODULE: ./components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(17169);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartsViewer.jsx + 171 modules
var v2_PartsViewer = __webpack_require__(39627);
;// CONCATENATED MODULE: ./public/icons/video-file.svg
/* harmony default export */ var video_file = ({"src":"/_next/static/media/video-file.17b65f7d.svg","height":14,"width":12});
// EXTERNAL MODULE: ./public/icons/parts-diagram.svg
var parts_diagram = __webpack_require__(93056);
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/installationSupport.jsx













const InstallationSupport = (props)=>{
    var ref, ref1;
    const { files ={} , staticTexts ={} , productInfo ={} , svgFileMap =[]  } = props;
    const [videoModal, setVideoModal] = (0,react.useState)({
        show: false,
        id: ""
    });
    const [partsModal, setPartsModal] = (0,react.useState)({
        show: false,
        id: ""
    });
    const [general, setGeneral] = (0,react.useState)(null);
    const partsRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const handleDownload = (e, link, title)=>{
        e.stopPropagation();
        const linkUrl = link.trim();
        let errMsg;
        try {
            window.open(linkUrl, "_blank");
        } catch (err) {
            errMsg = err.message;
        }
        addDownloadFilesAnalyticsInstSup(productInfo, title, errMsg, linkUrl);
    };
    const closeModal = (type)=>{
        if (type === "parts") {
            (0,helper/* scrollToElement */.kIi)(partsRef);
            setPartsModal({
                show: false,
                id: ""
            });
        } else if (type === "video") {
            (0,helper/* scrollToElement */.kIi)(videoRef);
            setVideoModal({
                show: false,
                id: ""
            });
        }
    };
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2: isPartsViewerV2Enabled = false  } = featureFlags;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            partsModal.show && (isPartsViewerV2Enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsViewer/* default */.Z, {
                productId: files.productId,
                partId: partsModal.id,
                showModal: partsModal.show,
                page: "pdp",
                onClose: ()=>closeModal("parts"),
                analyticsCustomData: productInfo,
                fileMap: svgFileMap
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                productId: files.productId,
                partId: partsModal.id,
                showModal: partsModal.show,
                page: "pdp",
                onClose: ()=>closeModal("parts"),
                analyticsCustomData: productInfo
            })),
            videoModal.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper_VideoModal, {
                videoId: videoModal.id,
                onClose: ()=>closeModal("video")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-install-support__download-section",
                children: [
                    (files.guides.installationGuides.length > 0 || files.guides.supportGuides.length > 0 || files.videos.length > 0 || files.partsLinks.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-support-files__install-support",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__install",
                                children: (files.guides.installationGuides.length > 0 || files.guides.supportGuides.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdp-technical-tile__files --technical-info --installation ".concat(files.guides.supportGuides.length > 0 ? "--technical-info__border" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pdp-support-files__sub-heading",
                                            children: staticTexts.guides
                                        }),
                                        (files === null || files === void 0 ? void 0 : (ref = files.guides) === null || ref === void 0 ? void 0 : ref.installationGuides) && files.guides.installationGuides.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-technical-tile__file",
                                                    onClick: (e)=>handleDownload(e, item.url, item.title),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, i);
                                        }),
                                        (files === null || files === void 0 ? void 0 : (ref1 = files.guides) === null || ref1 === void 0 ? void 0 : ref1.supportGuides) && files.guides.supportGuides.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-technical-tile__file",
                                                    onClick: (e)=>handleDownload(e, item.url, item.title),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, i);
                                        })
                                    ]
                                })
                            }),
                            files.videos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-support-files__support ".concat(files.guides.installationGuides.length + files.guides.supportGuides.length === 0 ? "mt-0" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__sub-heading",
                                        children: staticTexts.installVideo
                                    }),
                                    files.videos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__videos",
                                        role: "list",
                                        ref: videoRef,
                                        children: files.videos.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                role: "listitem",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-support-files__links gbh-data-layer pdp-support-files__file-type",
                                                    "data-gbh-data-layer": getEventInfoInstSup(item.title, "installation video"),
                                                    "data-gbh-data-layer-custom": productInfo,
                                                    onClick: ()=>setVideoModal({
                                                            show: true,
                                                            id: item.id
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: video_file === null || video_file === void 0 ? void 0 : video_file.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, item.id);
                                        })
                                    })
                                ]
                            }),
                            files.partsLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-support-files__parts-links ".concat(files.guides.installationGuides.length + files.guides.supportGuides.length + files.videos.length === 0 ? "mt-0" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__sub-heading",
                                        children: staticTexts.partsDiagram
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-support-files__parts-link",
                                        role: "list",
                                        ref: partsRef,
                                        children: files.partsLinks.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                role: "listitem",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    role: "button",
                                                    tabIndex: "0",
                                                    className: "pdp-support-files__links gbh-data-layer",
                                                    "data-gbh-data-layer": getEventInfoInstSup(item.title, "interactive parts diagram", true),
                                                    "data-gbh-data-layer-custom": productInfo,
                                                    onClick: ()=>setPartsModal({
                                                            show: true,
                                                            id: item.id
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: parts_diagram/* default */.Z === null || parts_diagram/* default */.Z === void 0 ? void 0 : parts_diagram/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, item.id);
                                        })
                                    })
                                ]
                            }),
                            files.pdfPartsLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__install pdf-support-files",
                                role: "list",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdp-technical-tile__files --technical-info --installation ".concat(files.pdfPartsLinks.length > 0 ? "--technical-info__border" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pdp-support-files__sub-heading",
                                            children: staticTexts.partsDiagram
                                        }),
                                        files.pdfPartsLinks.map((item, i)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp-technical-tile__file",
                                                    onClick: (e)=>handleDownload(e, item.id, item.title),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "",
                                                            "aria-hidden": "true",
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        }),
                                                        item.title
                                                    ]
                                                })
                                            }, i);
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    files.supportLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-support-files__support-links",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__sub-heading",
                                children: staticTexts.helpfulLinks
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-support-files__support-link",
                                role: "list",
                                children: files.supportLinks.map((item, i)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "pdp-support-files__links gbh-data-layer",
                                            "data-gbh-data-layer": getEventInfoInstSup(item.ctaLabel, "", false, item.ctaLink),
                                            "data-gbh-data-layer-custom": productInfo,
                                            href: (0,helper/* getShortenedUrlwithGeneral */.vu1)(item === null || item === void 0 ? void 0 : item.ctaLink, general),
                                            target: item.newTab ? "_blank" : "",
                                            rel: "noreferrer",
                                            children: (0,helper/* decodeHtmlCharacters */.qOB)(item.ctaLabel)
                                        })
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductAccordionList_installationSupport = (InstallationSupport);

// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/productAccordion.jsx




const productAccordion = (props)=>{
    const { title ="" , analyticTitleData =null , analyticTitleCustomData =null , showOnPrint =false , handleOpen =()=>{} , handleClose =()=>{} , isOpen =false , children =undefined  } = props;
    const CollapsibleHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "collapsible__header gbh-data-layer",
            "data-gbh-data-layer": analyticTitleData,
            "data-gbh-data-layer-custom": analyticTitleCustomData,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "heading",
                    "aria-level": "2",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pdp-support-files container-fluid ".concat(!showOnPrint ? "no-print" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-support-files__content collapsible-accordion",
            "data-testid": "product-accordion-".concat(title),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {}),
                onTriggerOpening: handleOpen,
                onTriggerClosing: handleClose,
                triggerOpenedClassName: "collapsible__trigger--open",
                open: isOpen,
                openedClassName: "collapsible--open",
                transitionTime: 400,
                tabIndex: "0",
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,utils_0/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,utils_0/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters px-0",
                    "data-testid": "colapse-data-".concat(title),
                    "aria-disabled": isOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-support-files__download-section col-12",
                        children: children
                    })
                })
            })
        })
    });
};
/* harmony default export */ var ProductAccordionList_productAccordion = (productAccordion);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/SetListData/index.js



const SetListData = (props)=>{
    const { listData =[] , showType , productAccordionText ={} , productInfo , tabName =""  } = props;
    const [viewMore, setViewMore] = (0,react.useState)({
        [productAccordionText.features]: false,
        [productAccordionText.technologies]: false,
        [productAccordionText.hydrotherapy]: false,
        [productAccordionText.material]: false,
        [productAccordionText.rebates]: false,
        [productAccordionText.installation]: false,
        [productAccordionText.props65Warning]: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "pdp-features-technologies__feature-list",
                children: listData.map((item, i)=>(i < 5 || i > 4 && viewMore[showType]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "pdp-features-technologies__list-item",
                        children: item
                    }, i))
            }),
            listData.length > 5 && !viewMore[showType] && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "pdp-features-technologies__view-more gbh-data-layer",
                "data-gbh-data-layer": getEventInfoProdAccordion(productAccordionText.viewMore, tabName),
                "data-gbh-data-layer-custom": productInfo,
                onClick: ()=>setViewMore({
                        ...viewMore,
                        [showType]: true
                    }),
                children: productAccordionText.viewMore
            })
        ]
    });
};
/* harmony default export */ var ProductAccordionList_SetListData = (SetListData);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/Features/index.js


const Features = (props)=>{
    const { data: { isExpanded: { feature: isExpanded = false  } = {} , featuresData , productAccordionText ={} , productAccordionText: { features =""  } = {} , watersense =[]  } = {}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pdp-features-technologies__content",
        "aria-hidden": isExpanded ? "false" : "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-features-technologies__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_SetListData, {
                    listData: featuresData,
                    showType: features,
                    tabName: "features",
                    productAccordionText: productAccordionText
                }),
                watersense.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-features-technologies__icons",
                    children: watersense.map((icon, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: icon,
                            alt: "watersense icon"
                        }, i))
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ProductAccordionList_Features = (Features);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/Specs/utils.js

const handleSpecsDownload = function(e, title, link) {
    let productInfo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var ref;
    e.stopPropagation();
    let errMsg;
    const url = link.trim();
    try {
        window.open(url, "_blank");
    } catch (err) {
        errMsg = err.message;
    }
    const eventInfo = getEventInfoProdAccordion(title, "specs", true, url, errMsg);
    const dataLayerProductInfo = productInfo ? (ref = JSON.parse(productInfo)) === null || ref === void 0 ? void 0 : ref.productInfo : null;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: dataLayerProductInfo
    });
};

;// CONCATENATED MODULE: ./public/icons/dimension-tooltip.svg
/* harmony default export */ var dimension_tooltip = ({"src":"/_next/static/media/dimension-tooltip.930908e2.svg","height":30,"width":30});
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/RowData/index.jsx





const RowData = (param)=>{
    let { data , accordionType , productInfo , config ={}  } = param;
    const [activeTooltipIdx, setActiveTooltipIdx] = (0,react.useState)(-1);
    const { regexPattern: { map: { productDimensionsRegex =""  }  } = {}  } = config;
    const removeSpecialChars = (str)=>{
        const strValue = String(str || "");
        const regex = new RegExp(productDimensionsRegex);
        return strValue.replace(regex, "");
    };
    const tooltipHover = (index, message)=>{
        setActiveTooltipIdx(index);
        dimensionsTooltipAnalyticsData(accordionType, productInfo, message);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pdp-dimensions__container",
        children: data.map((d, index)=>{
            var ref;
            return d.value ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-dimensions__label ".concat(index % 2 === 0 ? "pdp-dimensions__highlighted" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: d.label
                            }),
                            d.tooltip ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pdp-dimensions__tooltipIcon",
                                        src: dimension_tooltip === null || dimension_tooltip === void 0 ? void 0 : dimension_tooltip.src,
                                        alt: "Tooltip",
                                        onMouseLeave: ()=>{
                                            setActiveTooltipIdx(-1);
                                        },
                                        onMouseOver: ()=>{
                                            tooltipHover(index, d.tooltip);
                                        },
                                        onBlur: ()=>{
                                            setActiveTooltipIdx(-1);
                                        }
                                    }),
                                    activeTooltipIdx === index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                        message: d.tooltip
                                    }) : null
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pdp-dimensions__value ".concat(index % 2 === 0 ? "pdp-dimensions__highlighted" : ""),
                        children: "".concat(removeSpecialChars(d.value), " ").concat((ref = d === null || d === void 0 ? void 0 : d.unit) !== null && ref !== void 0 ? ref : "")
                    })
                ]
            }, index) : null;
        })
    });
};
/* harmony default export */ var ProductAccordionList_RowData = (RowData);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/Specs/index.js





const Specs = (props)=>{
    const { data: { techFiles , specsDetails , productAccordionText , productInfo  } = {} , dimensionsData =[] , config ={}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-technical-tile__files --specs-info",
                children: techFiles.map((item, i)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-technical-tile__file",
                            role: "link",
                            tabIndex: 0,
                            onClick: (e)=>handleSpecsDownload(e, item.title, item.url, productInfo),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "",
                                    "aria-hidden": "true",
                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.title
                                })
                            ]
                        })
                    }, i);
                })
            }),
            dimensionsData.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-dimensions__specs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_RowData, {
                    data: dimensionsData,
                    accordionType: "specifications",
                    productInfo: productInfo,
                    config: config
                })
            }) : null,
            specsDetails.map((subCategory, i)=>subCategory.specList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pdp-spec-detail__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "pdp-spec-detail__title",
                            children: subCategory.specTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_SetListData, {
                            listData: subCategory.specList,
                            showType: subCategory.specTitle,
                            productAccordionText: productAccordionText,
                            productInfo: productInfo,
                            tabName: "specs"
                        })
                    ]
                }, i))
        ]
    });
};
/* harmony default export */ var ProductAccordionList_Specs = (Specs);

// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/DesignServices/analytics.js
const analytics_getEventInfo = (type, url)=>{
    return JSON.stringify({
        eventAction: "pdp:cross-sell:kohler professional services:".concat(type),
        eventName: "pdp:cross-sell:kohler professional services:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:bathroom design services",
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        internalLinkURL: url ? (url.indexOf("http") === -1 ? window.location.origin : "") + url : "n/a",
        clickInternalLinks: "true"
    });
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/DesignServices/index.module.scss
var DesignServices_index_module = __webpack_require__(29742);
var DesignServices_index_module_default = /*#__PURE__*/__webpack_require__.n(DesignServices_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/DesignServices/index.jsx
















const DesignServices = (props)=>{
    var ref, ref1, ref2, ref3;
    const { width =0 , staticTexts ={} , designServiceAPIData =[] , locale ="" , currencyCode ="" , currencySign ="" , designServiceListData ={} , pdpType ="" , replaceAddToCart =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , disableEcommerce =false , cart ={} , sku =""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const quantity = 1;
    const [general, setGeneral] = (0,react.useState)({});
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [ctaLink, setCtaLink] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const { general  } = config;
            setGeneral(general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            var _cartLandingPagePath;
            (0,helper/* getShortenedUrl */.Ppy)((_cartLandingPagePath = general.cartLandingPagePath) !== null && _cartLandingPagePath !== void 0 ? _cartLandingPagePath : "/").then((res)=>setCartUrl(res));
        }
    }, [
        general
    ]);
    (0,react.useEffect)(()=>{
        if (designServiceListData === null || designServiceListData === void 0 ? void 0 : designServiceListData.ctaLink) {
            (0,helper/* getShortenedUrl */.Ppy)(designServiceListData.ctaLink).then((res)=>setCtaLink(res));
        }
    }, [
        designServiceListData.ctaLink
    ]);
    const addtoCart = (item)=>{
        const { quantity  } = item;
        const { serviceItemsAdded , yourCart  } = staticTexts;
        const itemCountMessage = "".concat(quantity, " ").concat(serviceItemsAdded, " ");
        const ToasterMsg = "".concat(itemCountMessage, "<a href=").concat(cartUrl, ">").concat(yourCart, "</a>.");
        (0,addTocart/* addToCartItem */.q)([
            {
                ...item,
                isBundle: false,
                backorder: false
            }
        ]).then((response)=>{
            const body = {
                actions: response
            };
            dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                if (res) {
                    if (dist_lib/* isMobile */.tq) {
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: ToasterMsg,
                            isVisible: true
                        }));
                    } else {
                        dispatch((0,genericSlice/* showPreviewCart */.z0)());
                    }
                }
            });
        });
    };
    let percentDiscount;
    let percentType;
    const designServiceTitle = get_default()(designServiceAPIData[0], "name[".concat(locale, "]"), false);
    const masterVariant = get_default()(designServiceAPIData[0], "masterVariant", []);
    const masterVariantPrice = get_default()(masterVariant, "prices", []);
    const designServicePrice = Number(get_default()(masterVariantPrice.find((item)=>item.value.currencyCode === currencyCode), "value.centAmount", 0) / 100).toFixed(2);
    const isDiscount = get_default()(masterVariantPrice[0], "discounted", {});
    const designServiceDiscountedPrice = !isEmpty_default()(isDiscount) ? Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.value.centAmount", 0) / 100).toFixed(2) : 0;
    if ((isDiscount === null || isDiscount === void 0 ? void 0 : (ref = isDiscount.discount) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.value.type) === "absolute") {
        percentDiscount = designServiceDiscountedPrice > 0 && Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.discount.obj.value.money[0].centAmount", 0) / 100);
        percentType = "absolute";
    } else {
        percentDiscount = designServiceDiscountedPrice > 0 && Number(get_default()(masterVariantPrice.find((item)=>item.discounted.value.currencyCode === currencyCode), "discounted.discount.obj.value.permyriad", 0) / 100);
        percentType = "relative";
    }
    const masterVariantAttributes = get_default()(masterVariant, "attributes", []);
    const ProductWebFeatures = get_default()(masterVariantAttributes.find((attr)=>attr.name === "ProductWebFeatures"), "value", []);
    let desc = "";
    ProductWebFeatures.slice(0, 3).forEach((item)=>{
        desc += item[locale];
        if (desc && desc[desc.length - 1] !== ".") {
            desc += ". ";
        }
    });
    const customerFacingSKU = get_default()(masterVariantAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", []);
    const productBrand = get_default()(masterVariantAttributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", []);
    const discountPriceState = designServiceDiscountedPrice > 0 ? "percentOff|" + percentDiscount : "regular price";
    const handleAddToCart = ()=>{
        addtoCart({
            sku: sku,
            quantity: quantity,
            brand: productBrand
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (DesignServices_index_module_default()).designServicesWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pdp-design-services",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-design-services__title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: designServiceTitle ? designServiceTitle : staticTexts.bathroomDesignService
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-design-services__price",
                        children: [
                            designServicePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pdp-design-services__original-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            }),
                            designServiceDiscountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pdp-design-services__discount-price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "pdp-design-services__percent-discount",
                                        children: [
                                            percentType === "absolute" ? currencySign + percentDiscount : percentDiscount + "%",
                                            " ",
                                            staticTexts.percentOff
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: designServicePrice,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__left ".concat(width < 768 || width >= 1024 && width <= 1600 ? "--full-width" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-design-services__description",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: ProductWebFeatures.slice(0, 3).map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pdp-design-services__list-item",
                                    children: item[locale]
                                }, i))
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pdp-design-services__right ".concat(width < 768 || width >= 1024 && width <= 1600 ? "--full-width" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-design-services__button-tab",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: ctaLink,
                                className: "pdp-design-services__learn-more gbh-data-layer",
                                target: designServiceListData.newTab ? "_blank" : "_self",
                                "aria-label": staticTexts.ariaLabel.designServiceLearnMore,
                                "data-gbh-data-layer": analytics_getEventInfo("learn more", designServiceListData.ctaLink),
                                "data-gbh-data-layer-custom": '{"productInfo":{"productBrand":"'.concat(general === null || general === void 0 ? void 0 : (ref2 = general.siteName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","description":"').concat((0,helper/* sanitizeTextForAnalytics */.T68)(desc) || "n/a", '","frequency":"n/a","globalPromotionPrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","isRecommended":"n/a","isSendNow":"n/a","isSubscription":"n/a","priceState":"').concat(discountPriceState, '","productBasePrice":"').concat(designServicePrice || "n/a", '","productCategory":"design services","productColor":"n/a","productCoupondiscount":"n/a","productID":"').concat(customerFacingSKU || "n/a", '","productName":"').concat((0,helper/* sanitizeTextForAnalytics */.T68)(staticTexts.bathroomDesignService) || "n/a", '","productPartnerBuyNow":"n/a","productRoom":"design services","productSalePrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","productSaleable":"true","productStatus":"in stock","productSuperSku":false,"productTileName":"').concat((0,helper/* sanitizeTextForAnalytics */.T68)(staticTexts.bathroomDesignService) || "n/a", '","quantity":1,"defaultImageName":"n/a","ratings":"n/a","numberOfReviews":"n/a","pdpType":"').concat(pdpType, '","productFindingMethod":"n/a","productCollectionsName":"design services"}}'),
                                rel: "noreferrer",
                                children: designServiceListData.ctaLabel
                            }),
                            replaceAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                ariaLabel: replaceAddToCartCtaLabel,
                                label: replaceAddToCartCtaLabel,
                                size: "small",
                                type: "primary",
                                to: replaceAddToCartCtaLink,
                                target: linkNewTab ? "_blank" : "_self"
                            }) : "",
                            !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": analytics_getEventInfo("add to cart", "".concat(window.location.origin).concat(window.location.pathname)),
                                "data-gbh-data-layer-custom": '{"page":{"cart":{"cartID":"'.concat(cart === null || cart === void 0 ? void 0 : cart.id, '"}},"productInfo":{"productBrand":"').concat(general === null || general === void 0 ? void 0 : (ref3 = general.siteName) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","description":"').concat((0,helper/* sanitizeTextForAnalytics */.T68)(desc) || "n/a", '","frequency":"n/a","globalPromotionPrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","isRecommended":"n/a","isSendNow":"n/a","isSubscription":"n/a","priceState":"').concat(discountPriceState, '","productBasePrice":"').concat(designServicePrice || "n/a", '","productCategory":"design services","productColor":"n/a","productCoupondiscount":"n/a","productID":"').concat(customerFacingSKU || "n/a", '","productName":"').concat((0,helper/* sanitizeTextForAnalytics */.T68)(staticTexts.bathroomDesignService) || "n/a", '","productPartnerBuyNow":"n/a","productRoom":"design services","productSalePrice":"').concat(designServiceDiscountedPrice > 0 ? designServiceDiscountedPrice : designServicePrice, '","productSaleable":"true","productStatus":"in stock","productSuperSku":false,"productTileName":"').concat((0,helper/* sanitizeTextForAnalytics */.T68)(staticTexts.bathroomDesignService) || "n/a", '","quantity":1,"defaultImageName":"n/a","ratings":"n/a","numberOfReviews":"n/a","pdpType":"').concat(pdpType, '","productFindingMethod":"n/a","productCollectionsName":"design services"}}'),
                                role: "button",
                                ariaLabel: staticTexts.ariaLabel.addProductService,
                                label: staticTexts.addService,
                                size: "small",
                                type: "primary",
                                onClick: handleAddToCart,
                                useDefaultClass: true
                            }) : ""
                        ]
                    })
                })
            ]
        })
    });
};
DesignServices.defaultProps = {
    description: [],
    currencySign: "",
    price: "",
    staticTexts: {
        learnMore: "",
        addToCart: ""
    }
};
DesignServices.propTypes = {
    description: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    currencySign: (prop_types_default()).string.isRequired,
    price: (prop_types_default()).string.isRequired,
    staticTexts: prop_types_default().shape({
        learnMore: (prop_types_default()).string.isRequired,
        addToCart: (prop_types_default()).string.isRequired
    })
};
/* harmony default export */ var v3_DesignServices = ((0,dist_lib/* withOrientationChange */.Qe)(DesignServices));

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/AddOnService/index.js



const AddOnService = (props)=>{
    const { isDiscontinued , designServiceDataFromProp , productType , staticTexts , currencySign , businessUnitName , ProductPriceSpiderIncluded_s: productPriceSpiderIncludeds , ProductRequiredAccessoriesGroupsList , designServiceData , persona , replaceAddToCart , disableRatings , replaceAddToCartCtaLink , replaceAddToCartCtaLabel , linkNewTab , disableEcommerce , currencyCode , discontinuedProductb , superSku , locale , width  } = props;
    return !isDiscontinued && designServiceDataFromProp.map((list, i)=>{
        const { productType: productTypes = []  } = list;
        return productTypes.includes(productType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row no-gutters product-detail-page__design-services",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_DesignServices, {
                staticTexts: staticTexts,
                currencySign: currencySign,
                pdpType: (0,helper/* pdpTypeFormat */.V4r)({
                    businessUnitName,
                    ProductPriceSpiderIncluded_s: productPriceSpiderIncludeds,
                    discontinuedProductb,
                    ProductRequiredAccessoriesGroupsList,
                    superSku
                }),
                sku: list.sku,
                designServiceAPIData: designServiceData.filter((item)=>item.masterVariant.sku === list.sku),
                persona: persona,
                designServiceListData: list,
                currencyCode: currencyCode,
                locale: locale,
                width: width,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce
            })
        }, i);
    });
};
/* harmony default export */ var ProductAccordionList_AddOnService = (AddOnService);

// EXTERNAL MODULE: ./components/core/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(96724);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordionList/index.module.scss
var ProductAccordionList_index_module = __webpack_require__(92555);
var ProductAccordionList_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductAccordionList_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordionList/index.jsx
/* eslint-disable camelcase */ 













const ProductAccordionList = (props)=>{
    const { productData ={} , productSku ="" , productInfo ={} , isDiscontinued =false , persona ="" , staticTexts ={} , accordionList =[] , installationDataFromProp =[] , designServiceDataFromProp =[] , disableEcommerce =false , isProjectPack =false , installationSupportLinks =[] , productType ="" , productServices =[] , dimensionData ={} , config ={}  } = props;
    const { productAccordionText  } = staticTexts;
    const defaultExpand = {
        feature: false,
        dimensions: false,
        specs: false,
        designFile: false,
        installationSupport: false,
        addOnService: true
    };
    const designFiles = {
        twoDimension: {
            plan: [],
            front: [],
            side: []
        },
        threeDimension: [],
        bim: [],
        cutout: []
    };
    const techFiles = [];
    var ref;
    const installFiles = {
        productId: (ref = productData["ProductProductNo_s"]) !== null && ref !== void 0 ? ref : "",
        guides: {
            installationGuides: [],
            supportGuides: []
        },
        partsLinks: [],
        pdfPartsLinks: [],
        videos: [],
        supportLinks: []
    };
    const designFileType = {
        twoDimension: [
            {
                type: "DWG",
                fromProductData: "DWGPlanView",
                angleView: "plan"
            },
            {
                type: "DXF",
                fromProductData: "DXFPlanView",
                angleView: "plan"
            },
            {
                type: "DWG",
                fromProductData: "DWGFrontView",
                angleView: "front"
            },
            {
                type: "DXF",
                fromProductData: "DXFFrontView",
                angleView: "front"
            },
            {
                type: "DWG",
                fromProductData: "DWGSideView",
                angleView: "side"
            },
            {
                type: "DXF",
                fromProductData: "DXFSideView",
                angleView: "side"
            }
        ],
        threeDimension: [
            {
                type: "DWG",
                fromProductData: "3DDWGSymbol"
            },
            {
                type: "DXF",
                fromProductData: "3DDXFSymbol"
            },
            {
                type: "3DS",
                fromProductData: "3D3DS"
            },
            {
                type: "OBJ",
                fromProductData: "3DOBJ"
            },
            {
                type: "SKP",
                fromProductData: "3DSketchup"
            }
        ],
        bim: [
            {
                type: "RFA",
                fromProductData: "3DRevit"
            }
        ],
        cutout: [
            {
                type: "DXF",
                fromProductData: "CutOutDXF"
            }
        ]
    };
    const [isExpanded, setIsExpanded] = (0,react.useState)(defaultExpand);
    const [currentSku, setCurrentSku] = (0,react.useState)(productSku);
    const dimensionsData = (0,ProductAccordionList_utils/* getDimensionData */.S)(dimensionData);
    (0,react.useEffect)(()=>{
        if (productSku !== "" && currentSku !== productSku) {
            setCurrentSku(productSku);
            setTimeout(()=>{
                setIsExpanded(defaultExpand);
            }, 500);
        }
    }, [
        productSku
    ]);
    const organizeData = (data, name, placeHolder, type)=>data.map((item, i)=>{
            let obj = {
                title: name ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
            };
            if (type === "part") {
                obj = {
                    ...obj,
                    id: item
                };
            } else {
                obj = {
                    ...obj,
                    type,
                    url: item
                };
            }
            return obj;
        });
    Object.keys(designFileType).forEach((fileType)=>{
        designFileType[fileType] && designFileType[fileType].forEach((file)=>{
            if (productData["ProductResource.".concat(file.fromProductData, ".resourceFullWebURL_ss")]) {
                if (fileType === "twoDimension") {
                    designFiles[fileType][file.angleView].push({
                        type: file.type,
                        url: productData["ProductResource.".concat(file.fromProductData, ".resourceFullWebURL_ss")][0]
                    });
                } else {
                    designFiles[fileType].push({
                        type: file.type,
                        url: productData["ProductResource.".concat(file.fromProductData, ".resourceFullWebURL_ss")][0]
                    });
                }
            }
        });
    });
    const designFilesLength = designFiles.twoDimension.plan.length + designFiles.twoDimension.front.length + designFiles.twoDimension.side.length + designFiles.threeDimension.length + designFiles.bim.length + designFiles.cutout.length;
    const getListValue = (arrayVal, stringVal)=>{
        if (productData[arrayVal]) {
            return productData[arrayVal];
        } else if (productData[stringVal]) {
            return [
                productData[stringVal]
            ];
        } else {
            return [];
        }
    };
    const featuresData = getListValue("ProductWebFeatures_ss", "ProductWebFeatures_s");
    const techData = getListValue("ProductWebTechnology_ss", "ProductWebTechnology_s");
    const webmaterialData = getListValue("ProductWebMaterial_ss", "ProductWebMaterial_s");
    const webInstallationData = getListValue("ProductWebInstallation_ss", "ProductWebInstallation_s");
    const prop65WarningData = getListValue("ProductCaliforniaProp65WarningDisclaimer_ss", "ProductCaliforniaProp65WarningDisclaimer_s");
    const webRebatesData = getListValue("ProductWebRebates_ss", "ProductWebRebates_s");
    const webHydrotherapyData = getListValue("ProductWebHydrotherapy_ss", "ProductWebHydrotherapy_s");
    const badges = getListValue("ProductBadgeInfo_ss", "ProductBadgeInfo_s");
    // check for technical files
    if (productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]) {
        techFiles.push(...organizeData(productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"], productData["ProductResource.SpecPDFFileName.resourceTitle_ss"], productAccordionText.specsSheet, "PDF"));
    }
    if (productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"]) {
        techFiles.push(...organizeData(productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"], productData["ProductResource.EnvironProdDecl.resourceTitle_ss"], productAccordionText.envDeclaration, "PDF"));
    }
    const specDataLength = techData.length + webmaterialData.length + webInstallationData.length + prop65WarningData.length + webRebatesData.length + webHydrotherapyData.length + techFiles.length;
    const specsDetails = [
        {
            specTitle: productAccordionText.technologies,
            specList: techData
        },
        {
            specTitle: productAccordionText.hydrotherapy,
            specList: webHydrotherapyData
        },
        {
            specTitle: productAccordionText.material,
            specList: webmaterialData
        },
        {
            specTitle: productAccordionText.rebates,
            specList: webRebatesData
        },
        {
            specTitle: productAccordionText.installation,
            specList: webInstallationData
        }
    ];
    if (!disableEcommerce) {
        specsDetails.push({
            specTitle: productAccordionText.props65Warning,
            specList: prop65WarningData
        });
    }
    // check for installation & support files
    if (productData["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]) {
        installFiles.guides.installationGuides = organizeData(productData["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"], productData["ProductResource.InstallationWithoutSPPDF.resourceTitle_ss"], productAccordionText.installationGuide, "PDF");
    }
    if (productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"]) {
        installFiles.guides.supportGuides = organizeData(productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"], productData["ProductResource.HomeownersGuide.resourceTitle_ss"], productAccordionText.homeOwnerGuide, "PDF");
    }
    if (productData["ProductResource.YouTubeInstallVideo.resourceName_ss"]) {
        installFiles.videos = organizeData(productData["ProductResource.YouTubeInstallVideo.resourceName_ss"], productData["ProductResource.YouTubeInstallVideo.resourceTitle_ss"], productAccordionText.installationVideo, "part");
    }
    if (productData["ProductResource.InteractiveSVG.resourceName_ss"]) {
        installFiles.partsLinks = organizeData(productData["ProductResource.InteractiveSVG.resourceName_ss"], productData["ProductResource.InteractiveSVG.resourceTitle_ss"], productAccordionText.partsDiagram, "part");
    }
    if (productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"]) {
        installFiles.pdfPartsLinks = organizeData(productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"], productData["ProductResource.PartsPDFFileName.resourceTitle_ss"], productAccordionText.partsDiagram, "part");
    }
    // Get support pages links from content fragment
    installFiles.supportLinks = (installationSupportLinks === null || installationSupportLinks === void 0 ? void 0 : installationSupportLinks.length) ? installationSupportLinks : [];
    const installationFilesLength = installFiles.guides.installationGuides.length + installFiles.guides.supportGuides.length + installFiles.partsLinks.length + installFiles.videos.length;
    let listValue = [
        "Features",
        "Dimensions",
        "Specs",
        "Installation & Support",
        "Design Files"
    ];
    if (persona === "TVS" || persona === "TPR") {
        listValue = [
            "Features",
            "Dimensions",
            "Specs",
            "Design Files",
            "Installation & Support"
        ];
    } else if (accordionList.length > 0) {
        var ref1;
        listValue = accordionList.map((obj)=>{
            return (0,helper/* decodeHtmlCharacters */.qOB)((ref1 = obj === null || obj === void 0 ? void 0 : obj.value) !== null && ref1 !== void 0 ? ref1 : "");
        });
    }
    const isInstallService = installationDataFromProp.filter((obj)=>productServices && productServices.includes(obj.sku));
    const isDesignService = designServiceDataFromProp.filter((obj)=>obj.productType.includes(productType));
    const { feature , dimensions , specs , designFile , installationSupport , addOnService  } = isExpanded;
    const watersense = badges.map(function() {
        let badge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const watersenseList = badge.split("|");
        return watersenseList[2] || [];
    });
    const featrsData = {
        isExpanded,
        featuresData,
        productAccordionText,
        watersense
    };
    const specsData = {
        techFiles,
        specsDetails,
        productAccordionText,
        productInfo
    };
    const componentList = {
        Features: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_Features, {
                data: featrsData
            }),
            title: productAccordionText.features,
            isExpanded: isExpanded.feature,
            keyValue: "feature",
            showAccordion: featuresData.length > 0,
            analyticData: accordianAnalyticsData(productAccordionText.features, isExpanded.feature),
            isOpen: feature
        },
        Dimensions: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_RowData, {
                data: dimensionsData === null || dimensionsData === void 0 ? void 0 : dimensionsData.dimensions,
                accordionType: "dimensions",
                productInfo: productInfo,
                config: config
            }),
            title: productAccordionText.dimensions,
            isExpanded: isExpanded.dimensions,
            keyValue: "dimensions",
            showAccordion: dimensionsData && (dimensionsData === null || dimensionsData === void 0 ? void 0 : dimensionsData.enabled) && (dimensionsData === null || dimensionsData === void 0 ? void 0 : dimensionsData.dimensions),
            analyticData: accordianAnalyticsData("Dimensions", isExpanded.dimensions),
            isOpen: dimensions
        },
        Specs: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_Specs, {
                data: specsData,
                dimensionsData: dimensionsData === null || dimensionsData === void 0 ? void 0 : dimensionsData.specifications,
                config: config
            }),
            title: productAccordionText.specs,
            isExpanded: isExpanded.specs,
            keyValue: "specs",
            showAccordion: specDataLength > 0,
            analyticData: accordianAnalyticsData(productAccordionText.specs, isExpanded.specs),
            isOpen: specs
        },
        "Design Files": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_designFiles, {
                files: designFiles,
                staticTexts: productAccordionText,
                productInfo: productInfo,
                sku: productSku
            }),
            title: productAccordionText.designFiles,
            isExpanded: isExpanded.designFile,
            showAccordion: designFilesLength > 0,
            keyValue: "designFile",
            analyticData: accordianAnalyticsData(productAccordionText.designFiles, isExpanded.designFile),
            isOpen: designFile
        },
        "Installation & Support": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_installationSupport, {
                files: installFiles,
                staticTexts: productAccordionText,
                productInfo: productInfo,
                sku: true,
                productSku: true,
                svgFileMap: installFiles.partsLinks
            }),
            title: productAccordionText.installationSupport,
            isExpanded: isExpanded.installationSupport,
            showAccordion: installationFilesLength > 0,
            keyValue: "installationSupport",
            analyticData: accordianAnalyticsData(productAccordionText.installationSupport, isExpanded.installationSupport),
            isOpen: installationSupport
        },
        "Available Services": {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_AddOnService, {
                ...props
            }),
            title: productAccordionText.addOnServices,
            isExpanded: isExpanded.addOnService,
            showAccordion: !isDiscontinued && !disableEcommerce && (isInstallService.length > 0 || isDesignService.length > 0) && !isProjectPack,
            keyValue: "addOnService",
            analyticData: accordianAnalyticsData(productAccordionText.addOnServices, isExpanded.addOnService),
            isOpen: addOnService
        }
    };
    const setAccordianState = (type, isOpen)=>{
        if (!isOpen) {
            setTimeout(()=>{
                setIsExpanded({
                    ...isExpanded,
                    [type]: isOpen
                });
            }, 500);
        } else {
            setIsExpanded({
                ...isExpanded,
                [type]: isOpen
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Accordion_module_default()).accordionWrapper, " ").concat((ProductAccordionList_index_module_default()).productAccordionListWrapper),
        children: Object.keys(productData).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-support-files__container product-specifications",
            children: listValue.map((list)=>{
                var ref, ref1, ref2;
                if (list === "Dimensions" && !(dimensionsData === null || dimensionsData === void 0 ? void 0 : (ref = dimensionsData.dimensions) === null || ref === void 0 ? void 0 : ref.filter((d)=>d.value).length)) {
                    return null;
                }
                return ((ref1 = componentList[list]) === null || ref1 === void 0 ? void 0 : ref1.showAccordion) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordionList_productAccordion, {
                    title: componentList[list].title,
                    isOpen: (ref2 = componentList[list]) === null || ref2 === void 0 ? void 0 : ref2.isOpen,
                    showOnPrint: list === "Features" || list === "Specs",
                    handleOpen: ()=>setAccordianState(componentList[list].keyValue, true),
                    handleClose: ()=>setAccordianState(componentList[list].keyValue, false),
                    analyticTitleData: componentList[list].analyticData,
                    analyticTitleCustomData: productInfo,
                    children: componentList[list].element
                }, componentList[list].keyValue) : null;
            })
        })
    });
//   }
};
/* harmony default export */ var v3_ProductAccordionList = (ProductAccordionList);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback/localization.js

const useTranslations = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    return {
        feedBackTitle: t("kf.pdp.label.feedBackTitle")
    };
};
/* harmony default export */ var localization = (useTranslations);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback/analytics.js

const analytics_pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    const { productInfo  } = page;
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};
const addAnalyticsProvideFeedback = ()=>{
    const eventInfo = {
        eventAction: constants.PDP_FEEDBACK,
        eventName: constants.PDP_FEEDBACK,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "provide feedback",
        internalLinkPosition: "pdp",
        internalLinkType: constants.PDP_FEEDBACK,
        clickInternalLinks: "false",
        internalLinkZoneName: constants.PDP_FEEDBACK,
        internalLinkURL: ""
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo);
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback/index.module.scss
var Feedback_index_module = __webpack_require__(13175);
var Feedback_index_module_default = /*#__PURE__*/__webpack_require__.n(Feedback_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback/index.jsx




const Feedback = (props)=>{
    const { pdpJson: { feedbackButtonLabel ="" , feedbackFormID =""  } = {}  } = props || {};
    const { feedBackTitle =""  } = localization();
    const showFeedbackForm = ()=>{
        if (window.KAMPYLE_ONSITE_SDK) {
            if (feedbackFormID) {
                var ref;
                (ref = window.KAMPYLE_ONSITE_SDK) === null || ref === void 0 ? void 0 : ref.showForm(feedbackFormID);
            }
        }
        addAnalyticsProvideFeedback();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Feedback_index_module_default()).Feedback,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: feedBackTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "button",
                onClick: showFeedbackForm,
                children: feedbackButtonLabel
            })
        ]
    });
};
/* harmony default export */ var ProductDescription_Feedback = (Feedback);

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/Product3Dmodel.jsx





const Product3Dmodel = (param)=>{
    let { pdpJson ={} , sku ="" , nvznList =[] , vntanaList =[] , productInfo ={}  } = param;
    const [showModal, setShowModal] = (0,react.useState)(false);
    const openModal = ()=>{
        setShowModal(true);
        (0,analytics_analytics/* addAnalyticsForViewNowClick */.Y2)(productInfo);
    };
    const closeModal = ()=>{
        setShowModal(false);
        (0,analytics_analytics/* addAnalyticsForCloseClick */.f6)(productInfo);
    };
    const { iframeTitle ="" , iframeDescription ="" , iframeCTA ="" , fileReferenceIframe ="" , iframePlayers =[]  } = pdpJson;
    const areBothPlayersAvaialbe = nvznList.length && vntanaList.length;
    const availablePlayerIdParam = nvznList.length ? "NVZN" : "VNTANA";
    const filterWith = areBothPlayersAvaialbe ? "priorityIframe" : "iframeID";
    var ref;
    const iframeToConsider = (ref = iframePlayers.find((item)=>areBothPlayersAvaialbe ? item[filterWith] : item[filterWith].includes(availablePlayerIdParam))) !== null && ref !== void 0 ? ref : {};
    const { iframeURL ="" , iframeID =""  } = iframeToConsider;
    var ref1;
    const playerIds = (ref1 = iframeID === "NVZN" ? nvznList : vntanaList) !== null && ref1 !== void 0 ? ref1 : [];
    const getPlayerId = ()=>{
        const playerIdBasedSku = playerIds.filter((item)=>item.split("|")[0] === sku);
        return playerIdBasedSku.length ? playerIdBasedSku[0].split("|")[1] : "";
    };
    const playerId = getPlayerId();
    const pdp3DIframe = iframeURL.replace("{{ID}}", playerId);
    if (!playerId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-detail-page__3d-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__3d-modal--title",
                children: iframeTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__3d-modal--decs",
                children: iframeDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-detail-page__3d-modal--modal-popup",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-detail-page__3d-modal--icon",
                        children: [
                            fileReferenceIframe ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: fileReferenceIframe,
                                alt: iframeCTA
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-detail-page__3d-modal--button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    tabIndex: "0",
                                    role: "button",
                                    "aria-label": "view",
                                    onClick: openModal,
                                    children: iframeCTA
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                        showModal: showModal,
                        onModalClose: closeModal,
                        isWhiteCloseIcon: true,
                        children: pdp3DIframe ? (0,html_react_parser/* default */.ZP)(pdp3DIframe) : null
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductDetailView_Product3Dmodel = (Product3Dmodel);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./components/core/SlideDrawer/index.module.scss
var SlideDrawer_index_module = __webpack_require__(85218);
var SlideDrawer_index_module_default = /*#__PURE__*/__webpack_require__.n(SlideDrawer_index_module);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductOnDisplay/analytics.js
var ProductOnDisplay_analytics = __webpack_require__(2797);
;// CONCATENATED MODULE: ./components/core/SlideDrawer/index.js






const SlideDrawer = (props)=>{
    const { isOpen =false , title ="" , subTitle ="" , children , onClose  } = props;
    (0,react.useEffect)(()=>{
        if (isOpen) {
            document.querySelector("body").classList.add("drawer-open");
        } else {
            const drawerOpen = document.getElementsByClassName("drawer-open");
            if (drawerOpen.length > 0) {
                (0,ProductOnDisplay_analytics/* addAnalyticsCloseSliderProductOnDisplay */.gU)();
            }
            document.querySelector("body").classList.remove("drawer-open");
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((SlideDrawer_index_module_default()).SlideDrawerBackdrop, " "),
                onClick: onClose
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((SlideDrawer_index_module_default()).SlideDrawer, " ").concat(isOpen ? (SlideDrawer_index_module_default()).Open : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "close-btn",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: icons_close/* default */.Z,
                                    height: 17,
                                    width: 17,
                                    alt: "Close",
                                    onClick: ()=>onClose(false)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sub-title",
                                children: subTitle
                            })
                        ]
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ var core_SlideDrawer = (SlideDrawer);

// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductOnDisplay/utils.js
var ProductOnDisplay_utils = __webpack_require__(14899);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductOnDisplay/index.jsx














const DisplayItem = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5232).then(__webpack_require__.bind(__webpack_require__, 75232)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75232)
            ]
    }
});


const ProductOnDisplay = (props)=>{
    const { pdpJson ={} , productServices ={} , installationData ={} , currencyCode ="" , currencySign ="$" , brandName ="" , findStores ="" , colorsData ={} , shortendPagePath ="" , findStoreDetailsUrl ="" , productType ="" , productInfo ={} , getZipCode =()=>{} , productOnDisplayData ={} , isRetailProduct =false , isParts =false , isProductDiscontinued =false  } = props || {};
    const { locationTitles ="" , zipCodeToUpdate ="" , updateZipTitle ="" , productDisplayTitle ="" , addInstallServiceTitle ="" , changeZipCode ="" , yourZipCode ="" , serviceUnavailableTitle ="" , serviceUnavailableSectionHeading ="" , descriptionProductNotAvailable ="" , errorMessage ="" , multiDesignServices =[] , installServices =[] , zipCodeTitle ="" , buyMoreTitle ="" , buyMoreToolTip ="" , addServiceToCart ="" , productOnDisplay ={} , sectionHeadingProductNotAvailable  } = pdpJson;
    const { findTitle ="" , findDesc =""  } = productOnDisplay;
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [tooltip, setTooltip] = (0,react.useState)({
        buyMoreSaveMore: false
    });
    const [serviceDetails, setServiceDetails] = (0,react.useState)({});
    const [servicePrice, setServicePrice] = (0,react.useState)("");
    const [zipCodeInputVal, setZipCodeInputVal] = (0,react.useState)(utilityLocation);
    const [showAddanInstallCard, setShowAddanInstallCard] = (0,react.useState)(false);
    const [toggleZipCodeSection, setToggleZipCodeSection] = (0,react.useState)(zipCodeInputVal ? true : false);
    const [colorsDataState, setColorsDataState] = (0,react.useState)(colorsData);
    const [colorsDatahasChanged, setColorsDatahasChanged] = (0,react.useState)(false);
    const [findStoreUtilityDetails, setFindStoreUtilityDetails] = (0,react.useState)({});
    const [isSliderOpen, setIsSliderOpen] = (0,react.useState)(false);
    const learnMoreRef = (0,react.useRef)();
    const installSeriveRef = (0,react.useRef)();
    const isInitionalRender = (0,react.useRef)(true);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        if (!isEqual_default()(colorsData, colorsDataState)) {
            setColorsDataState(colorsData);
        }
    }, [
        colorsData
    ]);
    (0,react.useEffect)(()=>{
        if (showAddanInstallCard > 0) {
            if (installSeriveRef === null || installSeriveRef === void 0 ? void 0 : installSeriveRef.current) {
                var ref;
                installSeriveRef === null || installSeriveRef === void 0 ? void 0 : (ref = installSeriveRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                    if ((item === null || item === void 0 ? void 0 : item.getAttribute("listener")) !== "true") {
                        item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                            (0,ProductOnDisplay_utils/* servicesClick */.zP)(e, productInfo);
                        });
                    }
                });
            }
        }
        return ()=>{
            var ref;
            installSeriveRef === null || installSeriveRef === void 0 ? void 0 : (ref = installSeriveRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", ProductOnDisplay_utils/* servicesClick */.zP);
            });
        };
    }, [
        showAddanInstallCard,
        servicePrice
    ]);
    (0,react.useEffect)(()=>{
        if (utilityLocation) setZipCodeInputVal(utilityLocation);
    }, [
        utilityLocation
    ]);
    (0,react.useEffect)(()=>{
        isInitionalRender.current = true;
        if (!zipCodeInputVal) setZipCodeInputVal(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("currentZipCode"));
        handleCheckAvailability(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("currentZipCode"), true);
        fetchFindStoreUtilityDetails();
        if (learnMoreRef === null || learnMoreRef === void 0 ? void 0 : learnMoreRef.current) {
            var ref;
            learnMoreRef === null || learnMoreRef === void 0 ? void 0 : (ref = learnMoreRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                    (0,ProductOnDisplay_utils/* installserviceClickHandler */.YI)(e, productInfo);
                });
            });
        }
        return ()=>{
            var ref;
            learnMoreRef === null || learnMoreRef === void 0 ? void 0 : (ref = learnMoreRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", (e)=>{
                    (0,ProductOnDisplay_utils/* installserviceClickHandler */.YI)(e, productInfo);
                });
            });
        };
    }, []);
    const fetchFindStoreUtilityDetails = ()=>{
        (0,api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: findStoreDetailsUrl
            }
        }).then((response)=>{
            const { data ={}  } = response;
            if (response && data) {
                setFindStoreUtilityDetails(data);
            }
        }).catch((err)=>{
            console.log("Failed to get compare attributes JSON file", err);
        });
    };
    (0,react.useEffect)(()=>{
        if (productServices.length) {
            var ref;
            const qualifiedService = (ref = installServices.find((item)=>item.sku === productServices[0])) !== null && ref !== void 0 ? ref : {};
            setServiceDetails(qualifiedService);
            if (installationData.length) {
                var ref1;
                const qaulifiedServiceBusinessData = (ref1 = installationData.find((item)=>item.masterVariant.sku === productServices[0])) !== null && ref1 !== void 0 ? ref1 : {};
                const { masterVariant: { prices =[]  } = {}  } = qaulifiedServiceBusinessData !== null && qaulifiedServiceBusinessData !== void 0 ? qaulifiedServiceBusinessData : {};
                if (prices.length) {
                    var ref2;
                    const priceObj = (ref2 = prices.find((item)=>item.value.currencyCode === currencyCode)) !== null && ref2 !== void 0 ? ref2 : {};
                    const { value: { centAmount =""  } = {}  } = priceObj;
                    const installationPrice = Number(centAmount / 100).toFixed(2);
                    setServicePrice(installationPrice);
                }
            }
        }
    }, [
        productServices,
        installationData
    ]);
    (0,react.useEffect)(()=>{
        if (!colorsDatahasChanged) setColorsDatahasChanged(true);
    }, [
        colorsDataState
    ]);
    const handleFieldInfoMouseOver = function() {
        let tooltipFor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "buyMoreSaveMore", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setTooltip({
            ...tooltip,
            [tooltipFor]: value
        });
    };
    const handlerForAddServiceClick = (e)=>{
        e.stopPropagation();
        (0,ProductOnDisplay_utils/* handleAddToCart */.Pq)({
            e,
            productServices,
            zipCodeInputVal,
            brandName
        });
        (0,analytics_analytics/* addAnalyticsForAddService */.I6)(addServiceToCart, productInfo, serviceDetails.sectionHeading, servicePrice, productServices[0]);
    };
    const handleChangeZip = ()=>{
        setToggleZipCodeSection(false);
        (0,analytics_analytics/* addAnalyticsForChangeZipCode */.DG)(changeZipCode, productInfo, zipCodeInputVal);
    };
    const handleZipCodeCallBack = (isZipAvaialbe)=>{
        setShowAddanInstallCard(isZipAvaialbe);
        setToggleZipCodeSection(true);
        if (!isInitionalRender.current) {
            (0,analytics_analytics/* addAnalyticsForUpdate */.Xr)(updateZipTitle, productInfo, zipCodeInputVal, isZipAvaialbe);
        }
    };
    const handleCheckAvailability = function(zipcode) {
        let isInitialCall = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const zipToPass = zipCodeInputVal || zipcode;
        getZipCode(zipToPass, handleZipCodeCallBack);
    };
    const handleUpadteClick = ()=>{
        dispatch((0,locationSlice/* setUtilityLocation */.NL)({
            utilityLocation: zipCodeInputVal
        }));
        isInitionalRender.current = false;
        handleCheckAvailability();
    };
    const dispalyData = {
        productOnDisplay,
        colorsData,
        findStores,
        brandName,
        findStoreUtilityDetails,
        shortendPagePath,
        productOnDisplayData
    };
    const isShowProductOnDisplay = !isProductDiscontinued && !isRetailProduct && !isParts;
    const storeNearClick = ()=>{
        setIsSliderOpen(true);
        (0,ProductOnDisplay_analytics/* addAnalyticsClickStoreNear */.xb)({
            productDisplayTitle: productDisplayTitle.toLowerCase(),
            sectionHeadingProductNotAvailable: sectionHeadingProductNotAvailable.toLowerCase()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-product-on-display",
                        children: locationTitles
                    }),
                    zipCodeInputVal && toggleZipCodeSection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "current-location",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "location",
                                children: "".concat(yourZipCode, ": ").concat(zipCodeInputVal)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                tabIndex: "0",
                                role: "button",
                                className: "chnage-location",
                                onClick: handleChangeZip,
                                children: changeZipCode
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "change-zip",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "zip-changes",
                                children: zipCodeToUpdate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "zip-code",
                                type: "text",
                                value: zipCodeInputVal,
                                maxLength: 6,
                                placeholder: zipCodeTitle,
                                label: zipCodeTitle,
                                onKeyDown: (e)=>e.key === "Enter" && handleCheckAvailability(),
                                onChange: (e)=>setZipCodeInputVal(e.target.value)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                tabIndex: "0",
                                role: "button",
                                className: "update",
                                onClick: handleUpadteClick,
                                children: updateZipTitle
                            })
                        ]
                    }),
                    isShowProductOnDisplay ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "productNotOnDisplay",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "left-side",
                                children: productDisplayTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "right-side",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "right-side__title",
                                        role: "link",
                                        onClick: ()=>storeNearClick(),
                                        children: sectionHeadingProductNotAvailable
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "notdisplay-desc",
                                        children: descriptionProductNotAvailable
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    showAddanInstallCard && productServices.length && servicePrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "add-an-install-service",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "add-an-install-service__left-side",
                                children: addInstallServiceTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "add-an-install-service__right-side",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "title",
                                        role: "link",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            (0,ProductOnDisplay_utils/* titleclickhandler */.ZL)(e, productInfo);
                                        },
                                        children: serviceDetails.sectionHeading ? (0,html_react_parser/* default */.ZP)(serviceDetails.sectionHeading) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "install-service",
                                        ref: installSeriveRef,
                                        onClick: (e)=>e.stopPropagation(),
                                        children: (serviceDetails === null || serviceDetails === void 0 ? void 0 : serviceDetails.sectiondescription) ? (0,html_react_parser/* default */.ZP)(serviceDetails.sectiondescription) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tool-tip",
                                        onMouseOver: ()=>{
                                            handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                            (0,analytics_analytics/* addAnalyticsForBuymore */.G5)(buyMoreTitle, "", productInfo);
                                        },
                                        onFocus: ()=>{
                                            handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                        },
                                        onMouseLeave: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                        onBlur: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tool-tip ".concat(tooltip.buyMoreSaveMore ? "--show" : "--hide"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tool-tip-wrapper",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                        message: buyMoreToolTip
                                                    })
                                                })
                                            }),
                                            buyMoreTitle
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "price-button",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "price",
                                                children: "".concat(currencySign, " ").concat(servicePrice)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "primary",
                                                size: "small",
                                                label: addServiceToCart,
                                                onClick: (e)=>{
                                                    handlerForAddServiceClick(e, serviceDetails.sectiondescription);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "add-installation-noservice",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "noservice-title",
                                children: serviceUnavailableTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "noservice__right-side",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header",
                                        role: "link",
                                        onClick: (e)=>{
                                            (0,ProductOnDisplay_utils/* getProsessionalClickHandler */.pi)(e, productInfo);
                                        },
                                        children: (0,html_react_parser/* default */.ZP)(serviceUnavailableSectionHeading)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "desc",
                                        children: (0,html_react_parser/* default */.ZP)(errorMessage)
                                    })
                                ]
                            })
                        ]
                    }),
                    multiDesignServices.map((item, index)=>{
                        const productTypeIndex = item.productType.findIndex((ele)=>ele.includes(productType));
                        if (productTypeIndex > -1) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "purchase-design",
                                ref: learnMoreRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "purchase-design__left-side",
                                        children: item.designPlanTitle ? (0,html_react_parser/* default */.ZP)(item.designPlanTitle) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "purchase-design__right-side",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "design-service",
                                                children: item.multiSectionHeadingDesign ? (0,html_react_parser/* default */.ZP)(item.multiSectionHeadingDesign) : null
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "expert-design",
                                                children: item.multiserviceDescription ? (0,html_react_parser/* default */.ZP)(item.multiserviceDescription) : null
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_SlideDrawer, {
                title: findTitle,
                subTitle: findDesc,
                isOpen: isSliderOpen,
                onClose: ()=>setIsSliderOpen(false),
                children: isSliderOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayItem, {
                    data: dispalyData
                }) : null
            })
        ]
    });
};
/* harmony default export */ var ProductDetailView_ProductOnDisplay = (ProductOnDisplay);

// EXTERNAL MODULE: ./components/Bundles/StaticBundle/index.jsx + 1 modules
var StaticBundle = __webpack_require__(5852);
// EXTERNAL MODULE: ./components/Bundles/localization.js
var Bundles_localization = __webpack_require__(60303);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/Feature/index.module.scss
var Feature_index_module = __webpack_require__(3220);
var Feature_index_module_default = /*#__PURE__*/__webpack_require__.n(Feature_index_module);
// EXTERNAL MODULE: ./components/Bundles/analytics/index.js
var Bundles_analytics = __webpack_require__(34252);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/Feature/index.js







const Feature = (props)=>{
    const { data  } = props;
    const { productFeatures =[] , name ="" , sku , category , slug  } = data;
    const [productUrl, setProductUrl] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (category && slug && sku) {
            (0,helper/* getPDPUrl */.ir5)(category, slug).then((pdpUrl)=>{
                const param = sku ? "skuId=".concat(sku) : "";
                const redirectUrl = (0,utils_0/* getPdpRedirectUrl */.Om)(pdpUrl, param);
                setProductUrl(redirectUrl);
            });
        }
    }, [
        category,
        slug,
        sku
    ]);
    const viewMoreBundleFeatureClick = function() {
        let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        (0,Bundles_analytics/* viewMoreBundleFeature */.V8)(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-12 ".concat((Feature_index_module_default()).Feature),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "title",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "lists",
                children: productFeatures.slice(0, 3).map((fl, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: fl
                    }, i))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: productUrl,
                className: "link",
                onClick: ()=>viewMoreBundleFeatureClick(productUrl),
                children: "View More"
            })
        ]
    }, sku);
};
/* harmony default export */ var BundlesAccordian_Feature = (Feature);

;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader/index.js


const CollapsibleHeader = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "collapsible__header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "heading",
                "aria-level": "2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "plus",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line line-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line line-2"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BundlesAccordian_CollapsibleHeader = (CollapsibleHeader);

;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/SpecsInstallation/index.js










const SpecsInstallation = (props)=>{
    const { title ="" , parentSku ="" , isOpen =false , items =[]  } = props;
    const [specAndInstall, setSpecAndInstall] = (0,react.useState)({});
    const [isDisabledSpec, setIsDisabledSpec] = (0,react.useState)(false);
    const [isDisabledInstall, setIsDisabledInstall] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { specsInstallationLabel ="" , downloadAllSpecSheetsLabel ="" , downloadAllInstallGuidesLabel =""  } = (0,Bundles_localization/* getTranslations */.F)(t);
    const { specFiles =[] , installGuidesFiles =[]  } = specAndInstall;
    const handleDownloadSpecZip = async function() {
        let downloadAllSpecSheetsLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", mainTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setIsDisabledSpec(true);
        try {
            const selectedFileList = [];
            specFiles.forEach((selectedObj)=>{
                const techFileInfo = selectedObj.substring(selectedObj.lastIndexOf("/") + 1);
                selectedFileList.push(techFileInfo);
            });
            (0,Bundles_analytics/* addAnlyticsForSDownloadSpec */.si)(downloadAllSpecSheetsLabel, selectedFileList, specFiles, mainTitle);
            await (0,helper/* handleZipDownload */.G12)(specFiles, parentSku);
            setIsDisabledSpec(false);
        } catch (e) {
            setIsDisabledSpec(false);
        }
    };
    const handleDownloadInstallGuidesZip = async function() {
        let downloadAllSpecSheetsLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", mainTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setIsDisabledInstall(true);
        try {
            const selectedFileList = [];
            installGuidesFiles.forEach((selectedObj)=>{
                const techFileInfo = selectedObj.substring(selectedObj.lastIndexOf("/") + 1);
                selectedFileList.push(techFileInfo);
            });
            (0,Bundles_analytics/* addAnlyticsForSDownloadSpec */.si)(downloadAllSpecSheetsLabel, selectedFileList, installGuidesFiles, mainTitle);
            await (0,helper/* handleZipDownload */.G12)(installGuidesFiles, parentSku);
            setIsDisabledInstall(false);
        } catch (e) {
            setIsDisabledInstall(false);
        }
    };
    const handleOpenAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        (0,Bundles_analytics/* accordianClickBundleFeature */.UQ)(title.toLowerCase(), "expand");
    };
    const handleCloseAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        (0,Bundles_analytics/* accordianClickBundleFeature */.UQ)(title.toLowerCase(), "collapse");
    };
    (0,react.useEffect)(()=>{
        const specFiles = [];
        const installGuidesFiles = [];
        items.forEach((e)=>{
            const { installGuides =[] , specPDFFiles =[]  } = e;
            installGuidesFiles.push(...installGuides);
            specFiles.push(...specPDFFiles);
        });
        setSpecAndInstall({
            installGuidesFiles,
            specFiles
        });
    }, [
        items
    ]);
    return specFiles.length || installGuidesFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "collapsible-accordion bundle-accordian-section",
        "data-testid": "bundle-product-accordion-".concat(title),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesAccordian_CollapsibleHeader, {
                title: specsInstallationLabel
            }),
            onTriggerOpening: ()=>handleOpenAccordian(specsInstallationLabel),
            onTriggerClosing: ()=>handleCloseAccordian(specsInstallationLabel),
            triggerOpenedClassName: "collapsible__trigger--open",
            open: isOpen,
            openedClassName: "collapsible--open",
            transitionTime: 400,
            tabIndex: "0",
            easing: "ease-in-out",
            triggerElementProps: {
                id: (0,utils_0/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
            },
            contentElementId: (0,utils_0/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters px-0",
                "data-testid": "colapse-data-".concat(title),
                "aria-disabled": isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 bundles-accordian-button",
                    children: [
                        specFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "ghost",
                            role: "button",
                            label: downloadAllSpecSheetsLabel,
                            onClick: ()=>handleDownloadSpecZip(downloadAllSpecSheetsLabel.toLowerCase(), specsInstallationLabel.toLowerCase()),
                            disabled: isDisabledSpec,
                            loading: isDisabledSpec
                        }) : null,
                        installGuidesFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "ghost",
                            role: "button",
                            label: downloadAllInstallGuidesLabel,
                            onClick: ()=>handleDownloadInstallGuidesZip(downloadAllInstallGuidesLabel.toLowerCase(), specsInstallationLabel.toLowerCase()),
                            disabled: isDisabledInstall,
                            loading: isDisabledInstall
                        }) : null
                    ]
                })
            })
        })
    }) : null;
};
/* harmony default export */ var BundlesAccordian_SpecsInstallation = (SpecsInstallation);

// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/index.module.scss
var BundlesAccordian_index_module = __webpack_require__(56152);
var BundlesAccordian_index_module_default = /*#__PURE__*/__webpack_require__.n(BundlesAccordian_index_module);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/index.jsx












const BundlesAccordian = (props)=>{
    const { parentSku , title ="" , handleOpen =()=>{} , handleClose =()=>{} , isOpen =false , items =[]  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { featuresLabel =""  } = (0,Bundles_localization/* getTranslations */.F)(t);
    const specsInstallData = {
        title,
        parentSku,
        isOpen,
        items,
        handleOpen,
        handleClose
    };
    const handleOpenAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        (0,Bundles_analytics/* accordianClickBundleFeature */.UQ)(title.toLowerCase(), "expand");
    };
    const handleCloseAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        (0,Bundles_analytics/* accordianClickBundleFeature */.UQ)(title.toLowerCase(), "collapse");
    };
    const features = [];
    items.forEach((e)=>{
        features.push(...e.productFeatures);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Accordion_module_default()).accordionWrapper, " ").concat((BundlesAccordian_index_module_default()).BundlesAccordianWrapper, " container-fluid"),
        children: [
            features.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapsible-accordion bundle-accordian-section",
                "data-testid": "bundle-product-accordion-".concat(title),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesAccordian_CollapsibleHeader, {
                        title: featuresLabel
                    }),
                    onTriggerOpening: ()=>handleOpenAccordian(featuresLabel),
                    onTriggerClosing: ()=>handleCloseAccordian(featuresLabel),
                    triggerOpenedClassName: "collapsible__trigger--open",
                    open: isOpen,
                    openedClassName: "collapsible--open",
                    transitionTime: 400,
                    tabIndex: "0",
                    easing: "ease-in-out",
                    triggerElementProps: {
                        id: (0,utils_0/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                    },
                    contentElementId: (0,utils_0/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row no-gutters px-0",
                        "data-testid": "colapse-data-".concat(title),
                        "aria-disabled": isOpen,
                        children: items.map((item)=>{
                            var ref;
                            return ((ref = item.productFeatures) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesAccordian_Feature, {
                                    data: item
                                })
                            }, item.sku) : null;
                        })
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesAccordian_SpecsInstallation, {
                ...specsInstallData
            })
        ]
    });
};
/* harmony default export */ var StaticBundle_BundlesAccordian = (BundlesAccordian);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesHighlights/index.module.scss
var BundlesHighlights_index_module = __webpack_require__(42083);
var BundlesHighlights_index_module_default = /*#__PURE__*/__webpack_require__.n(BundlesHighlights_index_module);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesHighlights/index.js



const BundleHighlights = (props)=>{
    const { features  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BundlesHighlights_index_module_default()).BundleHighlights,
        dangerouslySetInnerHTML: {
            __html: browser_default().sanitize(features)
        }
    });
};
/* harmony default export */ var BundlesHighlights = (BundleHighlights);

;// CONCATENATED MODULE: ./styles/images/configurator-icon.svg
/* harmony default export */ var configurator_icon = ({"src":"/_next/static/media/configurator-icon.9a489cd9.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./components/ProductDetail/v3/Configurator/index.jsx




const Cofigurator = (props)=>{
    const { title ="" , description ="" , buttonLabel =""  } = props;
    const handleClick = (e)=>{
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "configurator",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "configurator-title",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "configurator-description",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "ghost",
                role: "button",
                label: buttonLabel,
                className: "configurator-btn",
                icon: configurator_icon,
                iconClass: "icon",
                onClick: handleClick,
                flexible: true
            })
        ]
    });
};
/* harmony default export */ var Configurator = (Cofigurator);

;// CONCATENATED MODULE: ./public/icons/tooltip-info.svg
/* harmony default export */ var tooltip_info = ({"src":"/_next/static/media/tooltip-info.9bb375b5.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductDescription/index.jsx
/* eslint-disable camelcase */ 

































const ProductDescription = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { rightSectionRef , addCartContainer  } = ref;
    const { badgeTxt ="" , isDiscontinued =false , discontinuedProduct =false , staticTexts ={} , name ="" , desc ="" , customerFacingSKU ="" , sku ="" , price =0 , isPersonaANY =false , ProductPriceSpiderIncluded_s =false , discountPercent =0 , discountedPrice =0 , isType ="" , persona ="" , productInfo , handleSetPriceTooltip =()=>{} , options =[] , curroptions =[] , facetLabels =[] , variantOptions =[] , selectMoreTooltipData ="" , selectoption =()=>{} , isRegionSoldOnline =true , addToCartProps ={} , addToCartProps: { specialOrder ="" , backOrder =""  } = {} , productOnStock =0 , promoTitle ="" , isProjectPack ="" , disableEcommerce =false , freightPolicyType ="" , excludedState ="" , productAnalyticsData ={} , onQtyChange =()=>{} , comparedProductsCount =0 , isColorDiscontinued =false , handleNavChange =()=>{} , onAddToCompare =()=>{} , onRemoveFromCompare =()=>{} , checkProductCategory =()=>{} , isComboSku =false , productCategory ="" , isParts =false , showToaster =()=>{} , onAvailableColor =()=>{} , findStoreUrl ="" , isFavorite =false , favItem =[] , ctData ={} , ctProductId ="" , customerBrandName ="" , replaceAddToCart =false , disableRatings =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , fusionQueryId ="" , docId ="" , narrativeDescription ="" , partReplacementSuggestions ="" , pdpJson ={} , promoDescription ="" , onAddToCart =()=>{} , mboxes =[] , presetConfigObject ={} , productType ="" , installationDataFromProp =[] , designServiceDataFromProp =[] , installationData =[] , productData ={} , businessUnitName ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , superSku ="" , designServiceData =[] , productServices =[] , getZipCode =()=>{} , brandName ="" , config ={} , colorsData ={} , zipCodeData =[] , isPdpPropsLoaded =false , listPrice =0 , features ="" , imagesData =[] , dimensionData ={} , savedListLineItems ={}  } = props || {};
    const { pdp: { data: { primaryBundleSKU_s: primaryBundleSKUs = ""  } = {} , sku: currentSku = "" , bundleIncludedItems =[] , configuratorEnabled =false  } = {} , productServices: currentProductServices = []  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const { feedbackFormID =""  } = pdpJson;
    const dataSheetUrl = (0,productDetailsHelper/* getDataSheetUrl */.S8)(currentProductServices, currentSku);
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const { apiEndpoints: { productsOnDisplayEndpoint =""  } = {} , general: { shortendPagePath ="" , storeDetailsServletPath ="" , disableCommerce =false , siteName =""  } = {} , internationalization: { locale ="" , currencySign ="" , currencyCode =""  } = {}  } = config;
    const { ingredientsLabel =""  } = staticTexts;
    const isKohler = siteName === "Kohler";
    const { ResourceNvznIdList_ss: nvznList = [] , ResourceVntanaProductIdList_ss: vntanaList = []  } = productData;
    const overSizedType = "4";
    const compare = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_CONFIGURATOR: isConfiguratorEnabled = false  } = featureFlags;
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [showPromo, setShowPromo] = (0,react.useState)(false);
    const [descShowMore, setDescShowMore] = (0,react.useState)(false);
    const [allowedDescCount, setAllowedDescCount] = (0,react.useState)(0);
    const [selectedSkuIsFav, setSelectedSkuIsFav] = (0,react.useState)(false);
    const [optionValue, setOptionValue] = (0,react.useState)("");
    const [optionDropdownName, setOptionDropdownName] = (0,react.useState)("");
    const [configuratorError, setConfiguratorError] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (narrativeDescription) {
            var ref;
            const descCount = (ref = narrativeDescription === null || narrativeDescription === void 0 ? void 0 : narrativeDescription.length) !== null && ref !== void 0 ? ref : 0;
            const allowedCount = width > 1023 && width < 1280 ? 230 : 300;
            setAllowedDescCount(allowedCount);
            setDescShowMore(descCount > allowedCount);
        }
    }, [
        narrativeDescription,
        width
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScrollRight);
        return ()=>{
            window.removeEventListener("scroll", handleScrollRight);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (optionValue && optionDropdownName) {
            (0,analytics/* addDataLayerSuperSkuOptionSelected */.AS)(optionValue, optionDropdownName, productInfo);
            setOptionValue("");
            setOptionDropdownName("");
        }
    }, [
        customerFacingSKU
    ]);
    const handleSelectoption = (value, facet, dropdownName)=>{
        setOptionValue(value);
        setOptionDropdownName(dropdownName);
        selectoption(value, facet);
    };
    const handleScrollRight = ()=>{
        var ref;
        const rightSecHeight = (ref = rightSectionRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (rightSectionRef.current && width >= 1024) {
            rightSectionRef.current.style.top = "-".concat(rightSecHeight - height, "px");
        }
    };
    (0,react.useEffect)(()=>{
        if (ProductPriceSpiderIncluded_s) {
            (0,productDetailsHelper/* initPriceSpider */.i8)(productInfo);
        }
    }, [
        ProductPriceSpiderIncluded_s
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.PriceSpider) === null || ref === void 0 ? void 0 : ref.rebind();
        getSelectedSkuIsFavValue(favItem, sku);
    }, [
        sku,
        ctData === null || ctData === void 0 ? void 0 : ctData.id
    ]);
    const getSelectedSkuIsFavValue = (favList, skuId)=>{
        const isItem = favList.some((fav)=>{
            var ref;
            return (fav === null || fav === void 0 ? void 0 : (ref = fav.variant) === null || ref === void 0 ? void 0 : ref.sku) === skuId;
        });
        setSelectedSkuIsFav(isItem);
    };
    const productPrice = !isBundleProduct && discountedPrice > 0 ? discountedPrice : price;
    const dataAmountAffirm = productPrice * 100;
    const isAffirmLite =  true && productPrice > 150;
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (isAffirmLite && dataAmountAffirm && ((ref = window.affirm) === null || ref === void 0 ? void 0 : (ref1 = ref.ui) === null || ref1 === void 0 ? void 0 : ref1.refresh)) {
            var ref2, ref3;
            (ref2 = window.affirm) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ui) === null || ref3 === void 0 ? void 0 : ref3.refresh();
        }
    }, [
        dataAmountAffirm,
        isAffirmLite
    ]);
    const affirmDetailsClick = ()=>{
        const affirmClickText = document.querySelector(".affirm-modal-trigger").innerText.toLowerCase();
        const affirmTitle = document.querySelector(".affirm-as-low-as").innerText.toLowerCase();
        const pdpAffirmLetter = affirmTitle.split(". ");
        (0,analytics_analytics/* addAnalyticsPdpAffirmText */.jb)(pdpAffirmLetter[0], affirmClickText, productInfo, isBundleProduct);
    };
    const includedItems = getBundleIncludedItems({
        items: bundleIncludedItems,
        ctData,
        projectionData: currentProductServices,
        currencyCode,
        persona
    });
    const staticBundleData = {
        productPrice,
        currencySign,
        listPrice,
        lineItem: includedItems
    };
    const productOnDisplayData = {
        name,
        desc,
        imagesData
    };
    const isProductDiscontinued = isDiscontinued || isColorDiscontinued;
    const getSelectedSkuIsFavValueAddAndRemove = (favItems, variantSkuId)=>{
        var ref;
        const totalVarians = [];
        ctData === null || ctData === void 0 ? void 0 : (ref = ctData.variants) === null || ref === void 0 ? void 0 : ref.forEach((variant)=>{
            totalVarians.push(variant);
        });
        totalVarians.push(ctData === null || ctData === void 0 ? void 0 : ctData.masterVariant);
        const item = favItems.find((vl)=>{
            return vl.productId === (ctData === null || ctData === void 0 ? void 0 : ctData.id) && (totalVarians === null || totalVarians === void 0 ? void 0 : totalVarians.find((vt)=>{
                return vt.sku === variantSkuId && (vt === null || vt === void 0 ? void 0 : vt.id) === (vl === null || vl === void 0 ? void 0 : vl.variantId);
            }));
        });
        if (item) {
            setSelectedSkuIsFav(true);
        } else {
            setSelectedSkuIsFav(false);
        }
    };
    const handleClick = ()=>{
        (0,analytics_analytics/* addAnalyticsForRightToKnowInfoButtonClick */.yQ)(productInfo);
        window.open(dataSheetUrl);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: rightSectionRef,
        className: "product-detail-page__right-sticky",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row product-detail-page__main",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        (badgeTxt && !isDiscontinued || discontinuedProduct) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__badge",
                            children: [
                                !isDiscontinued && badgeTxt !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "product-detail-page__badge-new",
                                    children: badgeTxt
                                }),
                                discontinuedProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "product-detail-page__badge-discontinued",
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.discontinued
                                })
                            ]
                        }),
                        name || desc ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "product-detail-page__title-desc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-detail-page__title",
                                    children: name ? name : desc
                                }),
                                name && desc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "product-detail-page__description",
                                    children: [
                                        " ",
                                        desc
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "product-detail-page__title-desc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-detail-page__title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__para shimmer width-170"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__para shimmer width-170 product-detail-page__description"
                                })
                            ]
                        }),
                        customerFacingSKU || sku ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-detail-page__sku-id",
                            children: customerFacingSKU || sku
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-detail-page__sku-id",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "shimmer-loading__para shimmer width-170"
                            })
                        })
                    ]
                })
            }),
            price > 0 && !isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()({
                    "row no-gutters product-detail-page__price-main": true,
                    "price-retail-exclusive": ProductPriceSpiderIncluded_s
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 product-detail-page__price",
                        children: [
                            !(0,helper/* isCanadaSite */.guj)(brandName) && !isPersonaANY && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-detail-page__price-value",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: productPrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    tabIndex: "0",
                                    "aria-label": "".concat(staticTexts.currentPriceAriaLabel, " ").concat(currencySign).concat(productPrice)
                                })
                            }),
                            price && (persona === "FF" || persona === "KEMP") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-detail-page__customer-group",
                                children: [
                                    persona === "FF" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.friendsFamilyPrice
                                    }),
                                    persona === "KEMP" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.associatePrice
                                    })
                                ]
                            })
                        ]
                    }),
                    !disableCommerce && discountedPrice > 0 && !isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 product-detail-page__discount",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-detail-page__discount-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: price,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            }),
                            discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "product-detail-page__percent-off",
                                children: [
                                    isType === "absolute" ? currencySign + discountPercent : discountPercent + "%",
                                    " ",
                                    staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.percentOff
                                ]
                            })
                        ]
                    }) : null,
                    price && !ProductPriceSpiderIncluded_s && !isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-detail-page__list-price--associate",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListPrice/* default */.Z, {
                            ...props,
                            handleSetPriceTooltip: handleSetPriceTooltip
                        })
                    }),
                    isAffirmLite ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-detail-page__affirm-messaging",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "affirm-as-low-as",
                            "data-page-type": "product",
                            "data-amount": dataAmountAffirm,
                            onClick: affirmDetailsClick
                        })
                    }) : null
                ]
            }) : null,
            isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesHighlights, {
                features: features
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwatchList/* default */.Z, {
                ...props
            }),
            isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticBundle/* default */.Z, {
                pdpView: true,
                data: staticBundleData,
                page: "pdp"
            }) : null,
            !isDiscontinued && Object.keys(options).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_SuperSkuOption, {
                    i18n: staticTexts,
                    options: options,
                    curroptions: curroptions,
                    selectoption: handleSelectoption,
                    facetLabels: facetLabels,
                    tooltipdata: selectMoreTooltipData,
                    selectMoreTooltipHandler: handleSetPriceTooltip,
                    variantOptions: variantOptions
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_InstallReqItems, {
                currencyCode: currencyCode,
                ...props
            }),
            isRegionSoldOnline && specialOrder === "Yes" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__discontinued-txt product-detail-page__order-messaging",
                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.specialOrder
            }),
            ProductPriceSpiderIncluded_s && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-detail-page__price-spider-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-detail-page__price_spider_title",
                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.priceSpiderTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ps-widget",
                        "ps-sku": sku
                    })
                ]
            }),
            promoTitle && !ProductPriceSpiderIncluded_s && isRegionSoldOnline && !isDiscontinued && !isProjectPack && (backOrder === "Yes" || productOnStock > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__promo-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    isOpen: false,
                    title: promoTitle,
                    handleOpen: ()=>setShowPromo(true),
                    handleClose: ()=>setShowPromo(false),
                    isArrow: true,
                    children: showPromo && promoDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-detail-page__promo-desc",
                        children: (0,helper/* sanitizeInnerHtml */.KD0)(promoDescription)
                    })
                })
            }),
            !disableEcommerce && !ProductPriceSpiderIncluded_s && isRegionSoldOnline && !isDiscontinued && !isProjectPack && productOnStock > 0 && (isEqual_default()(freightPolicyType, overSizedType) || !isEmpty_default()(excludedState)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters product-detail-page__oversized-msg-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 oversized-msg-tooltip",
                    children: [
                        isEqual_default()(freightPolicyType, overSizedType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "oversized-msg-primary-txt",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "oversized-msg-info-icon",
                                    src: tooltip_info.src,
                                    alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.primaryTxt),
                                        " ",
                                        (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.secondaryTxt)
                                    ]
                                })
                            ]
                        }),
                        !isEmpty_default()(excludedState) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "oversized-msg-primary-txt",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "oversized-msg-info-icon",
                                    src: tooltip_info.src,
                                    alt: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.toolTip
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)("".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.shippingTitle, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.shippingDescription, " ").concat(excludedState, "."))
                                })
                            ]
                        })
                    ]
                })
            }),
            !ProductPriceSpiderIncluded_s && !isDiscontinued && !price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 product-detail-page__info-mssg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (0,helper/* sanitizeAndDecodeHtml */.EzU)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.withoutPriceTxt)
                    })
                })
            }),
            isConfiguratorEnabled && configuratorEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Configurator, {
                title: staticTexts.configuratorTitle,
                description: staticTexts.configuratorDesc,
                buttonLabel: staticTexts.configuratorButtonLabel,
                setError: setConfiguratorError
            }) : null,
            configuratorEnabled && configuratorError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "configurator-error-modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
                    showModal: configuratorError,
                    onModalClose: ()=>setConfiguratorError(false),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "error-title",
                            children: staticTexts.configuratorErrorTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "error-message",
                            children: staticTexts.configuratorErrorDesc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            type: "black",
                            label: staticTexts.configuratorErrorButtonLabel,
                            onClick: ()=>setConfiguratorError(false),
                            flexible: true
                        })
                    ]
                })
            }) : null,
            isProjectPack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 product-detail-page__info-mssg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (0,helper/* sanitizeAndDecodeHtml */.EzU)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.projectPackMssg)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_AddToCart, {
                ref: addCartContainer,
                ...addToCartProps,
                staticTexts: staticTexts,
                onQtyChange: (qty)=>onQtyChange(qty),
                onAddToCart: onAddToCart,
                onAdd: onAddToCompare,
                onRemove: onRemoveFromCompare,
                onAvailableColor: onAvailableColor,
                checkCategory: checkProductCategory,
                comparedProductsCount: comparedProductsCount,
                compareData: compare,
                sku: sku,
                isComboSku: isComboSku,
                productCategory: productCategory,
                isParts: isParts,
                productOnStock: productOnStock,
                isColorDiscontinued: isColorDiscontinued,
                isDiscontinued: isDiscontinued,
                specialOrder: specialOrder,
                backOrder: backOrder,
                ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                showToaster: showToaster,
                productData: productAnalyticsData,
                findStoreUrl: findStoreUrl,
                isFavorite: isFavorite,
                favItem: favItem,
                price: price,
                ctData: ctData,
                isRegionSoldOnline: isRegionSoldOnline,
                customerBrandName: customerBrandName,
                handleNavChange: handleNavChange,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce,
                fusionQueryId: fusionQueryId,
                docId: docId,
                analyticData: productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo,
                isPdpPropsLoaded: isPdpPropsLoaded,
                isBundleProduct: isBundleProduct,
                ctProductId: ctProductId,
                showFavirote: selectedSkuIsFav,
                resetSelectedFav: getSelectedSkuIsFavValueAddAndRemove,
                savedListLineItems: savedListLineItems
            }),
            nvznList.length || vntanaList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_Product3Dmodel, {
                pdpJson: pdpJson,
                nvznList: nvznList,
                vntanaList: vntanaList,
                sku: sku,
                productInfo: productInfo
            }) : null,
            narrativeDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-detail-page__narrative-description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "product-detail-page__narrative-description".concat(descShowMore ? "--show-more" : "--none"),
                    children: [
                        descShowMore ? narrativeDescription.slice(0, allowedDescCount) : narrativeDescription,
                        descShowMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "...",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "product-detail-page__narrative-description--show-more-button gbh-data-layer",
                                    tabIndex: 0,
                                    onClick: ()=>setDescShowMore(false),
                                    "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)(staticTexts.descReadMore.toLowerCase()),
                                    "data-gbh-data-layer-custom": productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo,
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.descReadMore
                                })
                            ]
                        })
                    ]
                })
            }),
            isKohler && dataSheetUrl && ingredientsLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ingredients-link",
                onClick: handleClick,
                children: ingredientsLabel
            }) : null,
            discontinuedProduct && isParts && partReplacementSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_MoreFromCollection, {
                pdpJson: pdpJson,
                sku: sku,
                i18n: {
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.moreCollection,
                    discontinuedTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.moreCollectionDiscontinued,
                    partNumber: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.partNumber,
                    partName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.partName
                },
                isColorDiscontinued: isColorDiscontinued,
                mboxes: mboxes,
                presetConfigObject: presetConfigObject,
                productType: productType,
                partReplacementSuggestions: partReplacementSuggestions
            }),
            isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticBundle_BundlesAccordian, {
                items: includedItems,
                parentSku: currentSku
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductAccordionList, {
                productData: productData,
                productInfo: productAnalyticsData.stringProductInfo,
                productSku: sku,
                isDiscontinued: isDiscontinued,
                staticTexts: staticTexts,
                accordionList: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.accordianLabels,
                installationSupportLinks: pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.installationSupportLinks,
                installationDataFromProp: installationDataFromProp,
                designServiceDataFromProp: designServiceDataFromProp,
                businessUnitName: businessUnitName,
                ProductPriceSpiderIncluded_s: ProductPriceSpiderIncluded_s,
                discontinuedProductb: discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
                superSku: superSku,
                currencySign: currencySign,
                productCategory: productCategory,
                designServiceData: designServiceData,
                productServices: productServices,
                productType: productType,
                getZipCode: getZipCode,
                installationData: installationData,
                persona: persona,
                currencyCode: currencyCode,
                locale: locale,
                width: width,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce,
                isProjectPack: isProjectPack,
                dimensionData: dimensionData,
                config: config
            }),
            zipCodeData.length && !isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_ProductOnDisplay, {
                pdpJson: pdpJson,
                productServices: productServices,
                installationData: installationData,
                staticTexts: staticTexts,
                currencyCode: currencyCode,
                currencySign: currencySign,
                brandName: brandName,
                getZipCode: getZipCode,
                findStores: productsOnDisplayEndpoint,
                colorsData: colorsData,
                shortendPagePath: shortendPagePath,
                findStoreDetailsUrl: storeDetailsServletPath,
                productType: productType,
                productInfo: productInfo,
                productOnDisplayData: productOnDisplayData,
                isRetailProduct: ProductPriceSpiderIncluded_s,
                isParts: isParts,
                isProductDiscontinued: isProductDiscontinued
            }) : null,
            feedbackFormID ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_Feedback, {
                pdpJson: pdpJson
            }) : null
        ]
    });
});
ProductDescription.displayName = "ProductDescription";
/* harmony default export */ var ProductDetailView_ProductDescription = (ProductDescription);

// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(13678);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/ProductBreadcrumb.jsx







const ProductBreadcrumb = (param)=>{
    let { staticTexts: { ariaLabel: { breadcrumb ="" , page ="" , print ="" , share =""  } = {} , home ="" , serviceParts ="" , priceFootnoteTitle ="" , priceFootnote ="" , colorFootnoteTitle ="" , colorFootnote =""  } , productCategory ="" , name ="" , homePagePath ="" , plpServletPath =[] , config ={} , productAnalyticsData ="" , productData ={} , swatchUrl ="" , imagesData =[] , width =0 , presetConfigObject ={} , isBundleProduct =""  } = param;
    const [url, setUrl] = (0,react.useState)("");
    const [plpPagePath, setPlpPagePath] = (0,react.useState)("");
    const [serviceLandingPath, setServiceLandingPath] = (0,react.useState)("");
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const shareBtn = (0,react.useRef)(null);
    const [localCategory, setLocalCategory] = (0,react.useState)(productCategory || (productData === null || productData === void 0 ? void 0 : productData.ProductLocalCategory_s));
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const { general ={}  } = config;
            var _plpPagePath;
            (0,helper/* getShortenedUrl */.Ppy)((_plpPagePath = general.plpPagePath) !== null && _plpPagePath !== void 0 ? _plpPagePath : "/").then((res)=>setPlpPagePath(res));
            var _servicePartsLandingPath;
            (0,helper/* getShortenedUrl */.Ppy)((_servicePartsLandingPath = general.servicePartsLandingPath) !== null && _servicePartsLandingPath !== void 0 ? _servicePartsLandingPath : "/").then((res)=>setServiceLandingPath(res));
        }
    }, [
        config,
        plpServletPath
    ]);
    (0,react.useEffect)(()=>{
        setLocalCategory(productCategory || (productData === null || productData === void 0 ? void 0 : productData.ProductLocalCategory_s));
    }, [
        productData,
        productCategory
    ]);
    (0,react.useEffect)(()=>{
        if (plpServletPath && productCategory && (plpPagePath || serviceLandingPath)) {
            const path = plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.find((i)=>i.categories.includes(productCategory));
            let plpUrl;
            if (productCategory) {
                if (path) {
                    plpUrl = "".concat(path.url, ".html");
                } else if (productCategory === "Service Parts") {
                    plpUrl = "".concat(serviceLandingPath, ".html");
                } else {
                    plpUrl = "".concat(plpPagePath, "/").concat(productCategory.replace(/ +/g, "-").toLowerCase(), ".html");
                }
            } else {
                plpUrl = "".concat(serviceLandingPath, ".html");
            }
            (0,helper/* getShortenedUrl */.Ppy)(plpUrl).then((url)=>setUrl(url));
        }
    }, [
        plpPagePath,
        serviceLandingPath,
        productCategory
    ]);
    // Hide social share options when user clicks outide the options
    (0,react.useEffect)(()=>{
        window.addEventListener("click", handleClickOutside);
        return ()=>window.removeEventListener("click", handleClickOutside);
    }, []);
    const handleClickOutside = (e)=>{
        const { target  } = e;
        if (!shareBtn.current.contains(target)) {
            setShowSocialLink(false);
        }
    };
    const handleShareClick = ()=>{
        setShowSocialLink((prevProp)=>!prevProp);
        (0,analytics/* addShareBtnAnalytics */.zE)(productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo);
    };
    const addAnalytics = function() {
        let internalLinkName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const page = window.pageObj || {};
        const eventInfo = (0,analytics/* getBreadcrumbEventInfo */.Sg)(internalLinkName, link);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const printPDP = ()=>{
        const printNoteLen = document.getElementsByClassName("product-detail-page__print-note").length;
        if (printNoteLen === 0) {
            const printNote = "<div class='product-detail-page__print-note'><div class='container'><div class='row'><div class='col-12'><h6>".concat(priceFootnoteTitle, "</h6><p>").concat(priceFootnote, "</p><h6>").concat(colorFootnoteTitle, "</h6> <p>").concat(colorFootnote, "</p></div></div></div></div>");
            const printNoteDiv = document.createElement("div");
            printNoteDiv.innerHTML = printNote;
            document.body.appendChild(printNoteDiv);
        }
        setTimeout(()=>{
            window.print();
        }, 900);
    };
    if (productData) {
        var ref;
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-section kf-react-plp-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-detail-page__breadcrumb",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": breadcrumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                            role: "list",
                            "data-testid": "bcm-list",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    role: "listitem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": "".concat(home, " ").concat(page),
                                            className: "product-detail-page__breadcrumb-link",
                                            onClick: ()=>addAnalytics(home, homePagePath),
                                            href: homePagePath,
                                            children: " ".concat(home)
                                        }),
                                        " / "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "aria-label": productCategory ? "".concat(productCategory, " ").concat(page) : "".concat(serviceParts, " ").concat(page),
                                        className: "product-detail-page__breadcrumb-link",
                                        onClick: ()=>addAnalytics("".concat(home, " > ").concat(productCategory), url),
                                        href: url,
                                        children: localCategory ? localCategory : serviceParts
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    role: "listitem",
                                    className: "adaopacity",
                                    children: [
                                        " / ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": productCategory ? "".concat(name, " ").concat(page) : "".concat(serviceParts, " ").concat(page),
                                            "aria-current": page,
                                            className: "product-detail-page__breadcrumb-link",
                                            onClick: ()=>addAnalytics("".concat(home, " > ").concat(productCategory, " > ").concat(name), "#"),
                                            href: "#",
                                            children: productCategory ? name : serviceParts
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-detail-page__print-share-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "list",
                            className: "print-and-share",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        tabIndex: "0",
                                        className: "gbh-data-layer",
                                        "data-gbh-data-layer": (0,analytics/* getEventInfo */.wQ)("print"),
                                        "data-gbh-data-layer-custom": productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.stringProductInfo,
                                        "aria-label": print,
                                        onClick: ()=>printPDP(),
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/icons/print.svg",
                                                alt: "",
                                                role: "presentation",
                                                width: "17",
                                                height: "17"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        tabIndex: "0",
                                        "aria-label": share,
                                        className: "share-button",
                                        ref: shareBtn,
                                        onClick: handleShareClick,
                                        role: "button",
                                        "aria-haspopup": true,
                                        "aria-expanded": showSocialLink,
                                        "aria-controls": "print-and-share",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/icons/share.svg",
                                            alt: "",
                                            role: "presentation",
                                            width: "17",
                                            height: "17"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                            disableInstagram: true,
                            showModal: showSocialLink,
                            shareBtn: shareBtn,
                            id: "print-and-share",
                            onClose: ()=>{
                                return shareBtn === null || shareBtn === void 0 ? void 0 : shareBtn.current.focus();
                            },
                            asset: {
                                description: (ref1 = productData === null || productData === void 0 ? void 0 : productData.ProductDescriptionProductShort_s) !== null && ref1 !== void 0 ? ref1 : "",
                                url: (0,helper/* appendPresetToUrl */.QCk)(swatchUrl, (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId, width, presetConfigObject, true)
                            },
                            analyticData: {
                                eventAction: "pdp:product details:share",
                                eventName: "pdp:product details:share",
                                internalLinkPosition: "pdp".concat(isBundleProduct ? ":bundle" : ""),
                                internalLinkType: "pdp:share",
                                internalLinkZoneName: "pdp:product details",
                                custom: productAnalyticsData.stringProductInfo
                            },
                            isBundleProduct: isBundleProduct
                        })
                    ]
                })
            ]
        });
    }
};
/* harmony default export */ var ProductDetailView_ProductBreadcrumb = (ProductBreadcrumb);

// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var react_sticky_el_lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/StickyHeader/analytics/index.js
const getAnalyticsData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { itemStatus , productStock =0 , backOrder , specialOrder  } = data;
    let analyticsAddToCart = '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    if (itemStatus === "outOfStock" || !(productStock > 0)) {
        analyticsAddToCart = JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "pdp:sticky nav:notify me",
            eventMsg: "n/a",
            eventName: "pdp:sticky nav:notify me",
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "notify me",
            internalLinkPosition: "header",
            internalLinkType: "pdp:notify me",
            internalLinkURL: "n/a",
            internalLinkZoneName: "pdp:sticky nav"
        });
        if (specialOrder === "Yes" || backOrder === "Yes") {
            analyticsAddToCart = '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    } else if (itemStatus === "discontinued") {
        analyticsAddToCart = '{"eventAction":"pdp:find similar items","eventName":"pdp:find similar items","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"find similar items","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else if (itemStatus === "preOrder") {
        analyticsAddToCart = '{"eventAction":"pdp:pre order","eventName":"pdp:pre order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"pre order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else if (itemStatus === "specialOrder") {
        analyticsAddToCart = '{"eventAction":"pdp:special order","eventName":"pdp:special order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"special order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    }
    return analyticsAddToCart;
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/StickyHeader/index.module.scss
var StickyHeader_index_module = __webpack_require__(2819);
var StickyHeader_index_module_default = /*#__PURE__*/__webpack_require__.n(StickyHeader_index_module);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/StickyHeader/index.jsx















const StickyHeader = (props)=>{
    const { staticTexts: { addToCart ="" , notifyMailCTA ="" , findSimilar ="" , preOrder ="" , specialOrder ="" , availColorCTA =""  } , productStock ="" , backOrder ="" , disableEcommerce ="" , replaceAddToCart =()=>{} , replaceAddToCartCtaLabel ="" , price =0 , onAddToCart =()=>{} , sku ="" , isComboSku ="" , customerBrandName ="" , imgUrl ="" , title ="" , color ="" , currencySign ="" , isDiscontinued ="" , isColorDiscontinued ="" , isRegionSoldOnline ="" , onAvailableColor =()=>{} , handleScroll =()=>{} , replaceAddToCartCtaLink ="" , linkNewTab ="" , description ="" , analyticData ={} , productPriceSpiderIncluded =""  } = props;
    const router = (0,next_router.useRouter)();
    const { label , url  } = color;
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const itemStatus = get_default()(props, "itemStatus", "available");
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [loading, setLoading] = (0,react.useState)(false);
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { pdp: { data: { primaryBundleSKU_s: primaryBundleSKUs = ""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const { MYSQLCONNSTR_DISABLE_ADD_CART: disableAddcart  } = featureFlags;
    let buttonText = addToCart;
    const analyticsAddToCart = getAnalyticsData({
        itemStatus,
        productStock,
        backOrder,
        specialOrder: props.specialOrder
    });
    if (itemStatus === "outOfStock" || !(productStock > 0)) {
        buttonText = notifyMailCTA;
        if (!isBundleProduct && (specialOrder === "Yes" || backOrder === "Yes")) {
            buttonText = addToCart;
        }
    } else if (itemStatus === "discontinued") {
        buttonText = findSimilar;
    } else if (itemStatus === "preOrder") {
        buttonText = preOrder;
    } else if (itemStatus === "specialOrder") {
        buttonText = specialOrder;
    }
    const analyticsWhereToBuy = disableEcommerce && replaceAddToCart && replaceAddToCartCtaLabel && JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "pdp:sticky nav:".concat(replaceAddToCartCtaLabel),
        eventMsg: "n/a",
        eventName: "pdp:sticky nav:".concat(replaceAddToCartCtaLabel),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(replaceAddToCartCtaLabel),
        internalLinkPosition: "header",
        internalLinkType: "pdp:".concat(replaceAddToCartCtaLabel),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(replaceAddToCartCtaLabel)
    });
    (0,react.useEffect)(()=>{
        if (productPriceSpiderIncluded) {
            setShowBuyBoxArea(false);
        } else if (!price) {
            setShowBuyBoxArea(false);
        } else {
            setShowBuyBoxArea(true);
        }
    }, [
        productPriceSpiderIncluded,
        price
    ]);
    const onAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleClick = ()=>{
        setLoading(true);
        if (buttonText === notifyMailCTA) {
            window.scroll({
                top: 800,
                left: 0,
                behavior: "smooth"
            });
        } else {
            if (analyticsAddToCart && window.adobeDataLayer) {
                // handle Requirement#19 Sticky Nav Add To Cart
                const eventInfo = JSON.parse(analyticsAddToCart);
                const { adobeDataLayer: { getState  } = {}  } = window;
                const page = getState && getState("page") || {};
                if (!page.cart) {
                    page.cart = {
                        cartID: cart.id
                    };
                } else {
                    page.cart.cartID = cart.id;
                }
                const otherInfo = {};
                if (page === null || page === void 0 ? void 0 : page.productInfo) {
                    otherInfo.productInfo = page.productInfo;
                    delete page.productInfo;
                }
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    ...otherInfo
                });
            }
            onAddToCart([
                {
                    sku: sku,
                    quantity: 1,
                    isBundle: isComboSku,
                    backorder: backOrder === "Yes" ? true : false,
                    brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase()
                }
            ], onAddToCartCb);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StickyHeader_index_module_default()).pdpStickyHeadWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-sticky-header container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-sticky-header__details-wrap container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pdp-sticky-header__container kf-react-plp-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: imgUrl,
                            alt: title,
                            width: 80,
                            height: 80
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-sticky-header__details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pdp-sticky-header__brand-name",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pdp-sticky-header__description",
                                    children: description
                                })
                            ]
                        }),
                        itemStatus === "available" && color && label !== "Not Applicable" && url && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-sticky-header__color-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-sticky-header__color",
                                    style: {
                                        backgroundImage: "url('".concat(url, "')")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pdp-sticky-header__color-label",
                                    children: label
                                })
                            ]
                        }),
                        showBuyBoxArea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()({
                                "pdp-sticky-header__right": true,
                                "pdp-sticky-header__right--retailers": productPriceSpiderIncluded
                            }),
                            children: [
                                itemStatus !== "discontinued" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-sticky-header__price-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-sticky-header__price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: price,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    })
                                }),
                                isDiscontinued ? isColorDiscontinued && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    useDefaultClass: true,
                                    label: availColorCTA,
                                    size: "small",
                                    type: "primary",
                                    onClick: onAvailableColor
                                }) : null : isRegionSoldOnline && (productStock > 0 || specialOrder === "Yes" || backOrder === "Yes") && !disableEcommerce || isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    useDefaultClass: true,
                                    label: buttonText,
                                    size: "small",
                                    type: "primary",
                                    role: "button",
                                    onClick: handleClick,
                                    disabled: disableAddcart,
                                    loading: loading
                                }) : isRegionSoldOnline && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    useDefaultClass: true,
                                    className: "".concat(analyticsAddToCart ? "gbh-data-layer" : ""),
                                    "data-gbh-data-layer": "".concat(analyticsAddToCart || null),
                                    "data-gbh-data-layer-custom": analyticData,
                                    label: buttonText,
                                    size: "small",
                                    type: "primary",
                                    onClick: handleScroll
                                }) : null,
                                replaceAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: ()=>{
                                        (0,AddToCart_analytics/* replaceAddToCartDatalayerPush */.ME)(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData);
                                        router.push(replaceAddToCartCtaLink);
                                    },
                                    useDefaultClass: true,
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": analyticsWhereToBuy,
                                    "data-gbh-data-layer-custom": analyticData,
                                    role: "button",
                                    ariaLabel: replaceAddToCartCtaLabel,
                                    label: replaceAddToCartCtaLabel,
                                    size: "small",
                                    type: "primary",
                                    to: replaceAddToCartCtaLink,
                                    target: linkNewTab ? "_blank" : "_self"
                                }) : ""
                            ]
                        })
                    ]
                })
            })
        })
    });
};
StickyHeader.defaultProps = {
    productStock: "",
    backOrder: "",
    disableEcommerce: "",
    replaceAddToCart: "",
    replaceAddToCartCtaLabel: "",
    onAddToCart: "",
    sku: "",
    isComboSku: "",
    customerBrandName: "",
    title: "",
    isDiscontinued: "",
    isColorDiscontinued: "",
    isRegionSoldOnline: "",
    onAvailableColor: "",
    handleScroll: "",
    replaceAddToCartCtaLink: "",
    linkNewTab: "",
    imgUrl: "",
    productSku: "",
    brandName: "",
    description: "",
    currencySign: "",
    price: 0,
    itemStatus: "available",
    color: {
        label: "",
        url: ""
    },
    staticTexts: {
        addToCart: "",
        notifyMailCTA: "",
        findSimilar: "",
        preOrder: "",
        specialOrder: "",
        availColorCTA: ""
    }
};
/* harmony default export */ var v3_StickyHeader = (StickyHeader);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/StickyHead.jsx




const StickyHead = (props)=>{
    var ref;
    const { setSticky , sticky =false , isDiscontinued ="" , showStickyHeader ="" , stickyHeaderProps ={} , discountedPrice =0 , price =0 , staticTexts ={} , onAddToCart , isColorDiscontinued ="" , addToCartProps ={} , productOnStock ="" , sku ="" , customerFacingSKU ="" , isComboSku ="" , handleScroll , onAvailableColor ="" , isRegionSoldOnline ="" , productAnalyticsData ={} , customerBrandName ="" , replaceAddToCart ="" , disableRatings ="" , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab ="" , disableEcommerce ="" , currencySign ="" , swatchUrl ="" , imagesData ={} , presetConfigObject ={} , assetAccountName ="" , productPriceSpiderIncluded =""  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_sticky_el_lib_default()), {
        onFixedToggle: ()=>setSticky(!sticky),
        className: "product-detail-page__sticky-wrapper",
        stickyClassName: "sticky sticky-pdp-page",
        children: !isDiscontinued && sticky && showStickyHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_StickyHeader, {
            ...stickyHeaderProps,
            currencySign: currencySign,
            price: discountedPrice > 0 ? discountedPrice : price,
            staticTexts: staticTexts,
            imgUrl: (0,utils_0/* getPresetThumbnailUrl */.BB)(swatchUrl, (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId, presetConfigObject, assetAccountName),
            onAddToCart: (cartItemProduct, cb)=>onAddToCart(cartItemProduct, cb),
            isDiscontinued: isDiscontinued,
            isColorDiscontinued: isColorDiscontinued,
            specialOrder: addToCartProps.specialOrder,
            backOrder: addToCartProps.backOrder,
            productStock: productOnStock,
            sku: sku,
            customerFacingSKU: customerFacingSKU,
            isComboSku: isComboSku,
            handleScroll: handleScroll,
            onAvailableColor: ()=>onAvailableColor(),
            productPriceSpiderIncluded: productPriceSpiderIncluded,
            isRegionSoldOnline: isRegionSoldOnline,
            analyticData: productAnalyticsData.stringProductInfo,
            customerBrandName: customerBrandName,
            replaceAddToCart: replaceAddToCart,
            disableRatings: disableRatings,
            replaceAddToCartCtaLink: replaceAddToCartCtaLink,
            replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
            linkNewTab: linkNewTab,
            disableEcommerce: disableEcommerce
        })
    });
};
/* harmony default export */ var ProductDetailView_StickyHead = (StickyHead);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/index.jsx
/* eslint-disable camelcase */ 





















const ProductDetailView = (props)=>{
    const { viewLoader =true , config ={} , colorsData =[] , staticTexts ={} , badgesProps ={} , presetConfigObject ={} , discountedPrice ="" , price ="" , productOnStock ="" , sku ="" , customerFacingSKU ="" , isComboSku =false , customerBrandName ="" , disableRatings =false , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab =false , currencySign ="" , imagesData =[] , onAddToCart =()=>{} , stickyHeaderProps ={} , addToCartProps ={} , onAvailableColor =()=>{} , isRegionSoldOnline =true , replaceAddToCart ="" , productCategory ="" , productLCategory ="" , name ="" , desc ="" , discountPercent =0 , superSku ="" , selectedColor ="" , businessUnitName ="" , productSaleable ="" , productPartnerBuyNow ="" , productCollectionsName ="" , globalDiscount =0 , cart ={} , ProductPriceSpiderIncluded_s: ProductIsRetail = "" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , loadShowEvent ="" , setProductInfo =()=>{} , clickedProductVariant ="" , removeVariantSelection =()=>{} , requiredItems =[] , addItemsToCart =()=>{} , discontinuedProduct =false , imageClickCounter =0 , updateImageClickCounter =()=>{} , productData ={} , initialImgAlt ="" , initialImgUrl ="" , pdpJson ={} , waterSenseProduct =[] , setIsLoadTargetRequired , isLoadTargetRequired , isPriceChecked =false , ctData ={} , persona ="" , productDetailData ={} , threeSixtyResourceData ={} , savedListLineItems ={}  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [sticky, setSticky] = (0,react.useState)(false);
    const [priceTooltip, setPriceTooltip] = (0,react.useState)(false);
    const [showPDPInstallModal, setShowPDPInstallModal] = (0,react.useState)(false);
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const [installReq, setInstallReq] = (0,react.useState)([]);
    const [installReqData, setInstallReqData] = (0,react.useState)([]);
    const [reqItemLwData, setReqItemLwData] = (0,react.useState)([]);
    const [currentQuantity, setCurrentQuantity] = (0,react.useState)(1);
    const [priceList, setPriceList] = (0,react.useState)();
    const [subTotal, setSubTotal] = (0,react.useState)();
    const [showStickyHeader, setShowStickyHeader] = (0,react.useState)(false);
    const [isMobileOnly, setIsMobileOnly] = (0,react.useState)(false);
    const addCartContainer = (0,react.useRef)(null);
    const rightSectionRef = (0,react.useRef)(null);
    const previousSticky = (0,react.useRef)(false);
    const { pdp: { data: { primaryBundleSKU_s: primaryBundleSKUs = ""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const { general ={} , general: { swatchUrl ="" , scene7AccountName =""  } = {} , plpServletPath , internationalization: { currencyCode =""  } = {}  } = config || {};
    const { disableCommerce =false , siteName: brandName = "" , homepageUrl ="" , scene7AccountName: assetAccountName = "PAWEB" , lwAppName =""  } = general;
    const { ProductLocalCategory_s: productLocalCategory = "" , isCollapsedPDP_b: isCollapsedPDP = false  } = productData;
    const homePagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)(homepageUrl, general);
    const disableEcommerce = Boolean(disableCommerce);
    const isPersonaANY = constants.isANYPersona;
    const badgeTxt = badgesProps.isNewProduct ? badgesProps.exclusiveBadge ? staticTexts.newExclusive : staticTexts.new : badgesProps.exclusiveBadge ? staticTexts.exclusive : badgesProps.badgeVal ? staticTexts.sale : "";
    const [width] = (0,useWindowResize/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (width > 0) {
            setIsMobileOnly(width <= 480);
        }
    }, [
        width
    ]);
    // To get the bundle's items
    const { pdp: { bundleIncludedItems =[]  } = {} , productServices: currentProductServices = []  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const includedItems = getBundleIncludedItems({
        items: bundleIncludedItems,
        ctData,
        projectionData: currentProductServices,
        currencyCode,
        persona
    });
    const getProductAnalyticsData = ()=>{
        var ref, ref1, ref2;
        var ref3;
        return {
            desc: (0,helper/* sanitizeTextForAnalytics */.T68)(desc),
            discountPrice: discountedPrice,
            discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
            unitPrice: price,
            category: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
            lcategory: (0,helper/* sanitizeTextForAnalytics */.T68)(productLCategory),
            color: (0,helper/* sanitizeTextForAnalytics */.T68)(get_default()(colorsData.find((item)=>item.id === sku), "label", "")),
            sku,
            name: (0,helper/* sanitizeTextForAnalytics */.T68)(name),
            quantity: currentQuantity,
            image: (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.url,
            stock: productOnStock,
            availability: discontinuedProduct || discontinuedColor ? "discontinued" : (addToCartProps === null || addToCartProps === void 0 ? void 0 : addToCartProps.backOrder) === "Yes" && !productOnStock ? "back order" : productOnStock ? "in stock" : "out of stock",
            customerFacingSKU: customerFacingSKU || (brandName ? brandName[0] + "-" + sku : ""),
            skuInitials: customerFacingSKU ? customerFacingSKU.split("-")[0] + "-" : brandName ? brandName[0] + "-" : "",
            discountName: badgesProps === null || badgesProps === void 0 ? void 0 : badgesProps.badgeVal,
            superSku,
            selectedColor: (0,helper/* sanitizeTextForAnalytics */.T68)(selectedColor),
            businessUnitName: (0,helper/* sanitizeTextForAnalytics */.T68)(businessUnitName),
            productSaleable,
            brandName: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
            productPartnerBuyNow,
            productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(productCollectionsName),
            globalDiscount,
            pdpType: isBundleProduct ? "bundle" : "",
            bundleIds: isBundleProduct ? includedItems === null || includedItems === void 0 ? void 0 : includedItems.map((item)=>"K-" + item.sku).toString() : "",
            bundleItemsCategories: isBundleProduct ? includedItems === null || includedItems === void 0 ? void 0 : includedItems.map((item)=>(0,helper/* sanitizeTextForAnalytics */.T68)(item.category)).toString() : "",
            bundleItemsCollections: isBundleProduct ? includedItems === null || includedItems === void 0 ? void 0 : includedItems.map((item)=>(0,helper/* sanitizeTextForAnalytics */.T68)(item.collection)).toString() : "",
            bundleProductRoom: isBundleProduct ? (0,helper/* sanitizeTextForAnalytics */.T68)((ref3 = (ref1 = includedItems.filter((item)=>item.sku === primaryBundleSKUs)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.productRoom) !== null && ref3 !== void 0 ? ref3 : "") : "",
            bundleProductColors: isBundleProduct ? includedItems === null || includedItems === void 0 ? void 0 : includedItems.map((item)=>(0,helper/* sanitizeTextForAnalytics */.T68)(item.color)).toString() : ""
        };
    };
    const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart,
        sku
    });
    const { pdpDesktopImage  } = pdpJson;
    let waterSenseProductVal = false;
    if (waterSenseProduct && waterSenseProduct.length) {
        waterSenseProductVal = waterSenseProduct[0] === "Yes" ? true : false;
    }
    const getProcessedProductInfo = function() {
        let updatedPageInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        const productAnalyticsData = getProductAnalyticsData();
        const productInfo = {
            description: productAnalyticsData.desc || "n/a",
            frequency: "n/a",
            globalPromotionPrice: Number((productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.discountPrice) || (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.unitPrice)),
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: productAnalyticsData.discountPriceState,
            productBasePrice: productAnalyticsData.unitPrice || "n/a",
            productCategory: productAnalyticsData.category || productAnalyticsData.businessUnitName || "n/a",
            productColor: productAnalyticsData.color || "n/a",
            productCoupondiscount: productCoupondiscount,
            productCouponCode: productCouponCode.join("|") || "n/a",
            productID: productAnalyticsData.customerFacingSKU || "n/a",
            productName: productAnalyticsData.name || "n/a",
            productPartnerBuyNow: productAnalyticsData.productPartnerBuyNow,
            productRoom: isBundleProduct ? productAnalyticsData.bundleProductRoom : productAnalyticsData.businessUnitName || productAnalyticsData.category,
            productSalePrice: (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.discountPrice) ? productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.discountPrice : productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.unitPrice,
            productSaleable: productAnalyticsData.productSaleable,
            productStatus: ProductIsRetail ? "retail exclusive" : productAnalyticsData.availability,
            productSuperSku: productAnalyticsData.superSku ? true : false,
            productSkuOption: isCollapsedPDP,
            productTileName: productAnalyticsData.name || "n/a",
            quantity: productAnalyticsData.quantity || "n/a",
            defaultImageName: productAnalyticsData.image || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: isBundleProduct ? "bundle" : (0,helper/* pdpTypeFormat */.V4r)({
                businessUnitName,
                ProductIsRetail,
                discontinuedProductb,
                ProductRequiredAccessoriesGroupsList,
                superSku
            }),
            productFindingMethod: "n/a",
            productCollectionsName: isBundleProduct ? productAnalyticsData.bundleItemsCollections : productAnalyticsData.productCollectionsName || productAnalyticsData.category || "n/a",
            productBrand: productAnalyticsData.brandName,
            globalOffer: productAnalyticsData.discountName || "n/a",
            globalDiscount: (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.globalDiscount) ? Number((productAnalyticsData.unitPrice - ((productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.discountPrice) || (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : productAnalyticsData.unitPrice))).toFixed(2)) : 0,
            itemType: (0,helper/* getCartItemType */.Nth)(productAnalyticsData.category, productAnalyticsData.businessUnitName),
            category: isBundleProduct ? productAnalyticsData.bundleItemsCategories : productAnalyticsData.lcategory || productAnalyticsData.businessUnitName || "n/a",
            waterSenseProduct: waterSenseProductVal,
            bundleIds: productAnalyticsData.bundleIds ? productAnalyticsData.bundleIds : "n/a",
            bundleProductColors: productAnalyticsData.bundleProductColors ? productAnalyticsData.bundleProductColors : "n/a",
            productImageGallery: false
        };
        if (updatedPageInfo) {
            window.productInfo = JSON.stringify(productInfo);
            window.pageObj.productInfo = {
                ...productInfo
            };
            dispatch((0,genericSlice/* setPageObject */.FE)(true));
        }
        disableEcommerce ? productAnalyticsData.stringProductInfo = JSON.stringify({
            productInfo
        }) : productAnalyticsData.stringProductInfo = JSON.stringify({
            page: {
                cart: {
                    cartID: cart === null || cart === void 0 ? void 0 : cart.id
                }
            },
            productInfo
        });
        return {
            productAnalyticsData,
            productInfo
        };
    };
    const addCartCallback = (entries)=>{
        var ref;
        const [entry] = entries;
        const currentValue = !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && (entry === null || entry === void 0 ? void 0 : (ref = entry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.y) < 0;
        if (currentValue !== previousSticky.current) {
            previousSticky.current = currentValue;
            setShowStickyHeader(currentValue);
        }
    };
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    };
    (0,react.useEffect)(()=>{
        if (installReq.length > 0) {
            (0,productDetailsHelper/* getRequireItems */.yS)(installReq, discountedPrice, price, ()=>setInstallReq(installReq), (subtotal)=>setSubTotal(subtotal), (priceList)=>setPriceList(priceList), (cartItem)=>addItemsToCart(cartItem, false));
        }
    }, [
        sku
    ]);
    (0,react.useEffect)(()=>{
        const data = {
            pageLoadAnalyticsTimer: null,
            getProcessedProductInfo,
            productLocalCategory,
            imagesData,
            isShowAnalyticsEventLoaded: helper/* isShowAnalyticsEventLoaded */.xJ2,
            getUserAnalyticsObject: helper/* getUserAnalyticsObject */.L7i,
            setProductInfo,
            productImagesWithUrls: (productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData["productImages.labelWithUrl_ss"]) || ""
        };
        if (window.pageObj && loadShowEvent && window.datalayerTopLoaded && window.adobeDataLayer.length > 0) {
            (0,analytics_analytics/* addPageLoadAnalytics */.nM)(data);
        } else {
            data.pageLoadAnalyticsTimer = setInterval(()=>{
                (0,analytics_analytics/* addPageLoadAnalytics */.nM)(data);
            }, 500);
        }
        return ()=>{
            setProductInfo(null);
            delete window.productInfo;
            clearInterval(data.pageLoadAnalyticsTimer);
        };
    }, [
        loadShowEvent,
        isPriceChecked
    ]);
    (0,react.useEffect)(()=>{
        if (clickedProductVariant) {
            // add a click event as use has selected differenct product color/variant
            removeVariantSelection();
            if (!isLoadTargetRequired) {
                const productInfoObj = getProcessedProductInfo();
                const productInfo = productInfoObj.productInfo;
                const page = window.pageObj || {};
                const eventInfo = (0,analytics/* getEventInfo */.wQ)("color selection", true);
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productInfo
                });
            } else {
                window.initDataLayerTop();
                setIsLoadTargetRequired(false);
            }
            setProductInfo(productAnalyticsData.stringProductInfo);
        }
    }, [
        clickedProductVariant
    ]);
    (0,react.useEffect)(()=>{
        const fetchRequiredItems = async ()=>{
            let query = "";
            let lwQuery = "";
            requiredItems.forEach((item, i)=>{
                query = query + '"'.concat(item, '"').concat(i !== requiredItems.length - 1 ? "," : "");
                lwQuery += '"'.concat(item, '" ');
            });
            dispatch((0,pdpSlice/* fetchPdpRequiredItems */.Zp)(query)).unwrap().then((response)=>{
                setInstallReqData(response);
                dispatch((0,pdpSlice/* getReqItemLwData */.gP)({
                    lwQuery,
                    brandName,
                    lwAppName
                })).unwrap().then((lwData)=>setReqItemLwData(lwData !== null && lwData !== void 0 ? lwData : []));
            }).catch((err)=>{
                console.error("Fetching data failed", err);
            });
        };
        if ((requiredItems === null || requiredItems === void 0 ? void 0 : requiredItems.length) > 0 && showPDPInstallModal && installReqData.length === 0) {
            fetchRequiredItems();
        }
    }, [
        requiredItems,
        showPDPInstallModal,
        installReqData
    ]);
    (0,react.useEffect)(()=>{
        if (width > 1023) {
            const observer = new IntersectionObserver(addCartCallback, options);
            if (addCartContainer === null || addCartContainer === void 0 ? void 0 : addCartContainer.current) observer.observe(addCartContainer.current);
            return ()=>{
                if (addCartContainer === null || addCartContainer === void 0 ? void 0 : addCartContainer.current) observer.observe(addCartContainer.current);
            };
        }
    }, [
        addCartContainer,
        options
    ]);
    const onModalClose = ()=>{
        setShowPDPInstallModal(false);
        (0,helper/* preventBodyScroll */.MVu)(false);
    };
    const onInstallCTA = ()=>{
        setShowPDPInstallModal(true);
        (0,helper/* preventBodyScroll */.MVu)(true);
    };
    const handleInfoToolTipHover = (e)=>{
        e.stopPropagation();
        setShowTooltip(true);
        const { productInfo ={}  } = getProcessedProductInfo();
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = (0,analytics/* getEventInfo */.wQ)(staticTexts.toolTip.toLowerCase(), true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const handleRemove = (i)=>{
        const priceListItems = [];
        let requiredItemsPrice = 0;
        let priceLists = 0;
        let baseTotal = 0;
        let subTotalItem = 0;
        let curValue = installReq;
        curValue = installReq.filter((f)=>f.skuid !== i.skuid);
        setInstallReq(curValue);
        const cartItemProduct = [];
        if (curValue.length > 0) {
            curValue && curValue.map((currentItem)=>{
                const product = {};
                product.sku = currentItem.skuid;
                const checkQuantity = get_default()(currentItem.colorsData.find((requiredItem)=>requiredItem.id === currentItem.skuid), "isOutOfStock", false);
                product.quantity = !checkQuantity ? 1 : 0;
                if (!checkQuantity) {
                    cartItemProduct.push(product);
                }
                if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.priceData) {
                    priceLists = get_default()(currentItem.priceData.find((requiredList)=>requiredList.id === currentItem.skuid), "discountedPrice", 0) > 0 ? get_default()(currentItem.priceData.find((requiredList)=>requiredList.id === currentItem.skuid), "discountedPrice", 0) : get_default()(currentItem.priceData.find((requiredList)=>requiredList.id === currentItem.skuid), "price", 0);
                    priceListItems.push(priceLists);
                    if (priceListItems.length >= 0) {
                        requiredItemsPrice = priceListItems.reduce((acc, currentItem)=>{
                            return parseFloat(acc) + parseFloat(currentItem);
                        }, 0);
                    } else {
                        requiredItemsPrice = priceListItems[0];
                    }
                    baseTotal = discountedPrice > 0 ? discountedPrice : price;
                    subTotalItem = baseTotal + requiredItemsPrice;
                    setSubTotal(subTotalItem);
                    setPriceList(requiredItemsPrice);
                }
            });
            addItemsToCart(cartItemProduct, false);
        } else {
            addItemsToCart([], false);
        }
    };
    const comparedProductsCount = Number(get_default()(props, "comparedProductsCount", 0));
    const discontinuedColor = get_default()(colorsData.find((item)=>item.id === sku), "discontinuedColor", "");
    let isDiscontinued = false;
    let isColorDiscontinued = false;
    if (discontinuedProduct) {
        isDiscontinued = true;
        (0,pdpSlice/* getDiscontinuedProductValue */.B$)(isDiscontinued);
    } else if (discontinuedColor) {
        isDiscontinued = true;
        isColorDiscontinued = true;
        (0,pdpSlice/* getDiscontinuedProductValue */.B$)(isDiscontinued);
    }
    const handleNavChange = function(navActive) {
        let addToDatalayer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if ((navActive === 4 || addToDatalayer) && window.adobeDataLayer) {
            // adding a click even on Write a review button Requirement#47
            const { productAnalyticsData ={} , productInfo ={}  } = getProcessedProductInfo();
            const eventInfo = (0,analytics/* getEventInfo */.wQ)("write a review", true);
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo,
                page,
                productInfo
            });
            (0,helper/* closeModalAnalytics */.u8D)(productAnalyticsData.stringProductInfo);
        }
    };
    const handleQtyChange = (qty)=>{
        if (qty) {
            setCurrentQuantity(qty);
        }
    };
    const handleScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("buy-area", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    const handleSetPriceTooltip = (type, needsToSetState, tooltipContent)=>{
        if (needsToSetState) setPriceTooltip(true);
        if (!window.isHoverLoaded) {
            window.isHoverLoaded = true;
            const { productInfo ={}  } = getProcessedProductInfo();
            setTimeout(()=>{
                const { adobeDataLayer: { getState  } = {}  } = window;
                const page = getState && getState("page") || {};
                const eventInfo = (0,analytics/* getEventInfo */.wQ)(type, true, tooltipContent);
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productInfo
                });
                delete window.isHoverLoaded;
            }, 1400);
        }
    };
    const { productAnalyticsData ={} , productInfo ={}  } = getProcessedProductInfo();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_StickyHead, {
                setSticky: setSticky,
                sticky: sticky,
                isDiscontinued: isDiscontinued,
                showStickyHeader: showStickyHeader,
                stickyHeaderProps: stickyHeaderProps,
                discountedPrice: discountedPrice,
                price: price,
                staticTexts: staticTexts,
                onAddToCart: onAddToCart,
                isColorDiscontinued: isColorDiscontinued,
                addToCartProps: addToCartProps,
                productOnStock: productOnStock,
                sku: sku,
                customerFacingSKU: customerFacingSKU,
                isComboSku: isComboSku,
                handleScroll: handleScroll,
                onAvailableColor: onAvailableColor,
                isRegionSoldOnline: isRegionSoldOnline,
                productAnalyticsData: productAnalyticsData,
                customerBrandName: customerBrandName,
                replaceAddToCart: replaceAddToCart,
                disableRatings: disableRatings,
                replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                linkNewTab: linkNewTab,
                disableEcommerce: disableEcommerce,
                currencySign: currencySign,
                swatchUrl: swatchUrl,
                imagesData: imagesData,
                presetConfigObject: presetConfigObject,
                assetAccountName: assetAccountName,
                productPriceSpiderIncluded: ProductIsRetail
            }),
            viewLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressiveLoader_PdpProgressiveLoader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productDetailsView_module_default()).productDetailsV3Wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-detail-page",
                    role: "main",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_ProductBreadcrumb, {
                                staticTexts: staticTexts,
                                productCategory: productCategory,
                                name: name,
                                homePagePath: homePagePath,
                                plpServletPath: plpServletPath,
                                config: config,
                                productAnalyticsData: productAnalyticsData,
                                productData: productData,
                                swatchUrl: swatchUrl,
                                imagesData: imagesData,
                                width: width,
                                presetConfigObject: presetConfigObject,
                                isBundleProduct: isBundleProduct
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-overview print-overview",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-detail-page__image-gallery print-overview-left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-detail-page__left-sticky",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ImageGallery, {
                                                data: imagesData,
                                                imageClickCounter: imageClickCounter,
                                                updateImageClickCounter: updateImageClickCounter,
                                                productInfo: productAnalyticsData.stringProductInfo,
                                                page: "pdp",
                                                staticTexts: staticTexts,
                                                presetConfigObject: presetConfigObject,
                                                swatchUrl: swatchUrl,
                                                assetAccountName: scene7AccountName !== null && scene7AccountName !== void 0 ? scene7AccountName : "PAWEB",
                                                initialImgAlt: initialImgAlt,
                                                initialImgUrl: initialImgUrl,
                                                pdpDesktopImage: pdpDesktopImage,
                                                productImagesWithResourceTypes: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData["productImages.labelWithUrl_ss"],
                                                threeSixtyResourceData: threeSixtyResourceData,
                                                clickedProductVariant: clickedProductVariant
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-detail-page__content-section print-overview-right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_ProductDescription, {
                                            ref: {
                                                rightSectionRef,
                                                addCartContainer
                                            },
                                            badgeTxt: badgeTxt,
                                            isDiscontinued: isDiscontinued,
                                            isPersonaANY: isPersonaANY,
                                            productInfo: productInfo,
                                            priceTooltip: priceTooltip,
                                            handleSetPriceTooltip: handleSetPriceTooltip,
                                            setPriceTooltip: setPriceTooltip,
                                            installReq: installReq,
                                            productAnalyticsData: productAnalyticsData,
                                            onInstallCTA: onInstallCTA,
                                            toolTipIcon: tooltip/* default */.Z,
                                            handleInfoToolTipHover: handleInfoToolTipHover,
                                            setShowTooltip: setShowTooltip,
                                            showTooltip: showTooltip,
                                            isMobileOnly: isMobileOnly,
                                            handleRemove: handleRemove,
                                            priceList: priceList,
                                            subTotal: subTotal,
                                            getRequireItems: (items)=>(0,productDetailsHelper/* getRequireItems */.yS)(items, discountedPrice, price, ()=>setInstallReq(items), (subtotal)=>setSubTotal(subtotal), (priceList)=>setPriceList(priceList), (cartItem)=>addItemsToCart(cartItem, false)),
                                            installReqData: installReqData,
                                            reqItemLwData: reqItemLwData,
                                            onModalClose: onModalClose,
                                            showPDPInstallModal: showPDPInstallModal,
                                            onQtyChange: handleQtyChange,
                                            comparedProductsCount: comparedProductsCount,
                                            isColorDiscontinued: isColorDiscontinued,
                                            handleNavChange: handleNavChange,
                                            disableEcommerce: disableEcommerce,
                                            savedListLineItems: savedListLineItems,
                                            ...props
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v3_ProductDetailView = (ProductDetailView);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/PDPLoader/index.jsx
/* provided dependency */ var PDPLoader_process = __webpack_require__(83454);





const Loader = (props)=>{
    const { pdpData: productInfo , skuId , pdpJson , initialImgAlt , initialImgUrl  } = props;
    const { RegionBrandName_s: pdpBrnadName = "" , ProductDescriptionProductShort_s: pdpShotDesc = "" , masterCustomerFacingSKU_s: productID = "" , ProductLocalCategory_s: productCategory = "" , masterSKU_s: masterSku = "" , "priceList.ANY.finalPrice_d": anyFinalPrice = "" , "priceList.GST.finalPrice_d": gstFinalPrice = ""  } = productInfo;
    const { pdpDesktopImage  } = pdpJson;
    const [initImage] = (0,react.useState)(pdpDesktopImage && initialImgUrl ? pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")) : "");
    const [initImageAlt] = (0,react.useState)(initialImgAlt);
    const categoryTmp = (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory);
    const category = categoryTmp === null || categoryTmp === void 0 ? void 0 : categoryTmp.split(" ").map((a)=>{
        return a.charAt(0).toUpperCase() + (a === null || a === void 0 ? void 0 : a.slice(1));
    }).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-detail-page min-vh-100",
        "data-testid": "product-detail-page",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-section kf-react-plp-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-detail-page__breadcrumb",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                "aria-label": "Breadcrumb",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                    role: "list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            role: "listitem",
                                            children: " Home / "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            role: "listitem",
                                            children: category ? category : "Parts"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            role: "listitem",
                                            className: "adaopacity",
                                            children: [
                                                " ",
                                                " / ",
                                                category ? pdpBrnadName : "Parts"
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-detail-page__print-share-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                role: "list",
                                className: "print-and-share",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            tabIndex: "0",
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": "",
                                            "data-gbh-data-layer-custom": "",
                                            "aria-label": "Click here to print ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTdweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTcgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UHJpbnQtSWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iUHJpbnQiIGZpbGw9IiM3NTc1NzUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNCwwIEwxNCw0IEwxNyw0IEwxNywxMiBMMTQsMTIgTDE0LDE3IEwzLDE3IEwzLDEyIEwwLDEyIEwwLDQgTDMsNCBMMywwIEwxNCwwIFogTTEzLDEyIEw0LDEyIEw0LDE2IEwxMywxNiBMMTMsMTIgWiBNMyw1IEwxLDUgTDEsMTEgTDE2LDExIEwxNiw1IEwxNCw1IEwxNCw4IEwzLDggTDMsNSBaIE0xMywxIEw0LDEgTDQsNyBMMTMsNyBMMTMsMSBaIiBpZD0iUHJpbnQtSWNvbiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+",
                                                alt: "",
                                                role: "presentation",
                                                width: "20",
                                                height: "20"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            tabIndex: "0",
                                            "aria-label": "Click here to share ",
                                            className: "share-button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTQgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+c2hhcmU8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InNoYXJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC42MjAzNzIpIiBmaWxsPSIjNzU3NTc1IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNMy41LDYuODc5NjI4MyBMMy41LDcuODc5NjI4MyBMMSw3Ljg3OTYyODMgTDEsMTQuODc5NjI4MyBMMTMsMTQuODc5NjI4MyBMMTMsNy44Nzk2MjgzIEwxMC41LDcuODc5NjI4MyBMMTAuNSw2Ljg3OTYyODMgTDE0LDYuODc5NjI4MyBMMTQsMTUuODc5NjI4MyBMMCwxNS44Nzk2MjgzIEwwLDYuODc5NjI4MyBMMy41LDYuODc5NjI4MyBaIE03LC04Ljg4MTc4NDJlLTE2IEw3LjQ0MiwwLjM3OSBMNy41LDAuMzc5NjI4MzAxIEw3LjUsMC40MjgwMDAwMDEgTDEwLjgyNTM5NTcsMy4yNzg5MTA1OSBMMTAuMTc0NjA0Myw0LjAzODE2NzE5IEw3LjUsMS43NDYgTDcuNSwxMS4zNzk2MjgzIEw2LjUsMTEuMzc5NjI4MyBMNi41LDEuNzQ2IEwzLjgyNTM5NTY5LDQuMDM4MTY3MTkgTDMuMTc0NjA0MzEsMy4yNzg5MTA1OSBMNi41LDAuNDI4MDAwMDAxIEw2LjUsMC4zNzk2MjgzMDEgTDYuNTU4LDAuMzc5IEw3LC04Ljg4MTc4NDJlLTE2IFoiIGlkPSJDb21iaW5lZC1TaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+",
                                                alt: "",
                                                role: "presentation",
                                                width: "20",
                                                height: "20"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-overview print-overview",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-detail-page__image-gallery print-overview-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-reel row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pdp-image-reel__image-stack-view",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "pl-0 list-inline pdp-image-reel__image-stack-list",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "pdp-image-reel__image-list",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pdp-image-reel__image-display",
                                                    children: initImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        role: "button",
                                                        src: initImage,
                                                        alt: initImageAlt,
                                                        tabIndex: "0",
                                                        className: "print"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer height-400"
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-detail-page__content-section print-overview-right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row no-gutters product-detail-page__main",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-detail-page__price-value",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer width-170"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "product-detail-page__title-desc",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-detail-page__title",
                                                        children: pdpBrnadName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "product-detail-page__description",
                                                        children: pdpShotDesc
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "product-detail-page__sku-id",
                                                children: [
                                                    " ",
                                                    productID
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row no-gutters product-detail-page__price-main",
                                    children: [
                                        !(pdpJson === null || pdpJson === void 0 ? void 0 : pdpJson.disableEcommerce) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-12 product-detail-page__price",
                                            children: masterSku === skuId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-detail-page__price-value",
                                                tabIndex: "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: PDPLoader_process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true" ? anyFinalPrice : gstFinalPrice,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: constants["default"].CURRENCY_SIGN,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer width-170"
                                                })
                                            })
                                        }) : null,
                                        masterSku !== skuId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-12 product-detail-page__discount",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer"
                                                })
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-detail-page__list-price--associate",
                                            children: masterSku === skuId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-detail-page__list-view",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-detail-page__list-value",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: anyFinalPrice,
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: constants["default"].CURRENCY_SIGN,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-detail-page__list-text",
                                                        children: "List"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer width-170"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row no-gutters product-detail-page__finish-sample",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-12 product-detail-page__finish",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-detail-page__finish_value",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__para shimmer width-170"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row no-gutters product-detail-page__color-swatch-main",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 product-detail-page__color-swatch",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "color-swatch",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-swatch",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "color-swatch",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-swatch",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "color-swatch",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-swatch",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-detail-page__narrative-description",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para shimmer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para shimmer"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var PDPLoader = (Loader);

// EXTERNAL MODULE: ./utils/ApiUtil.js
var ApiUtil = __webpack_require__(51666);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetail.jsx































const ProductDetail = (props)=>{
    var ref;
    const { data: authorData = {} , pdpData: pdpDataServer = {} , slug: slugProp = "" , skuId ="" , initialImgAlt ="" , initialImgUrl =""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { stateListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { cart , cart: { id: cartLoaded = ""  } = {}  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [pdpData, setPdpData] = (0,react.useState)(pdpDataServer);
    const [slug, setSlug] = (0,react.useState)(slugProp);
    const { comparedProducts , category: productCategory  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const blankState = (0,utils/* getDefaultStateData */.FP)(pdpData);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { saveToListLineItems  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [state, setState] = (0,react.useState)({});
    const [isParts, setIsParts] = (0,react.useState)(false);
    const [config, setConfig] = (0,react.useState)({});
    const [superSku, setSuperSku] = (0,react.useState)("");
    const [brandNameDisplay, setBrandNameDisplay] = (0,react.useState)("");
    const [collapseBrandNameDisplay, setCollapseBrandNameDisplay] = (0,react.useState)(null);
    const [availableColorFirstSku, setAvailableColorFirstSku] = (0,react.useState)("");
    const [productServices, setProductServices] = (0,react.useState)("");
    const [pdprops, setPdprops] = (0,react.useState)({});
    const [comboSku, setComboSku] = (0,react.useState)([]);
    const [regionSoldOnline, setRegionSoldOnline] = (0,react.useState)([]);
    const [imagesData, setImagesData] = (0,react.useState)([]);
    const [videoIds, setVideoIds] = (0,react.useState)([]);
    const [pricesData, setPricesData] = (0,react.useState)([]);
    const [listPrices, setListPrices] = (0,react.useState)([]);
    const [discountedPrices, setDiscountedPrices] = (0,react.useState)([]);
    const [discountPercent, setDiscountPercent] = (0,react.useState)([]);
    const [isType, setIsType] = (0,react.useState)([]);
    const [badgesProps, setBadgesProps] = (0,react.useState)([]);
    const [excludedStates, setExcludedStates] = (0,react.useState)([]);
    const [presetConfigObject, setPresetConfigObject] = (0,react.useState)({});
    const [partReplacementSuggestions, setPartReplacementSuggestions] = (0,react.useState)([]);
    const [replaceAddToCartCtaLink, setReplaceAddToCartCtaLink] = (0,react.useState)("");
    const [isPdpPropsLoaded, setIsPdpPropsLoaded] = (0,react.useState)(false);
    const [isLoadTargetRequired, setIsLoadTargetRequired] = (0,react.useState)(false);
    const [isPriceChecked, setIsPriceChecked] = (0,react.useState)(false);
    const [colorSKUDetailss, setColorSKUDetailss] = (0,react.useState)();
    const { RegionBrandName_s: pdpBrnadName = "" , productName_s: productNameInit = ""  } = pdpData;
    const { general ={} , internationalization: { locale ="" , currencySign ="" , currencyCode =""  } = {} , apiEndpoints: { reverseGeo =""  } = {}  } = config;
    const { disableCommerce: disableEcommerce = false , siteName: brandName = "" , findProPagePath: findProPagePathUrl = "/" , findStorePagePath ="" , newBadgeName ="" , saleBadgeName ="" , exclusiveBadgeName ="" , discontinuedBadgeName ="" , lwAppName ="kohler"  } = general;
    const badgeText = {
        new: newBadgeName,
        onSale: saleBadgeName,
        exclusive: exclusiveBadgeName,
        discontinued: discontinuedBadgeName
    };
    const { persona ="" , selectedSku ="" , installationDataFromProp =[] , designServiceDataFromProp =[] , promoTitle ="" , imageClickCounter =0 , statesData ={} , findInstallerPath ="" , productDetailData ={} , variantData =[] , ctData ={} , loadShowEvent =false , clickedProductVariant =false , availableStock =0 , dimensionData ={}  } = state;
    const { id , productName_s: productNames = "" , RegionBrandName_s: regionBrandNames = "" , ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCate = ""  } = productDetailData;
    const category = productLocalCategory || productCate;
    const localCategory = productDetailData.category1_s;
    const { pdp: { data: { primaryBundleSKU_s: primaryBundleSKUs = "" , bundleSKUList_ss: bundleSKUList = []  } = {}  } = {} , requiredItemsSkuData ={}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const threeSixtyResourceDataState = {};
    if (requiredItemsSkuData === null || requiredItemsSkuData === void 0 ? void 0 : requiredItemsSkuData.data) {
        var ref1;
        const { data ={}  } = requiredItemsSkuData;
        if ((ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1["ItemResource.IMGSpinSet.resourceFullWebURL_ss"]) {
            var ref2, ref3, ref4, ref5;
            threeSixtyResourceDataState.resourceAltText = (ref2 = data[0]) === null || ref2 === void 0 ? void 0 : ref2["ItemResource.IMGSpinSet.resourceAltText_ss"];
            threeSixtyResourceDataState.resourceFullWebUrl = (ref3 = data[0]) === null || ref3 === void 0 ? void 0 : ref3["ItemResource.IMGSpinSet.resourceFullWebURL_ss"];
            threeSixtyResourceDataState.resourceName = (ref4 = data[0]) === null || ref4 === void 0 ? void 0 : ref4["ItemResource.IMGSpinSet.resourceName_ss"];
            threeSixtyResourceDataState.resourceTypeImg = (ref5 = data[0]) === null || ref5 === void 0 ? void 0 : ref5["ItemResource.IMGSpinSet.resourceType_ss"];
        }
    }
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const productName = isParts ? productNameInit : pdpBrnadName;
    const [name, setName] = (0,react.useState)(productName);
    const staticTexts = (0,usePdpi18n/* default */.Z)(authorData, badgeText, name);
    const findStoreUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(findStorePagePath, general);
    const findProPagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)(findProPagePathUrl, general);
    const getProductDetails = function(brandName, accessToken, slug) {
        let lwAppName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        if (brandName && accessToken && lwAppName) {
            try {
                const payload = {
                    slug,
                    isParts,
                    brandName,
                    selectedSku,
                    selectedColor,
                    setSkuVariantCb: (initSku)=>setSkuVariant(initSku),
                    getVariantFieldsCb: (skuList)=>{
                        const payload = {
                            skuList,
                            slug,
                            isParts,
                            brandName,
                            lwAppName
                        };
                        dispatch((0,pdpSlice/* getVariantFields */.ww)(payload)).unwrap().then((res)=>{
                            if (res) {
                                const varData = get_default()(res, "response.docs", []);
                                setState((prevState)=>{
                                    return {
                                        ...prevState,
                                        variantData: varData
                                    };
                                });
                            }
                        });
                    },
                    lwAppName
                };
                // Get product data from LucidWorks
                dispatch((0,pdpSlice/* searchPdp */.zF)(payload)).unwrap().then((res)=>{
                    if (res) {
                        const { productData ={} , sku ="" , fusionQueryId ="" , customerFacingSKU ="" , dimensionData ={} , threeSixtyResourceDataState ={}  } = res;
                        setProductServices(get_default()(productData, "ProductServices_ss", ""));
                        // get product options
                        if (productData["ProductIsRetail"] !== "true" && productData["Product_Category"]) {
                            setSuperSku(productData["Super_Sku"]);
                            var ref;
                            setBrandNameDisplay((ref = productData["ProductBrandNameDisplay_s"]) !== null && ref !== void 0 ? ref : "");
                            // adding new filter in get options.
                            if (productData["Collapse_Field_s"]) {
                                setCollapseBrandNameDisplay(productData["Collapse_Field_s"]);
                            } else {
                                setCollapseBrandNameDisplay(null);
                            }
                        }
                        setPdpData(productData);
                        setState((prevState)=>{
                            return {
                                ...prevState,
                                productDetailData: productData,
                                selectedSku: sku,
                                customerFacingSKU,
                                masterSku: get_default()(productData, "masterSKU_s", ""),
                                fusionQueryId,
                                viewLoader: false,
                                dimensionData,
                                threeSixtyResourceDataState
                            };
                        });
                        window.addEventListener("popstate", ()=>{
                            fetchSkuFromUrl();
                        });
                        setState((prevState)=>{
                            return {
                                ...prevState,
                                viewLoader: false
                            };
                        });
                    } else {
                        console.error("Error occured while fetching product data");
                    }
                });
            // Get product data from CommerceTools
            } catch (error) {
                console.error(error);
            }
            if (authorData) {
                const { promoConfigTitle ="" , promoConfigDesc ="" , enablePromo ="" , installServices =[] , designServices =[] , findAnInstaller , installerArea , mboxIdList =[] , jsonFilePath =""  } = authorData;
                setState((prevState)=>{
                    return {
                        ...prevState,
                        promoTitle: promoConfigTitle,
                        promoDescription: promoConfigDesc,
                        enablePromo,
                        installationDataFromProp: installServices,
                        designServiceDataFromProp: designServices,
                        jsonFileUrl: jsonFilePath,
                        findInstallerPath: findAnInstaller,
                        installerArea,
                        mboxes: mboxIdList
                    };
                });
            } else {
                // Get product data from CommerceTools
                dispatch((0,pdpSlice/* getProductBySlug */.Co)({
                    slug
                })).unwrap().then((product)=>{
                    if (product.id) setState((prevState)=>{
                        return {
                            ...prevState,
                            ctData: product
                        };
                    });
                });
            }
        }
    };
    const updateImageClickCounter = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                imageClickCounter: imageClickCounter + 1
            };
        });
    };
    const setSkuVariant = (sku)=>{
        sku && setState((prevState)=>{
            return {
                ...prevState,
                selectedSku: sku,
                isProductVariantClicked: true,
                clickedProductVariant: false
            };
        });
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        const skuNumber = searchParams.get("skuNumber");
        skuNumber ? searchParams.set("skuNumber", sku) : searchParams.set("skuId", sku);
        // Check is URL sku present in the variants if available keep Search paremeters else remove
        const query = (colorSKUDetailss === null || colorSKUDetailss === void 0 ? void 0 : colorSKUDetailss.some((color)=>color.includes(sku))) ? "?" + searchParams.toString() : "";
        window.history.replaceState(window.location.pathname, document.title, query);
        dispatch((0,pdpSlice/* setPDP */.qK)({
            sku
        }));
    };
    const addRequiredItems = (list)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                reqCartData: list
            };
        });
    };
    const addToCart = function(items) {
        let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        const callbackFun = function() {
            let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const { res: { lineItems =[]  } = {}  } = data;
            if (lineItems.length > 0) {
                if (!isEmpty_default()(authorData)) {
                    try {
                        const { hapticFeedbackTimer =0  } = authorData;
                        window.navigator.vibrate(Number(hapticFeedbackTimer));
                    } catch (err) {
                        cb();
                    }
                }
            }
            cb();
        };
        (0,shareCartHelper/* shareaddToCart */.J9)([
            ...items,
            ...state.reqCartData
        ], "", (obj)=>{
            dispatch((0,genericSlice/* showPreviewCart */.z0)());
            callbackFun(obj);
        });
    };
    const fetchSkuFromUrl = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                selectedSku: skuId ? skuId : state.selectedSku
            };
        });
    };
    // Get list of available options to be shown under Select More Options
    const getOptions = async (selectedColor)=>{
        var ref;
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        var ref2;
        const { data  } = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "Super_Sku",
                q: "*:*",
                fq: [
                    "".concat(collapseBrandNameDisplay ? "Collapse_Field_s" : "ProductBrandNameDisplay_s", ':("').concat((ref2 = (0,helper/* replaceAndFunction */._Gn)(collapseBrandNameDisplay)) !== null && ref2 !== void 0 ? ref2 : (0,helper/* replaceAndFunction */._Gn)(brandNameDisplay), '")'),
                    'ProductLocalCategory_s:("'.concat((0,helper/* replaceAndFunction */._Gn)(category), '")'),
                    '-(productRegionAllVariantDiscontinued_b:("true") OR RegionDiscontinuedDate_dt:%7B* TO NOW%7D)',
                    '-ProductIsRetail:("true")',
                    '-ATTR_SPEC_TankLocks_s:("Yes")',
                    '-SKUIsProjectPack_s:"Yes"',
                    'language_s:("'.concat(language, '")'),
                    selectedColor && "Color.Finish:(".concat(selectedColor, ")")
                ],
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                collections: lwAppName.toLowerCase(),
                sessionId: (0,ApiUtil/* getSessionIdObjWithEpoc */.oq)()
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        const { fusion: { facet_labels: facetLabels = [] , Color_data: colorData = {}  } = {} , facet_counts: { facet_fields: facets  } = {} , response: { docs: variantOptions = []  } = {}  } = data;
        const colorDetails = (0,productDetailsHelper/* getColorFinishData */.Jo)(colorData);
        setColorSKUDetailss(colorDetails);
        var ref3;
        const currOptions = (ref3 = variantOptions.find((e)=>e.sku_s === selectedSku)) !== null && ref3 !== void 0 ? ref3 : {};
        const { slug_s: currSlug = ""  } = currOptions;
        if (currSlug) {
            const pdpUrl = await (0,helper/* getPDPUrl */.ir5)(category, currSlug);
            const queryString = window.location.href.split("?")[1];
            const selectedParam = selectedSku ? "skuId=".concat(selectedSku) : "";
            let param = (queryString === null || queryString === void 0 ? void 0 : queryString.split("&")) || "";
            if (!param.includes(selectedParam)) {
                param = "skuId=".concat(selectedSku);
            }
            const redirectUrl = (0,utils_0/* getPdpRedirectUrl */.Om)(pdpUrl, Array.isArray(param) ? param.join("&") : param);
            setSlug(currSlug);
            router.push(redirectUrl, null, {
                shallow: true
            });
        }
        if (facets) {
            // TODO: GBH-12117 - Make this facets configurable | Delete unwanted facets
            delete facets["New_Products"];
            delete facets["Available_Now"];
            delete facets["Product_Family"];
            delete facets["Product_Category"];
            delete facets["Color"];
            delete facets["Finish"];
            delete facets["Color.Finish"];
            setState((prevState)=>{
                return {
                    ...prevState,
                    options: facets,
                    currOptions,
                    facetLabels,
                    variantOptions
                };
            });
        }
        const payload = {
            brandName
        };
        dispatch((0,pdpSlice/* getPdpTooltip */.n_)(payload)).unwrap().then((res)=>{
            const tooltipData = res !== null && res !== void 0 ? res : {};
            setState((prevState)=>{
                return {
                    ...prevState,
                    selectMoreTooltipData: tooltipData
                };
            });
        });
    };
    // Search for product variant based on selected option and redirect to that PDP
    const selectOption = async function() {
        let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", facet = arguments.length > 1 ? arguments[1] : void 0;
        var ref;
        setIsLoadTargetRequired(true);
        const { options , currOptions: currStateOptions  } = state;
        let slug = "";
        let skuIdMaster = "";
        let bq = "";
        Object.entries(options).map((f)=>{
            if (f[0] !== facet && currStateOptions[f[0]]) {
                bq = bq + "".concat(f[0], ':"').concat(currStateOptions[f[0]], '"^50 ');
            }
        });
        if (bq) {
            bq = "(".concat(bq.trim(), ")");
        }
        const { selectedColor =""  } = pdprops;
        const color = selectedColor.trim();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        var ref2;
        const { data  } = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "Super_Sku, slug_s,masterSKU_s",
                q: "*:*",
                fq: [
                    "".concat(collapseBrandNameDisplay ? "Collapse_Field_s" : "ProductBrandNameDisplay_s", ':("').concat((ref2 = (0,helper/* replaceAndFunction */._Gn)(collapseBrandNameDisplay)) !== null && ref2 !== void 0 ? ref2 : (0,helper/* replaceAndFunction */._Gn)(brandNameDisplay), '")'),
                    "".concat(facet, ':("').concat(value.replace(/"/g, '\\"'), '")'),
                    'ProductLocalCategory_s:("'.concat((0,helper/* replaceAndFunction */._Gn)(category), '")'),
                    '-(productRegionAllVariantDiscontinued_b:("true") OR RegionDiscontinuedDate_dt:%7B* TO NOW%7D)',
                    '-ProductIsRetail:("true")',
                    '-ATTR_SPEC_TankLocks_s:("Yes")',
                    '-SKUIsProjectPack_s:"Yes"',
                    'language_s:("'.concat(language, '")'),
                    color && "Color.Finish:(".concat(color, ")")
                ],
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                collections: lwAppName.toLowerCase(),
                sessionId: (0,ApiUtil/* getSessionIdObjWithEpoc */.oq)(),
                ...bq ? {
                    bq
                } : {}
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        const { fusion: { facet_labels: facetLabels = [] , Color_data: colorData = {}  } = {} , facet_counts: { facet_fields: facets  } = {} , response: { docs: variantOptions = []  } = {}  } = data;
        const colorDetails = (0,productDetailsHelper/* getColorFinishData */.Jo)(colorData);
        setColorSKUDetailss(colorDetails);
        var ref3;
        const currOptions = (ref3 = variantOptions.find((e)=>e.sku_s === selectedSku)) !== null && ref3 !== void 0 ? ref3 : {};
        setState((prevState)=>{
            return {
                ...prevState,
                options: facets,
                currOptions,
                facetLabels,
                variantOptions
            };
        });
        const groupedSlug = get_default()(data, "grouped.Product_Family.groups[0].doclist.docs[0].slug_s", "");
        slug = groupedSlug ? groupedSlug : get_default()(data, "response.docs[0].slug_s", "");
        skuIdMaster = get_default()(data, "response.docs[0].masterSKU_s", "");
        if (slug) {
            const pdpUrl = await (0,helper/* getPDPUrl */.ir5)(category, slug);
            const param = skuIdMaster ? "skuId=".concat(skuIdMaster) : "";
            const redirectUrl = (0,utils_0/* getPdpRedirectUrl */.Om)(pdpUrl, param);
            dispatch((0,pdpSlice/* getProductBySlug */.Co)({
                slug
            })).unwrap().then((product)=>{
                if (product.id) {
                    setState((prevState)=>{
                        return {
                            ...prevState,
                            ctData: product
                        };
                    });
                    getProductDetails(brandName, accessToken, slug, lwAppName);
                }
            });
            setSlug(slug);
            router.push(redirectUrl, null, {
                shallow: true
            });
        }
    };
    const seeAvailableColor = ()=>{
        setSkuVariant(availableColorFirstSku);
        dispatch((0,pdpSlice/* getDiscontinuedProductValue */.B$)(""));
    };
    const getZipCode = (userZipCode, handleZipCodeAvailabilityCallBack)=>{
        (0,productDetailsHelper/* checkUserZipCode */.Ec)({
            userZipCode,
            state,
            callBack: handleZipCodeAvailabilityCallBack
        });
    };
    const getAvailableStock = async (sku)=>{
        let stock;
        try {
            stock = await (0,utils_cart/* getStock */.K5)(sku);
        } catch (err) {
            console.error("Error | getStock | getAvailablesStock | ProductDetails | ", err);
        }
        setState((prevState)=>{
            return {
                ...prevState,
                availableStock: stock !== null && stock !== void 0 ? stock : 0,
                loadShowEvent: true,
                clickedProductVariant: state.isProductVariantClicked
            };
        });
    };
    const getServiceData = async ()=>{
        let designServiceSkus = [];
        let installationServiceSkus = [];
        if (!isEmpty_default()(designServiceDataFromProp)) {
            designServiceSkus = designServiceDataFromProp.map((product)=>{
                if (product.sku) {
                    return product.sku;
                }
            });
        }
        if (!isEmpty_default()(installationDataFromProp)) {
            installationServiceSkus = installationDataFromProp.map((list)=>{
                if (list.sku) {
                    return list.sku;
                }
            });
        }
        if (designServiceSkus.length === 0 && installationServiceSkus.length === 0) return;
        const payload = {
            slug,
            skus: [
                ...designServiceSkus,
                ...installationServiceSkus,
                ...isBundleProduct ? [
                    ...bundleSKUList,
                    selectedSku
                ] : []
            ]
        };
        dispatch((0,pdpSlice/* getProductBySlugAndSku */.bF)(payload)).unwrap().then(function() {
            let products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            var ref, ref1, ref2, ref3;
            const installationServices = products.filter((product)=>{
                var ref;
                return installationServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
            });
            const designServices = products.filter((product)=>{
                var ref;
                return designServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
            });
            var ref4;
            const ctData = (ref4 = products.filter((product)=>{
                var ref, ref1;
                return !installationServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku) && !designServiceSkus.includes(product === null || product === void 0 ? void 0 : (ref1 = product.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.sku);
            })) !== null && ref4 !== void 0 ? ref4 : [];
            var ref5, ref6;
            const masterVarientSkuId = isBundleProduct ? (ref5 = ctData === null || ctData === void 0 ? void 0 : (ref = ctData.masterVariant) === null || ref === void 0 ? void 0 : ref.sku) !== null && ref5 !== void 0 ? ref5 : "" : (ref6 = ctData === null || ctData === void 0 ? void 0 : (ref1 = ctData[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.masterVariant) === null || ref2 === void 0 ? void 0 : ref2.sku) !== null && ref6 !== void 0 ? ref6 : "";
            const url = new URL(window.location.href);
            var ref7;
            const skuId = (ref7 = (ref3 = url.searchParams) === null || ref3 === void 0 ? void 0 : ref3.get("skuId")) !== null && ref7 !== void 0 ? ref7 : masterVarientSkuId;
            var ref8;
            const currentSkuData = (ref8 = ctData.find((e)=>{
                const findData = e.variants.find((el)=>{
                    return el.sku === skuId;
                });
                if (findData || e.masterVariant.sku === skuId) return e;
            })) !== null && ref8 !== void 0 ? ref8 : {};
            setState((prevState)=>{
                return {
                    ...prevState,
                    designServiceData: designServices,
                    installationData: installationServices,
                    ctData: currentSkuData,
                    projectionData: products
                };
            });
            if (installationServices.length > 0) {
                getUserLocation();
            }
        });
    };
    const getUserLocation = ()=>{
        (0,helper/* getLocationByCookies */.ngN)().then((getLocation)=>{
            var _zipcode;
            const userZipCode = (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "";
            (0,productDetailsHelper/* checkUserZipCode */.Ec)({
                userZipCode,
                state
            });
        });
    };
    const removeVariantSelection = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                clickedProductVariant: false,
                isProductVariantClicked: false
            };
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (res)=>{
            var ref;
            setConfig(res);
            const servicePartPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(res, "general.servicePartsLandingPath"));
            const isPartsPath = location && (location === null || location === void 0 ? void 0 : (ref = location.href) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(servicePartPath));
            setIsParts(isPartsPath);
        });
        setState(blankState);
    }, []);
    (0,react.useEffect)(()=>{
        let pdpPropsLoadedTimer;
        if (!isEmpty_default()(pdprops)) {
            pdpPropsLoadedTimer = setTimeout(()=>{
                setIsPdpPropsLoaded(true);
            }, 1000);
        }
        return ()=>{
            if (pdpPropsLoadedTimer) {
                clearTimeout(pdpPropsLoadedTimer);
            }
        };
    }, [
        pdprops
    ]);
    (0,react.useEffect)(()=>{
        getServiceData();
        setSuperSku("");
        setBrandNameDisplay("");
        setCollapseBrandNameDisplay(null);
        setAvailableColorFirstSku("");
        setProductServices("");
        setComboSku([]);
        setRegionSoldOnline([]);
        setImagesData([]);
        setVideoIds([]);
        setPricesData([]);
        setListPrices([]);
        setDiscountedPrices([]);
        setDiscountPercent([]);
        setIsType([]);
        setBadgesProps([]);
        setExcludedStates([]);
        setPartReplacementSuggestions([]);
    }, [
        slug
    ]);
    (0,react.useEffect)(()=>{
        if (primaryBundleSKUs) getServiceData();
    }, [
        primaryBundleSKUs
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken) {
            const persona = (0,helper/* getUserPersona */.shu)();
            setState((prevState)=>{
                return {
                    ...prevState,
                    persona
                };
            });
        }
    }, [
        accessToken,
        slug
    ]);
    (0,react.useEffect)(()=>{
        if (disableEcommerce) {
            setState((prevState)=>{
                return {
                    ...prevState,
                    persona: ""
                };
            });
        }
    }, [
        disableEcommerce
    ]);
    (0,react.useEffect)(()=>{
        if (!stateListPath) {
            dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        } else {
            dispatch((0,genericSlice/* getstateList */.lK)()).unwrap().then((res)=>setState((prevState)=>{
                    return {
                        ...prevState,
                        statesData: res
                    };
                }));
        }
    }, [
        stateListPath
    ]);
    (0,react.useEffect)(()=>{
        const url = new URL(window.location.href);
        if (skuId && !url.searchParams.get("skuNumber")) {
            setState((prevState)=>{
                return {
                    ...prevState,
                    selectedSku: skuId
                };
            });
        }
    }, [
        skuId
    ]);
    (0,react.useEffect)(()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                reverseGeo: reverseGeo
            };
        });
    }, [
        reverseGeo
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(authorData) && !isEmpty_default()(general)) {
            setReplaceAddToCartCtaLink((0,helper/* getShortenedUrlwithGeneral */.vu1)(authorData === null || authorData === void 0 ? void 0 : authorData.replaceAddToCartCtaLink, general));
            const { presetConfigs ="{}"  } = authorData !== null && authorData !== void 0 ? authorData : {
                presetConfigs: "{}"
            };
            const presetConfigObject = JSON.parse(presetConfigs);
            setPresetConfigObject(presetConfigObject);
        }
    }, [
        authorData,
        general
    ]);
    (0,react.useEffect)(()=>{
        getProductDetails(brandName, accessToken, slug, lwAppName);
    }, [
        brandName,
        accessToken,
        slug,
        lwAppName
    ]);
    (0,react.useEffect)(()=>{
        if (promoTitle !== null) {
            getServiceData();
            (0,productDetailsHelper/* getZipCodeJsonFile */.O1)(state.jsonFileUrl, (data)=>{
                const { zipcode =[]  } = data;
                setState((prevState)=>{
                    return {
                        ...prevState,
                        zipCodeData: zipcode
                    };
                });
            });
        }
    }, [
        promoTitle
    ]);
    (0,react.useEffect)(()=>{
        const name = isParts ? productNames : regionBrandNames;
        setName(name);
    }, [
        productNames,
        regionBrandNames
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(productDetailData)) {
            var ref;
            let imagesData = [];
            let videoIds = [];
            const pricesData = [];
            const listPrices = [];
            let colorsData = [];
            let variants = [];
            let colors = [];
            const comboSku = [];
            const discountedPrices = [];
            const discountPercent = [];
            let requiredItemstoInstall = [];
            const availableColors = [];
            const disContinuedColors = [];
            const customerSkus = [];
            const isType = [];
            const regionSoldOnline = [];
            const partReplacementSuggestions = [];
            let isRegionSoldOnline = false;
            // get list of variants
            if (productDetailData["variantList.sku_ss"]) {
                variants = productDetailData["variantList.sku_ss"];
            }
            var ref1;
            // get list of variant colors
            const colorDetailsss = colorSKUDetailss ? colorSKUDetailss : (ref1 = productDetailData["Color.SKU.Details_ss"]) !== null && ref1 !== void 0 ? ref1 : [];
            if (colorDetailsss) {
                colors = colorDetailsss.map((color)=>{
                    const d = color.split("|");
                    return (0,productDetailsHelper/* getColorDataObject */.WI)(d);
                });
            }
            // get required items to install
            const accessoryGroups = productDetailData["ProductRequiredAccessoryGroup_s"];
            const accessoryGroupss = productDetailData["ProductRequiredAccessoryGroup_ss"];
            if (!disableEcommerce || (0,helper/* isCanadaSite */.guj)(brandName)) {
                if (accessoryGroups) {
                    requiredItemstoInstall = [
                        accessoryGroups
                    ];
                } else if (accessoryGroupss) {
                    requiredItemstoInstall = accessoryGroupss;
                }
            }
            // get Youtube Url's
            const productYoutubeIDs = productDetailData["ProductYoutubeID_s"];
            if (productYoutubeIDs) {
                videoIds = productYoutubeIDs.split("|").map((v)=>({
                        type: "video",
                        url: v
                    }));
                setVideoIds(videoIds);
            }
            if (cart.lineItems && cart.lineItems.length) {
                cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
                    var ref;
                    if ((ref = product.price) === null || ref === void 0 ? void 0 : ref.discounted) {
                        var ref1, ref2;
                        discountedPrices[product.variant.sku] = Number((product.price.discounted.value.centAmount / 100).toFixed(2));
                        setDiscountedPrices(discountedPrices);
                        let percentOff;
                        if (((ref2 = (ref1 = product.price) === null || ref1 === void 0 ? void 0 : ref1.discounted.discount.obj.value) === null || ref2 === void 0 ? void 0 : ref2.type) === "absolute") {
                            percentOff = get_default()(product.price, "discounted.discount.obj.value.money[0].centAmount", 0);
                            isType[product.variant.sku] = "absolute";
                            setIsType(isType);
                        } else {
                            percentOff = get_default()(product.price, "discounted.discount.obj.value.permyriad", 0);
                            isType[product.variant.sku] = "relative";
                            setIsType(isType);
                        }
                        discountPercent[product.variant.sku] = percentOff > 0 ? Number(percentOff / 100) : 0;
                        setDiscountPercent(discountPercent);
                    }
                });
            }
            // get data related to each color variant
            colors.forEach((color)=>{
                const colorObj = {
                    id: color.sku,
                    name: "product-color",
                    value: color.sku,
                    label: color.name,
                    notApplicable: color.swatch.toLowerCase() === constants.SWATCH_NA.toLowerCase(),
                    colorUrl: constants["default"].COLOR_FILE_URL + color.swatch,
                    checked: color.sku === state.selectedSku ? true : false,
                    discontinuedColor: color.discontinued
                };
                color.discontinued ? disContinuedColors.push(colorObj) : availableColors.push(colorObj);
                customerSkus[color.sku] = color.customerSku;
            });
            const isDisContinuedColor = (ref = colors.find((color)=>color.sku === state.selectedSku)) === null || ref === void 0 ? void 0 : ref.discontinued;
            colorsData = isDisContinuedColor ? disContinuedColors : availableColors;
            var _id;
            if (availableColors && availableColors[0]) setAvailableColorFirstSku((_id = availableColors[0].id) !== null && _id !== void 0 ? _id : "");
            const variantImages = productDetailData["productImages.labelWithUrl_ss"] ? productDetailData["productImages.labelWithUrl_ss"] : [];
            let variantImageLabels = [];
            let variantImageURLs = [];
            if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
                const selVarImageUrls = [];
                const selVarImageLabels = [];
                variantImages.map((img)=>{
                    const imgDetail = img.split("|");
                    if (state.selectedSku === imgDetail[0]) {
                        var ref;
                        selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                        selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    } else if (!variants.find((v)=>v === imgDetail[0])) {
                        var ref1;
                        variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                        variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    }
                });
                variantImageLabels = [
                    ...selVarImageLabels,
                    ...variantImageLabels
                ];
                variantImageURLs = [
                    ...selVarImageUrls,
                    ...variantImageURLs
                ];
                if (variantImageURLs.length < 1) {
                    variantImageLabels.push(state.selectedSku);
                    variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                }
            } else {
                variantImageLabels.push(state.selectedSku);
                variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
            }
            imagesData = (0,utils/* getFormatedImages */.$)({
                variantImageLabels,
                variantImageURLs,
                authorData
            });
            setImagesData(imagesData);
            for(let i = 0; i < variants.length; i++){
                var ref2;
                const variantSku = variants[i];
                if ((ref2 = state.ctData) === null || ref2 === void 0 ? void 0 : ref2.masterVariant) {
                    var ref3, ref4, ref5, ref6, ref7;
                    let product = {};
                    if (variantSku === state.ctData.masterVariant.sku) {
                        product = state.ctData.masterVariant;
                    } else {
                        product = state.ctData.variants.find((variant)=>variantSku === variant.sku);
                    }
                    // Get variant prices from CT data
                    const fixedPromo = product === null || product === void 0 ? void 0 : (ref3 = product.prices) === null || ref3 === void 0 ? void 0 : ref3.find((price)=>{
                        var ref, ref1, ref2, ref3, ref4;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona && ((ref3 = price.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.fixedPrice);
                    });
                    const productPrice = product === null || product === void 0 ? void 0 : (ref4 = product.prices) === null || ref4 === void 0 ? void 0 : ref4.find((price)=>{
                        var ref, ref1, ref2;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                    });
                    let priceObj = fixedPromo ? fixedPromo : productPrice;
                    if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) {
                        var ref8;
                        priceObj = product === null || product === void 0 ? void 0 : (ref8 = product.prices) === null || ref8 === void 0 ? void 0 : ref8.find((price)=>{
                            var ref;
                            return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                        });
                    }
                    var ref9;
                    pricesData[variantSku] = Number((((ref9 = priceObj === null || priceObj === void 0 ? void 0 : (ref5 = priceObj.value) === null || ref5 === void 0 ? void 0 : ref5.centAmount) !== null && ref9 !== void 0 ? ref9 : 0) / 100).toFixed(2));
                    setPricesData(pricesData);
                    if (discountedPrices[variantSku] === 0 || !discountedPrices[variantSku]) {
                        var ref10, ref11, ref12, ref13, ref14;
                        var ref15;
                        discountedPrices[variantSku] = Number((((ref15 = priceObj === null || priceObj === void 0 ? void 0 : (ref10 = priceObj.discounted) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.value) === null || ref11 === void 0 ? void 0 : ref11.centAmount) !== null && ref15 !== void 0 ? ref15 : 0) / 100).toFixed(2));
                        setDiscountedPrices(discountedPrices);
                        if ((priceObj === null || priceObj === void 0 ? void 0 : (ref12 = priceObj.discounted) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.discount) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.obj) === null || ref14 === void 0 ? void 0 : ref14.value.type) === "absolute") {
                            var ref16, ref17, ref18, ref19, ref20;
                            var ref21;
                            discountPercent[variantSku] = Number(((ref21 = (ref20 = priceObj === null || priceObj === void 0 ? void 0 : (ref16 = priceObj.discounted) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.discount) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.obj) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.value) === null || ref19 === void 0 ? void 0 : ref19.money[0]) === null || ref20 === void 0 ? void 0 : ref20.centAmount) !== null && ref21 !== void 0 ? ref21 : 0) / 100);
                            setDiscountPercent(discountPercent);
                            isType[variantSku] = "absolute";
                            setIsType(isType);
                        } else {
                            var ref22, ref23, ref24, ref25;
                            var ref26;
                            discountPercent[variantSku] = Number(((ref26 = priceObj === null || priceObj === void 0 ? void 0 : (ref22 = priceObj.discounted) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.discount) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.obj) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.value) === null || ref25 === void 0 ? void 0 : ref25.permyriad) !== null && ref26 !== void 0 ? ref26 : 0) / 100);
                            setDiscountPercent(discountPercent);
                            isType[variantSku] = "relative";
                            setIsType(isType);
                        }
                    }
                    // price-checking done for product(price & discounted price)
                    setIsPriceChecked(true);
                    const listPrice = product === null || product === void 0 ? void 0 : (ref6 = product.prices) === null || ref6 === void 0 ? void 0 : ref6.find((price)=>{
                        var ref;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                    });
                    var ref27;
                    listPrices[variantSku] = Number((((ref27 = listPrice === null || listPrice === void 0 ? void 0 : (ref7 = listPrice.value) === null || ref7 === void 0 ? void 0 : ref7.centAmount) !== null && ref27 !== void 0 ? ref27 : 0) / 100).toFixed(2));
                    setListPrices(listPrices);
                    // Check if variant is a Combo SKU
                    comboSku[variantSku] = (product === null || product === void 0 ? void 0 : product.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
                    setComboSku(comboSku);
                    // Check if RegionSoldOnline
                    const isOnline = get_default()(product === null || product === void 0 ? void 0 : product.attributes.find((attr)=>attr.name === "RegionSoldOnline"), "value", "");
                    regionSoldOnline[variantSku] = isOnline;
                    isRegionSoldOnline = !isOnline;
                    setRegionSoldOnline(regionSoldOnline);
                    // Check if Service Part have replacement suggestion
                    if (authorData.ctRecommendations) {
                        if (0 in authorData.ctRecommendations) {
                            partReplacementSuggestions[variantSku] = get_default()(product === null || product === void 0 ? void 0 : product.attributes.find((attr)=>attr.name === authorData.ctRecommendations[0].fieldname), "value", "");
                            setPartReplacementSuggestions(partReplacementSuggestions);
                        }
                    }
                }
            }
            const selectedColor = get_default()(colorsData.find((item)=>item.id === state.selectedSku), "label", "");
            if (!loadShowEvent) return;
            const pdpPayload = {
                state,
                customerSkus,
                selectedColor,
                isParts,
                currencySign,
                requiredItemstoInstall,
                colorsData,
                comparedProducts,
                disableEcommerce,
                favorites,
                superSku,
                cartLoaded,
                cart,
                pricesData,
                locale,
                discountedPrices
            };
            const pdprops = (0,utils/* getPdpProps */.xU)(pdpPayload);
            if (pdprops.ProductPriceSpiderIncluded_s || isDisContinuedColor || isRegionSoldOnline) {
                if (pdprops.ProductPriceSpiderIncluded_s) {
                    pdprops.productPartnerBuyNow = true;
                }
                if (!skuId.startsWith("BNDL") && !isBundleProduct) {
                    pdprops.productSaleable = false;
                }
            }
            setPdprops(pdprops);
            const excludedStates = get_default()(state.variantData.find((item)=>item.sku_s === state.selectedSku), "RegionStatesExcluded_ss", []);
            setExcludedStates(excludedStates);
            // Get badge values for product
            const shipmentDate = get_default()(state.productDetailData, "RegionReleaseforShipment_dt", "");
            const exclusiveBadge = (0,utils_0/* parseToBoolean */.DD)(get_default()(state.productDetailData, "ProductIsExclusive_s", ""));
            const badgesProps = {
                isNewProduct: (0,helper/* showNewBadge */.ZTk)(shipmentDate),
                badgeVal: get_default()(state.productDetailData, "priceList.".concat(persona, ".saleOffer_s"), ""),
                exclusiveBadge
            };
            setBadgesProps(badgesProps);
            const { presetConfigs ="{}"  } = authorData !== null && authorData !== void 0 ? authorData : {
                presetConfigs: "{}"
            };
            const presetConfigObject = JSON.parse(presetConfigs);
            setPresetConfigObject(presetConfigObject);
        }
    }, [
        productDetailData,
        selectedSku,
        persona,
        variantData,
        ctData,
        loadShowEvent,
        clickedProductVariant,
        availableStock,
        favorites,
        colorSKUDetailss
    ]);
    (0,react.useEffect)(()=>{
        if (selectedSku) {
            getAvailableStock(selectedSku);
            dispatch((0,pdpSlice/* setPDP */.qK)({
                sku: selectedSku
            }));
        }
    }, [
        selectedSku
    ]);
    const { selectedColor =""  } = pdprops;
    (0,react.useEffect)(()=>{
        const color = selectedColor.trim();
        if ((collapseBrandNameDisplay || brandNameDisplay) && category && brandName && state.productDetailData && state.productDetailData["ProductPriceSpiderIncluded_s"] !== "true" && state.productDetailData["Product_Category"] && state.productDetailData["isCollapsedPDP_b"] && color) {
            getOptions(color);
        }
    }, [
        selectedColor,
        collapseBrandNameDisplay,
        brandNameDisplay,
        category,
        brandName,
        state.productDetailData
    ]);
    (0,react.useEffect)(()=>{
        setSlug(slugProp);
    }, [
        slugProp
    ]);
    const allVariants = ctData === null || ctData === void 0 ? void 0 : (ref = ctData.variants) === null || ref === void 0 ? void 0 : ref.concat(ctData.masterVariant);
    const { attributes: currentSkuAttributes = []  } = (allVariants === null || allVariants === void 0 ? void 0 : allVariants.find((variant)=>variant.sku === state.selectedSku)) || {};
    const { value: isBackorderable = false  } = (currentSkuAttributes === null || currentSkuAttributes === void 0 ? void 0 : currentSkuAttributes.find((attr)=>attr.name === "RegionIsBackorderable")) || {};
    const { value: leadTime = 0  } = (currentSkuAttributes === null || currentSkuAttributes === void 0 ? void 0 : currentSkuAttributes.find((attr)=>attr.name === "RegionLeadTime")) || {};
    const addToCartProps = {
        ...pdprops.addToCartProps,
        backOrder: isBackorderable ? "Yes" : "No",
        leadTime,
        availableStock,
        isBackorderable
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        var ref3;
        const hashedId = (ref3 = (ref2 = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : ref1.split("#")) === null || ref2 === void 0 ? void 0 : ref2[1]) !== null && ref3 !== void 0 ? ref3 : "";
        const timeout = setTimeout(()=>{
            const element = document.getElementById(hashedId);
            if (hashedId && element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest"
                });
            }
        }, 5000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    if (!isEmpty_default()(state.productDetailData) && !state.viewLoader && (pdprops.name || pdprops.desc)) {
        var _selectedSku, _selectedSku1, _replaceAddToCartCtaLabel;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductDetailView, {
            ...pdprops,
            ...state,
            addToCartProps: addToCartProps,
            customerFacingSKU: pdprops.customerFacingSKU,
            curroptions: state.currOptions,
            imagesData: [
                ...imagesData,
                ...videoIds
            ],
            isPdpPropsLoaded: isPdpPropsLoaded,
            staticTexts: staticTexts,
            productCategory: category,
            productLCategory: localCategory,
            productServices: productServices,
            isComboSku: comboSku[selectedSku],
            isRegionSoldOnline: disableEcommerce ? false : regionSoldOnline[selectedSku],
            price: pricesData[selectedSku],
            listPrice: listPrices[selectedSku],
            discountedPrice: (_selectedSku = discountedPrices[selectedSku]) !== null && _selectedSku !== void 0 ? _selectedSku : 0,
            discountPercent: (_selectedSku1 = discountPercent[selectedSku]) !== null && _selectedSku1 !== void 0 ? _selectedSku1 : 0,
            isType: isType[selectedSku],
            setSkuVariant: setSkuVariant,
            selectoption: selectOption,
            getStock: ()=>(0,utils_cart/* getStock */.K5)(selectedSku),
            onAddToCart: addToCart,
            setIsLoadTargetRequired: setIsLoadTargetRequired,
            isLoadTargetRequired: isLoadTargetRequired,
            onAddToCompare: ()=>{
                return (0,product/* addToCompareProduct */.dX)(selectedSku, addToCartProps === null || addToCartProps === void 0 ? void 0 : addToCartProps.backOrder);
            },
            onRemoveFromCompare: ()=>(0,product/* removeFromCompareProduct */.Zj)(selectedSku),
            checkProductCategory: ()=>(0,productDetailsHelper/* checkProductCategory */.tz)(productCategory, category),
            comparedProductsCount: comparedProducts.length,
            isParts: isParts,
            findProPagePath: findProPagePath,
            addItemsToCart: addRequiredItems,
            showToaster: utils/* showToaster */.gI,
            onAvailableColor: seeAvailableColor,
            cart: cart,
            getZipCode: getZipCode,
            findStoreUrl: findStoreUrl,
            badgesProps: badgesProps,
            findInstallerPath: (0,helper/* getShortenedUrlwithGeneral */.vu1)(findInstallerPath, general),
            removeVariantSelection: removeVariantSelection,
            excludedState: (0,productDetailsHelper/* getShippingLocations */.lk)(statesData, excludedStates),
            pdpJson: authorData,
            presetConfigObject: presetConfigObject,
            setProductInfo: (data)=>dispatch((0,pdpSlice/* setProductInfo */.CC)(data)),
            partReplacementSuggestions: partReplacementSuggestions[selectedSku],
            updateImageClickCounter: updateImageClickCounter,
            productData: productDetailData,
            replaceAddToCart: Boolean(authorData.replaceAddToCart),
            disableRatings: Boolean(authorData.disableRatings),
            replaceAddToCartCtaLink: replaceAddToCartCtaLink !== null && replaceAddToCartCtaLink !== void 0 ? replaceAddToCartCtaLink : findStoreUrl,
            linkNewTab: Boolean(authorData.linkNewTab),
            replaceAddToCartCtaLabel: (_replaceAddToCartCtaLabel = authorData.replaceAddToCartCtaLabel) !== null && _replaceAddToCartCtaLabel !== void 0 ? _replaceAddToCartCtaLabel : t("kf.global.label.findStore"),
            docId: id,
            config: config,
            initialImgAlt: initialImgAlt,
            initialImgUrl: initialImgUrl,
            waterSenseProduct: pdpData["ProductWaterSense_ss"] || [],
            isInstock: pdpData["productIsInStock_b"] || false,
            brandName: brandName,
            isPriceChecked: isPriceChecked,
            dimensionData: dimensionData,
            threeSixtyResourceData: threeSixtyResourceDataState,
            savedListLineItems: saveToListLineItems
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PDPLoader, {
        pdpJson: authorData,
        pdpData: pdpData,
        skuId: skuId,
        initialImgAlt: initialImgAlt,
        initialImgUrl: initialImgUrl
    });
};
/* harmony default export */ var v3_ProductDetail = (ProductDetail);

// EXTERNAL MODULE: ./components/PairsWellWith/PairsWellWith.jsx + 1 modules
var PairsWellWith = __webpack_require__(32046);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
;// CONCATENATED MODULE: ./components/Review/v1/analytics.js

const addFirstReviewAnalyticsEvent = (productInfo)=>{
    setTimeout(()=>{
        const actualFirstReviewButton = document.getElementById("first-to-write");
        if (!window.isFirstReviewEventLoaded && actualFirstReviewButton && productInfo) {
            // this means review contents are loaded
            actualFirstReviewButton.addEventListener("click", ()=>clickEvent("be the first to review this product", productInfo));
            window.isFirstReviewEventLoaded = true;
        } else if (!window.isFirstReviewEventLoaded && (!window.reiterate || window.reiterate < 10)) {
            var _reiterate;
            window.reiterate = ((_reiterate = window.reiterate) !== null && _reiterate !== void 0 ? _reiterate : 0) + 1;
            addFirstReviewAnalyticsEvent(productInfo);
        }
    }, 2000);
};
const addWriteReviewAnalyticsEvent = (productInfo)=>{
    setTimeout(()=>{
        const actualWriteReviewButtons = document.getElementsByClassName("bv-write-review");
        if (!window.isWriteReviewEventLoaded && (actualWriteReviewButtons === null || actualWriteReviewButtons === void 0 ? void 0 : actualWriteReviewButtons.length) && productInfo) {
            const actualWriteReviewButton = actualWriteReviewButtons[0];
            // this means review contents are loaded
            actualWriteReviewButton.addEventListener("click", ()=>clickEvent("write a review", productInfo));
            window.isWriteReviewEventLoaded = true;
        } else if (!window.isWriteReviewEventLoaded && (!window.reiterate1 || window.reiterate1 < 10)) {
            var _reiterate1;
            window.reiterate1 = ((_reiterate1 = window.reiterate1) !== null && _reiterate1 !== void 0 ? _reiterate1 : 0) + 1;
            addWriteReviewAnalyticsEvent(productInfo);
        }
    }, 2000);
};
const clickEvent = (type, productInfo)=>{
    const eventInfo = v1_analytics_getEventInfo(type);
    const productInfoA = productInfo ? JSON.parse(productInfo).productInfo : null;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo: productInfoA
    });
    (0,helper/* closeModalAnalytics */.u8D)(productInfo);
};
const v1_analytics_getEventInfo = (type)=>{
    return {
        eventAction: "pdp:customer reviews:" + type,
        eventName: "pdp:customer reviews:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:navigation",
        internalLinkZoneName: "pdp:customer reviews",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
};

;// CONCATENATED MODULE: ./components/Review/v1/Review.view.jsx



const ReviewDetail = (props)=>{
    const { productInfo ={} , bazaarVoiceProductId =""  } = props;
    const reviewContainer = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        // we need to use javascript to fetch dom element as it's a third party script getting loaded(BazaarVoice) here and we don't have control over dom.
        if ((!window.isFirstReviewEventLoaded || !window.isWriteReviewEventLoaded) && bazaarVoiceProductId && productInfo && reviewContainer.current) {
            addFirstReviewAnalyticsEvent(productInfo);
            addWriteReviewAnalyticsEvent(productInfo);
        }
        return ()=>{
            delete window.isFirstReviewEventLoaded;
            delete window.isWriteReviewEventLoaded;
            delete window.reiterate1;
            delete window.reiterate;
            delete window.checker;
            delete window.modalCloseEventLoaded;
        };
    }, [
        productInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "review",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "kf-react-plp-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-0 mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "review-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-bv-show": "reviews",
                        "data-bv-product-id": bazaarVoiceProductId,
                        ref: reviewContainer
                    })
                })
            })
        })
    });
};
ReviewDetail.defaultProps = {
    bazaarVoiceProductId: "",
    productInfo: {}
};
/* harmony default export */ var Review_view = (ReviewDetail);

;// CONCATENATED MODULE: ./components/Review/v1/Review.jsx





const Review = (props)=>{
    const { pdp: { sku ="" , variants =[]  } , productInfo ={}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    var ref;
    const variant = (ref = variants.find((v)=>v.sku === sku)) !== null && ref !== void 0 ? ref : {};
    return sku && (variant === null || variant === void 0 ? void 0 : variant.discontinued) && productInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Review_view, {
        bazaarVoiceProductId: sku,
        productInfo: productInfo
    });
};
/* harmony default export */ var v1_Review = (Review);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductLandingTeasers/ProductExf.jsx





const ProductExf = ()=>{
    const { teaserContent =[]  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    return teaserContent.length ? teaserContent.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "exfpdp",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "xfpage",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                    data: item,
                    count: 0
                })
            })
        }, "".concat(item["title"], "-").concat(index))) : null;
};
/* harmony default export */ var ProductLandingTeasers_ProductExf = (ProductExf);

// EXTERNAL MODULE: ./components/core/Head/NextHead.jsx
var NextHead = __webpack_require__(20812);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/PDPCuratedProducts/index.jsx
var PDPCuratedProducts = __webpack_require__(25762);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./pages/products/pdp.jsx



























/**
 * renders ProductDetailsPage page
 * @return {JSX.Element}
 */ function ProductDetailsPage(param) {
    let { tmpData: data = {} , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , slug , tmpSkuId: skuId , type , pdpData , apiStatus: status , apiStatusText: statusText , initialImgAlt , initialImgUrl , initialImageFullUrl , fullUrl , isPart , siteName , metaContent , seoProperties: { email ="" , phoneNum =""  } = {} , variantImages  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { isTeaserLoaded  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const [config, setConfig] = (0,react.useState)({});
    const [priceSpiderKey, setPriceSpiderKey] = (0,react.useState)("");
    const [priceSpiderLanguage, setPriceSpiderLanguage] = (0,react.useState)("");
    const [priceSpiderCountry, setPriceSpiderCountry] = (0,react.useState)("");
    const { primaryBundleSKU_s: primaryBundleSKUs = ""  } = pdpData;
    const isBundleProduct = Boolean(primaryBundleSKUs);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>setConfig(config));
        scrollToTop();
        const { ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCategory = "" , CustomerFacingSKU_s: skuID = "" , CustomerFacingBrand_s: siteName = ""  } = pdpData;
        window.needPdpdata = {
            productSubCatergory: (productLocalCategory === null || productLocalCategory === void 0 ? void 0 : productLocalCategory.toLowerCase()) || (productCategory === null || productCategory === void 0 ? void 0 : productCategory.toLowerCase()),
            skuID,
            siteName: siteName.toLowerCase()
        };
        if (gbhDataLayerCustom) dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
    }, []);
    (0,react.useEffect)(()=>{
        window.adobeTarget = window.adobeTarget || {};
        window.adobeTarget.pdp = {
            variantImages: variantImages
        };
    }, [
        variantImages
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const psKey = get_default()(config, "general.priceSpiderKey", "");
            if (psKey) {
                setPriceSpiderKey(psKey);
            }
            const psLanguage = get_default()(config, "internationalization.language", "");
            if (psLanguage) {
                setPriceSpiderLanguage(psLanguage);
            }
            const psCountry = get_default()(config, "internationalization.country", "");
            if (psCountry) {
                setPriceSpiderCountry(psCountry);
            }
        }
    }, [
        config
    ]);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (analyticsData) (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper/* removeAndCleanLink */.xEh)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
            (0,productDetailsHelper/* getTeaserFragments */.lX)(data, pdpData);
        }
    }, [
        accessToken,
        pdpData,
        pageIsInteractive,
        isTeaserLoaded
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const { language: metaLanguage = ""  } = data;
    const quickViewAuthData = (0,helper/* getQuickViewAuth */.sKe)(footer);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* default */.Z, {
                psKey: priceSpiderKey,
                psCountry: priceSpiderCountry,
                psLanguage: priceSpiderLanguage,
                fullUrl: fullUrl,
                metaLanguage: metaLanguage,
                pdpData: pdpData,
                isPart: isPart,
                initialImageFullUrl: initialImageFullUrl,
                skuId: skuId,
                siteName: siteName,
                isBundleProduct: isBundleProduct,
                persona: (0,helper/* getUserPersona */.shu)(),
                config: config
            }),
            header ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaTitle_s,
                description: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaDescription_s,
                templateName: data === null || data === void 0 ? void 0 : data.templateName,
                globalScripting: globalScript,
                isPdp: true,
                fullUrl: fullUrl,
                imageUrl: initialImageFullUrl,
                email: email,
                phone: phoneNum,
                siteName: siteName
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "zoomdatapdp",
                src: "".concat(SCENE7_JS_URL, "ZoomViewer.js")
            }, "zoomdatapdp"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "".concat(SCENE7_JS_URL, "SpinViewer.js")
            }),
            data && !isEmpty_default()(pdpData) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-vh-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                    data: data,
                    count: 0,
                    productDetail: (data, slug, skuId, type)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductDetail, {
                            data: data,
                            pdpData: pdpData,
                            slug: slug,
                            skuId: skuId,
                            type: type,
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl
                        }),
                    productDetailFiller: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PDPLoader, {
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl,
                            pdpJson: data,
                            pdpData: pdpData,
                            skuId: skuId
                        }),
                    pairsWellWith: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PairsWellWith/* default */.Z, {
                            data: data,
                            skuId: skuId
                        }),
                    productAccordion: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                            data: data
                        }),
                    review: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Review, {
                            data: data
                        }),
                    productExf: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLandingTeasers_ProductExf, {
                            data: data
                        }),
                    slug: slug,
                    skuId: skuId,
                    type: type,
                    pdpCuratedProduct: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PDPCuratedProducts/* default */.Z, {
                            authData: data,
                            slug: slug,
                            skuId: skuId,
                            quickViewAuthData: quickViewAuthData
                        })
                })
            }) : null,
            footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pdp = (ProductDetailsPage);


/***/ }),

/***/ 3220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Feature":"Feature_Feature__CNhsC"};

/***/ }),

/***/ 56152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundlesAccordianWrapper":"BundlesAccordian_BundlesAccordianWrapper__07Hsr"};

/***/ }),

/***/ 42083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundleHighlights":"BundlesHighlights_BundleHighlights__XUias"};

/***/ }),

/***/ 98185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addToCartWrapper":"AddToCart_addToCartWrapper__XoveX"};

/***/ }),

/***/ 29742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"designServicesWrapper":"DesignServices_designServicesWrapper__agYZ_"};

/***/ }),

/***/ 28416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"moreFromCollectionWrapper":"MoreFromCollection_moreFromCollectionWrapper__fEMBh"};

/***/ }),

/***/ 61184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpRequiredItemModalWrapper":"PDPRequiredItemModal_pdpRequiredItemModalWrapper__SYOuq"};

/***/ }),

/***/ 92555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productAccordionListWrapper":"ProductAccordionList_productAccordionListWrapper__xrgw8"};

/***/ }),

/***/ 52102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpcuratedproductmodule":"pdpCuratedProduct_pdpcuratedproductmodule__wUU6A"};

/***/ }),

/***/ 13175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Feedback":"Feedback_Feedback__1Fn0J"};

/***/ }),

/***/ 14427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productDetailsV3Wrapper":"productDetailsView_productDetailsV3Wrapper__IsX6B"};

/***/ }),

/***/ 2819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpStickyHeadWrapper":"StickyHeader_pdpStickyHeadWrapper__IJA5F"};

/***/ }),

/***/ 13642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"superSkuOption":"SuperSkuOption_superSkuOption__JcL6d","superSkuOptionSet":"SuperSkuOption_superSkuOptionSet__DacZx","superSkuOptionButton":"SuperSkuOption_superSkuOptionButton__09doW","activeBttn":"SuperSkuOption_activeBttn__lQPVM","disabledBttn":"SuperSkuOption_disabledBttn__AM8yJ"};

/***/ }),

/***/ 7187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoModalWrapper":"VideoWrapper_videoModalWrapper__BSa4h"};

/***/ }),

/***/ 96724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__vZrfq"};

/***/ }),

/***/ 85218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SlideDrawerBackdrop":"SlideDrawer_SlideDrawerBackdrop__19Qht","SlideDrawer":"SlideDrawer_SlideDrawer__zrZpB","Open":"SlideDrawer_Open__ox9xj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4482,3147,8787,9747,2046,9774,2888,179], function() { return __webpack_exec__(48033); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);